<template>
  <div>
    <div class="node-wrap" v-if="nodeConfig.type!=4">
      <div class="node-wrap-box" :class="(nodeConfig.type==0?'start-node ':'')+(isTried&&nodeConfig.error?'active error':'')">
        <div>
          <div class="title" :style="'background: rgb('+ ['87, 106, 149','255, 148, 62','50, 150, 250'][nodeConfig.type] +');'">
            <span class="iconfont" v-show="nodeConfig.type==1"></span>
            <span class="iconfont" v-show="nodeConfig.type==2"></span>
            <span v-if="nodeConfig.type==0">{{nodeConfig.nodeName}}</span>
            <input type="text" class="ant-input editable-title-input" v-if="nodeConfig.type!=0&&isInput" @blur="blurEvent()" @focus="$event.currentTarget.select()" v-focus v-model="nodeConfig.nodeName" :placeholder="placeholderList[nodeConfig.type]">
            <span class="editable-title" @click="clickEvent()" v-if="nodeConfig.type!=0&&!isInput">{{nodeConfig.nodeName}}</span>
            <i class="anticon anticon-close close" v-if="nodeConfig.type!=0" @click="delNode()"></i>
          </div>
          <div class="content" @click="setPerson">
            <div class="text" v-if="nodeConfig.type==0">{{arrToStr(flowPermission)?arrToStr(flowPermission):'所有人'}}</div>
            <div class="text" v-if="nodeConfig.type==1">
              <span class="placeholder" v-if="!setApproverStr(nodeConfig)">请选择{{placeholderList[nodeConfig.type]}}</span>
              {{setApproverStr(nodeConfig)}}
            </div>
            <div class="text" v-if="nodeConfig.type==2">
              <span class="placeholder" v-if="!copyerStr(nodeConfig)">请选择{{placeholderList[nodeConfig.type]}}</span>
              {{copyerStr(nodeConfig)}}
            </div>
            <i class="anticon anticon-right arrow"></i>
          </div>
          <div class="error_tip" v-if="isTried&&nodeConfig.error">
            <i class="anticon anticon-exclamation-circle" style="color: rgb(242, 86, 67);"></i>
          </div>
        </div>
      </div>
      <addNode :childNodeP.sync="nodeConfig.childNode"></addNode>
    </div>
    <div class="branch-wrap" v-if="nodeConfig.type==4">
      <div class="branch-box-wrap">
        <div class="branch-box">
          <button class="add-branch" @click="addTerm">添加条件</button>
          <div class="col-box" v-for="(item,index) in nodeConfig.conditionNodes" :key="index">
            <div class="condition-node">
              <div class="condition-node-box">
                <div class="auto-judge" :class="isTried&&item.error?'error active':''">
                  <div class="sort-left" v-if="index!=0" @click="arrTransfer(index,-1)">&lt;</div>
                  <div class="title-wrapper">
                    <input type="text" class="ant-input editable-title-input" v-if="isInputList[index]" @blur="blurEvent(index)" @focus="$event.currentTarget.select()" v-focus v-model="item.nodeName">
                    <span class="editable-title" @click="clickEvent(index)" v-if="!isInputList[index]">{{item.nodeName}}</span>
                    <span class="priority-title" @click="setPerson(item.priorityLevel)">优先级{{item.priorityLevel}}</span>
                    <i class="anticon anticon-close close" @click="delTerm(index)"></i>
                  </div>
                  <div class="sort-right" v-if="index!=nodeConfig.conditionNodes.length-1" @click="arrTransfer(index)">&gt;</div>
                  <div class="content" @click="setPerson(item.priorityLevel)">{{ conditionStr(item,index) }}</div>
                  <div class="error_tip" v-if="isTried&&item.error">
                    <i class="anticon anticon-exclamation-circle" style="color: rgb(242, 86, 67);"></i>
                  </div>
                </div>
                <addNode :childNodeP.sync="item.childNode"></addNode>
              </div>
            </div>
            <nodeWrap v-if="item.childNode && item.childNode" :nodeConfig.sync="item.childNode" :tableId="tableId" :isTried.sync="isTried" :directorMaxLevel="directorMaxLevel" :flowType="flowType"></nodeWrap>
            <div class="top-left-cover-line" v-if="index==0"></div>
            <div class="bottom-left-cover-line" v-if="index==0"></div>
            <div class="top-right-cover-line" v-if="index==nodeConfig.conditionNodes.length-1"></div>
            <div class="bottom-right-cover-line" v-if="index==nodeConfig.conditionNodes.length-1"></div>
          </div>
        </div>
        <addNode :childNodeP.sync="nodeConfig.childNode"></addNode>
      </div>
    </div>
    <el-drawer :append-to-body="true" title="发起人" :visible.sync="promoterDrawer" direction="rtl" class="set_promoter" size="550px" :before-close="savePromoter">
      <div class="demo-drawer__content">
        <div class="promoter_content drawer_content">
          <p>{{arrToStr(flowPermission1)?arrToStr(flowPermission1):'所有人'}}</p>
          <el-button type="primary" @click="addPromoter" size="mini" style="border-radius: 0px;color: #ffffff;">添加/修改发起人</el-button>
        </div>
        <div class="demo-drawer__footer clear">
          <el-button type="primary" @click="savePromoter" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          <el-button @click="promoterDrawer = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
        </div>
        <el-dialog title="选择成员" :visible.sync="promoterVisible" width="600px" append-to-body class="promoter_person">
          <div class="person_body clear">
            <div class="person_tree l" style="float: left;">
              <input type="text" placeholder="搜索成员" v-model="promoterSearchName" @input="getDebounceData($event)">
              <p class="ellipsis tree_nav" v-if="!promoterSearchName">
                <span @click="getDepartmentList(0)" class="ellipsis">天下</span>
                <span v-for="(item,index) in departments.titleDepartments" class="ellipsis" :key="index+'a'" @click="getDepartmentList(item.id)">{{item.departmentName}}</span>
              </p>
              <ul>
                <li v-for="(item,index) in departments.childDepartments" :key="index+'b'" class="check_box">
                  <a :class="toggleClass(checkedDepartmentList,item)&&'active'" @click="toChecked(checkedDepartmentList,item)">
                    <img src="@/assets/images/icon_file.png">{{item.departmentName}}</a>
                  <i @click="getDepartmentList(item.id)">下级</i>
                </li>
                <li v-for="(item,index) in departments.employees" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(checkedEmployessList,item)&&'active'" @click="toChecked(checkedEmployessList,item)" :title="item.departmentNames">
                    <img src="@/assets/images/icon_people.png">{{item.employeeName}}</a>
                </li>
              </ul>
            </div>
            <div class="has_selected l" style="float: right;">
              <p class="clear">已选（{{checkedDepartmentList.length+checkedEmployessList.length}}）
                <a @click="checkedDepartmentList=[];checkedEmployessList=[]">清空</a>
              </p>
              <ul>
                <li v-for="(item,index) in checkedDepartmentList" :key="index+'d'">
                  <img src="@/assets/images/icon_file.png">
                  <span>{{item.departmentName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(checkedDepartmentList,item)">
                </li>
                <li v-for="(item,index) in checkedEmployessList" :key="index+'e'">
                  <img src="@/assets/images/icon_people.png">
                  <span>{{item.employeeName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(checkedEmployessList,item)">
                </li>
              </ul>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="promoterVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="surePromoter" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-drawer>
    <el-drawer :append-to-body="true" title="审批人设置" :visible.sync="approverDrawer" direction="rtl" class="set_promoter" size="550px" :before-close="saveApprover">
      <div class="demo-drawer__content">
        <div class="drawer_content">
          <div class="approver_content">
            <el-radio-group v-model="approverConfig.settype" style="width: 100%;" class="clear" @change="changeType">
              <el-radio :label="1">指定成员</el-radio>
              <el-radio :label="2">主管</el-radio>
              <el-radio :label="3">角色</el-radio>
              <el-radio :label="8">分管领导</el-radio>
              <el-radio :label="9">指定部门负责人</el-radio>
              <el-radio :label="10">指定部门分管领导</el-radio>
              <el-radio :label="11">指定单据中的字段</el-radio>
              <!-- <el-radio :label="4">发起人自选</el-radio>
                            <el-radio :label="5">发起人自己</el-radio>
                            <el-radio :label="7">连续多级主管</el-radio> -->
            </el-radio-group>
            <el-button type="primary" @click="addApprover" v-if="approverConfig.settype==1" size="mini" style="color: #ffffff;border-radius: 0px;font-size: 14px;">添加/修改成员</el-button>
            <p class="selected_list" v-if="approverConfig.settype==1">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index" style="font-size: 14px;">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0" @click="approverConfig.nodeUserList=[]" style="font-size: 14px;">清除</a>
            </p>
          </div>
          <div class="approver_manager" v-if="approverConfig.settype==2">
            <p>
              <span>发起人的：</span>
              <select v-model="approverConfig.directorLevel">
                <option v-for="item in directorMaxLevel" :value="item" :key="item">{{item==1?'直接':'第'+item+'级'}}主管</option>
              </select>
            </p>
            <p class="tip">找不到主管时，由上级主管代审批</p>
          </div>
          <div class="approver_self_select" v-show="approverConfig.settype==3">
            <el-radio-group v-model="approverConfig.selectMode" style="width: 100%;" v-show="false">
              <el-radio :label="1">选一个人</el-radio>
              <el-radio :label="2">选多个人</el-radio>
            </el-radio-group>
            <h3 v-show="false">选择范围</h3>
            <el-radio-group v-model="approverConfig.selectRange" style="width: 100%;" @change="changeRange" v-show="false">
              <el-radio :label="1">全公司</el-radio>
              <el-radio :label="2">指定成员</el-radio>
              <el-radio :label="3">指定角色</el-radio>
            </el-radio-group>
            <el-button type="primary" @click="addApprover" v-if="approverConfig.selectRange==2" size="mini" style="color: #ffffff;border-radius: 0px;">添加/修改成员</el-button>
            <el-button type="primary" @click="addRoleApprover" v-if="approverConfig.selectRange==3" size="mini" style="border-radius: 0px;color: #ffffff">添加/修改角色</el-button>
            <p class="selected_list" v-if="approverConfig.selectRange==2||approverConfig.selectRange==3">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0&&approverConfig.selectRange!=1" @click="approverConfig.nodeUserList=[]">清除</a>
            </p>
          </div>
          <div class="approver_self" v-if="approverConfig.settype==5">
            <p>该审批节点设置“发起人自己”后，审批人默认为发起人</p>
          </div>
          <div class="approver_self_select" v-show="approverConfig.settype==4">
            <el-radio-group v-model="approverConfig.selectMode" style="width: 100%;">
              <el-radio :label="1">选一个人</el-radio>
              <el-radio :label="2">选多个人</el-radio>
            </el-radio-group>
            <h3>选择范围</h3>
            <el-radio-group v-model="approverConfig.selectRange" style="width: 100%;" @change="changeRange">
              <el-radio :label="1">全公司</el-radio>
              <el-radio :label="2">指定成员</el-radio>
              <el-radio :label="3">指定角色</el-radio>
            </el-radio-group>
            <el-button type="primary" @click="addApprover" v-if="approverConfig.selectRange==2" style="color: #ffffff;border-radius: 0px;" size="mini">添加/修改成员</el-button>
            <el-button type="primary" @click="addRoleApprover" size="mini" v-if="approverConfig.selectRange==3" style="color: #ffffff;border-radius: 0px;">添加/修改角色</el-button>
            <p class="selected_list" v-if="approverConfig.selectRange==2||approverConfig.selectRange==3">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0&&approverConfig.selectRange!=1" @click="approverConfig.nodeUserList=[]">清除</a>
            </p>
          </div>
          <div class="approver_manager" v-if="approverConfig.settype==7">
            <p>审批终点</p>
            <p style="padding-bottom:20px">
              <span>发起人的：</span>
              <select v-model="approverConfig.examineEndDirectorLevel">
                <option v-for="item in directorMaxLevel" :value="item" :key="item">{{item==1?'最高':'第'+item}}层级主管</option>
              </select>
            </p>
          </div>

          <div class="approver_manager" v-if="approverConfig.settype==8">
            <p>
              <span>发起人的：</span>
              <select v-model="approverConfig.leaderLevel">
                <option value="1">发起人部门的分管领导</option>
                <option value="2">发起人部门的2级分管领导</option>
                <option value="3">发起人部门的3级分管领导</option>
                <option value="4">发起人部门的4级分管领导</option>
              </select>
            </p>
          </div>

          <div class="approver_self_select" v-show="approverConfig.settype==9">
            <el-button type="primary" @click="addDeptApprover" size="mini" v-if="approverConfig.selectRange==4" style="color: #ffffff;border-radius: 0px;">添加/修改部门</el-button>
            <p class="selected_list" v-if="approverConfig.selectRange==4">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0&&approverConfig.selectRange==4" @click="approverConfig.nodeUserList=[]">清除</a>
            </p>

          </div>

          <div class="approver_self_select" v-if="approverConfig.settype==10">
            <el-button type="primary" @click="addDeptApprover" size="mini" v-if="approverConfig.selectRange==5" style="color: #ffffff;border-radius: 0px;">添加/修改部门</el-button>
            <p class="selected_list" v-if="approverConfig.selectRange==5">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0&&approverConfig.selectRange==5" @click="approverConfig.nodeUserList=[]">清除</a>
            </p>

          </div>
          <div class="approver_self_select" v-if="approverConfig.settype==11">
            <el-button type="primary" @click="addTableApprover" size="mini" style="color: #ffffff;border-radius: 0px;">选择单据中的字段</el-button>
            <p class="selected_list">
              <span v-for="(item,index) in approverConfig.nodeUserList" :key="index">{{item.name}}
                <img src="@/assets/images/add-close1.png" @click="removeEle(approverConfig.nodeUserList,item,'targetId')">
              </span>
              <a v-if="approverConfig.nodeUserList.length!=0" @click="approverConfig.nodeUserList=[]">清除</a>
            </p>

          </div>

          <!-- <div class="approver_some" v-if="(approverConfig.settype==1&&approverConfig.nodeUserList.length>1)||approverConfig.settype==2||(approverConfig.settype==4&&approverConfig.selectMode==2)">
                        <p>多人审批时采用的审批方式</p>
                        <el-radio-group v-model="approverConfig.examineMode" class="clear">
                            <el-radio :label="1">依次审批</el-radio>
                            <br/>
                            <el-radio :label="2" v-if="approverConfig.settype!=2">会签(须所有审批人同意)</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="approver_some" v-if="approverConfig.settype==2||approverConfig.settype==7">
                        <p>审批人为空时</p>
                        <el-radio-group v-model="approverConfig.noHanderAction" class="clear">
                            <el-radio :label="1">自动审批通过/不允许发起</el-radio>
                            <br/>
                            <el-radio :label="2">转交给审核管理员</el-radio>
                        </el-radio-group>
                    </div> -->
        </div>
        <div class="demo-drawer__footer clear">
          <el-button type="primary" @click="saveApprover" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          <el-button @click="approverDrawer = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
        </div>
        <el-dialog title="选择成员" :visible.sync="approverVisible" width="600px" append-to-body class="promoter_person">
          <div class="person_body clear">
            <div class="person_tree l" style="float: left;">
              <input type="text" placeholder="搜索成员" v-model="approverSearchName" @input="getDebounceData($event)">
              <p class="ellipsis tree_nav" v-if="!approverSearchName">
                <span @click="getDepartmentList(0)" class="ellipsis">天下</span>
                <span v-for="(item,index) in departments.titleDepartments" class="ellipsis" :key="index+'a'" @click="getDepartmentList(item.id)">{{item.departmentName}}</span>
              </p>
              <ul>
                <li v-for="(item,index) in departments.childDepartments" :key="index+'b'" class="check_box not">
                  <a><img src="@/assets/images/icon_file.png">{{item.departmentName}}</a>
                  <!-- <i @click="getDepartmentList(item.id)">下级</i> -->
                </li>
                <li v-for="(item,index) in departments.employees" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(approverEmplyessList,item)&&'active'" @click="toChecked(approverEmplyessList,item)" :title="item.departmentNames">
                    <img src="@/assets/images/icon_people.png">{{item.employeeName}}</a>
                </li>
              </ul>
            </div>
            <div class="has_selected l" style="float: right;">
              <p class="clear">已选（{{approverEmplyessList.length}}）
                <a @click="approverEmplyessList=[]">清空</a>
              </p>
              <ul>
                <li v-for="(item,index) in approverEmplyessList" :key="index+'e'">
                  <img src="@/assets/images/icon_people.png">
                  <span>{{item.employeeName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(approverEmplyessList,item)">
                </li>
              </ul>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="approverVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="sureApprover" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="选择角色" :visible.sync="approverRoleVisible" width="600px" append-to-body class="promoter_person">
          <div class="person_body clear">
            <div class="person_tree l" style="float: left;">
              <input type="text" placeholder="搜索角色" v-model="approverRoleSearchName" @input="getDebounceData($event,2)">
              <ul>
                <li v-for="(item,index) in roles" :key="index+'b'" class="check_box not" :class="toggleClass(roleList,item,'roleId')&&'active'" @click="roleList=[item]">
                  <a :title="item.description"><img src="@/assets/images/icon_role.png">{{item.roleName}}</a>
                </li>
              </ul>
            </div>
            <div class="has_selected l" style="float: right;">
              <p class="clear">已选（{{roleList.length}}）
                <a @click="roleList=[]">清空</a>
              </p>
              <ul>
                <li v-for="(item,index) in roleList" :key="index+'e'">
                  <img src="@/assets/images/icon_role.png">
                  <span>{{item.roleName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(roleList,item,'roleId')">
                </li>
              </ul>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="approverRoleVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="sureApprover" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="选择部门" width="600px" class="promoter_person" :visible.sync="approverDeptVisible" append-to-body>
          <select-tree :options="departmentsTrees" placeholder="请选择部门" v-model="selectDeptId" :props="defaultProps" width="200" style="margin-right: 10px;" />
          <span slot="footer" class="dialog-footer">
            <el-button @click="approverDeptVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="sureApprover" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="选择单据中的字段" width="600px" class="promoter_person" :visible.sync="approverTableVisible" append-to-body>
          <!-- <el-button type="primary" @click="showConditions" size="mini" style="color: #ffffff;border-radius: 0px;">查看单据字段</el-button> -->
          <div>单据字段
            <el-radio-group v-model="selectTableCode" style="width: 100%;">
              <el-radio v-for="item in conditions" :label="item.columnDbname" :key="item.columnId">{{item.columnName}}</el-radio>
            </el-radio-group>
          </div>

          <div> 字段类型
            <el-radio-group v-model="selectTableType" style="width: 100%;">
              <el-radio :label="5">部门负责人</el-radio>
              <el-radio :label="6">部门分管领导</el-radio>
            </el-radio-group>

          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="approverTableVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="sureApprover" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>

      </div>
    </el-drawer>
    <el-drawer :append-to-body="true" title="抄送人设置" :visible.sync="copyerDrawer" direction="rtl" class="set_copyer" size="550px" :before-close="saveCopyer">
      <div class="demo-drawer__content">
        <div class="copyer_content drawer_content">
          <el-button type="primary" @click="addCopyer" size="mini" style="color: #fff;border-radius: 0px;font-size: 14px;">添加成员</el-button>
          <p class="selected_list">
            <span v-for="(item,index) in copyerConfig.nodeUserList" :key="index" style="font-size: 14px;">{{item.name}}
              <img src="@/assets/images/add-close1.png" @click="removeEle(copyerConfig.nodeUserList,item,'targetId')">
            </span>
            <a v-if="copyerConfig.nodeUserList&&copyerConfig.nodeUserList.length!=0" @click="copyerConfig.nodeUserList=[]" style="font-size: 14px;">清除</a>
          </p>
          <el-checkbox-group v-model="ccSelfSelectFlag" class="clear">
            <el-checkbox :label="1">允许发起人自选抄送人</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="demo-drawer__footer clear">
          <el-button type="primary" @click="saveCopyer" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          <el-button @click="copyerDrawer = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
        </div>
        <el-dialog title="选择成员" :visible.sync="copyerVisible" width="600px" append-to-body class="promoter_person">
          <div class="person_body clear">
            <div class="person_tree l" style="float: left;">
              <input type="text" placeholder="搜索成员" v-model="copyerSearchName" @input="getDebounceData($event,activeName)">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="组织架构" name="1"></el-tab-pane>
                <el-tab-pane label="角色列表" name="2"></el-tab-pane>
              </el-tabs>
              <p class="ellipsis tree_nav" v-if="activeName==1&&!copyerSearchName">
                <span @click="getDepartmentList(0)" class="ellipsis">农发集团</span>
                <span v-for="(item,index) in departments.titleDepartments" class="ellipsis" :key="index+'a'" @click="getDepartmentList(item.id)">{{item.departmentName}}</span>
              </p>
              <ul style="height: 360px;" v-if="activeName==1">
                <li v-for="(item,index) in departments.childDepartments" :key="index+'b'" class="check_box not">
                  <a><img src="@/assets/images/icon_file.png">{{item.departmentName}}</a>
                  <!-- <i @click="getDepartmentList(item.id)">下级</i> -->
                </li>
                <li v-for="(item,index) in departments.employees" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(copyerEmployessList,item)&&'active'" @click="toChecked(copyerEmployessList,item)" :title="item.departmentNames">
                    <img src="@/assets/images/icon_people.png">{{item.employeeName}}</a>
                </li>
              </ul>
              <ul style="height: 360px;" v-if="activeName==2">
                <li v-for="(item,index) in roles" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(copyerRoleList,item,'roleId')&&'active'" @click="toChecked(copyerRoleList,item,'roleId')" :title="item.description">
                    <img src="@/assets/images/icon_role.png">{{item.roleName}}</a>
                </li>
              </ul>
            </div>
            <div class="has_selected l" style="float: right;">
              <p class="clear">已选（{{copyerEmployessList.length+copyerRoleList.length}}）
                <a @click="copyerEmployessList=[];copyerRoleList=[]">清空</a>
              </p>
              <ul>
                <li v-for="(item,index) in copyerRoleList" :key="index+'e'">
                  <img src="@/assets/images/icon_role.png">
                  <span>{{item.roleName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(copyerRoleList,item,'roleId')">
                </li>
                <li v-for="(item,index) in copyerEmployessList" :key="index+'e1'">
                  <img src="@/assets/images/icon_people.png">
                  <span>{{item.employeeName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(copyerEmployessList,item)">
                </li>
              </ul>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="copyerVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
            <el-button type="primary" @click="sureCopyer" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-drawer>
    <el-drawer :append-to-body="true" title="条件设置" :visible.sync="conditionDrawer" direction="rtl" class="condition_copyer" size="550px" :before-close="saveCondition">
      <select v-model="conditionConfig.priorityLevel" class="priority_level" style="font-size: 14px;">
        <option v-for="item in conditionsConfig.conditionNodes.length" :value="item" :key="item">优先级{{item}}</option>
      </select>
      <div class="demo-drawer__content">
        <div class="condition_content drawer_content">
          <p class="tip">当审批单同时满足以下条件时进入此流程</p>
          <ul style="font-size: 14px;">
            <li v-for="(item,index) in conditionConfig.conditionList" :key="index">
              <div class="ellipsis" style="display: inline-block;width: 150px;">{{item.type==1?'发起人':item.showName}}：</div>
              <div v-if="item.type==1">
                <p :class="conditionConfig.nodeUserList.length > 0?'selected_list':''" @click.self="addConditionRole" style="cursor:text">
                  <span v-for="(item1,index1) in conditionConfig.nodeUserList" :key="index1">
                    {{item1.name}}<img src="@/assets/images/add-close1.png" @click="removeEle(conditionConfig.nodeUserList,item1,'targetId')">
                  </span>
                  <input type="text" placeholder="请选择具体人员/角色/部门" v-if="conditionConfig.nodeUserList.length == 0" @click="addConditionRole">
                </p>
              </div>
              <div v-else-if="item.columnType == 'Boolean'">
                <el-radio-group v-model="item.fixedDownBoxValue">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false" style="margin-left: 5px;">否</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.columnType == 'String'">
                <span v-if="item.showType == 3">
                  <el-input placeholder="请输入内容" v-model="item.fixedDownBoxValue" size="mini" clearable></el-input>
                </span>
                <span v-if="item.showType == 4">
                  <el-select v-model="item.fixedDownBoxValue" clearable placeholder="请选择" style="width: 370px;" size="mini">
                    <el-option v-for="(item11, index11) in item.options" :key="index11" style="margin-left: 5px;" :label="item11.label" :value="item11.value">
                    </el-option>
                  </el-select>
                </span>
                <span v-if="item.showType == 5">
                  <el-radio-group v-model="item.fixedDownBoxValue">
                    <el-radio v-for="(item11, index11) in item.options" :key="index11" style="margin-left: 5px;" :label="item11.value">
                      {{item11.label}}
                    </el-radio>
                  </el-radio-group>
                </span>
                <span v-if="item.showType == 6">
                  <el-checkbox-group v-model="item.fixedDownBoxValue">
                    <el-checkbox v-for="(item11, index11) in item.options" :key="index11" style="margin-left: 5px;" :label="item11.value">
                      {{item11.label}}
                    </el-checkbox>
                  </el-checkbox-group>
                </span>
              </div>
              <div v-else>
                <p>
                  <select v-model="item.optType" :style="'width:'+(item.optType==6?370:100)+'px'" @change="changeOptType(item)">
                    <option value="1">小于</option>
                    <option value="2">大于</option>
                    <option value="3">小于等于</option>
                    <option value="4">等于</option>
                    <option value="5">大于等于</option>
                    <option value="6">介于两个数之间</option>
                  </select>
                  <input v-if="item.optType!=6" type="text" :placeholder="'请输入'+item.showName" v-enter-number="2" v-model="item.zdy1">
                </p>
                <p v-if="item.optType==6">
                  <input type="text" style="width:75px;" class="mr_10" v-enter-number="2" v-model="item.zdy1">
                  <select style="width:60px;" v-model="item.opt1">
                    <option value="<">&lt;</option>
                    <option value="<=">≤</option>
                  </select>
                  <span class="ellipsis" style="display:inline-block;width:60px;vertical-align: text-bottom;">{{item.showName}}</span>
                  <select style="width:60px;" class="ml_10" v-model="item.opt2">
                    <option value="<">&lt;</option>
                    <option value="<=">≤</option>
                  </select>
                  <input type="text" style="width:75px;" v-enter-number="2" v-model="item.zdy2">
                </p>
              </div>
              <a v-if="item.type==1" @click="conditionConfig.nodeUserList= [];removeEle(conditionConfig.conditionList,item,'columnId')">删除</a>
              <a v-if="item.type==2" @click="removeEle(conditionConfig.conditionList,item,'columnId')">删除</a>
            </li>
          </ul>
          <el-button type="primary" @click="addCondition" size="mini" style="border-radius: 0px;margin-top: 10px;color: #fff;font-size: 14px;">添加条件</el-button>
          <el-dialog title="选择条件" :visible.sync="conditionVisible" width="480px" append-to-body class="condition_list">
            <p>请选择用来区分审批流程的条件字段</p>
            <p class="check_box">
              <a :class="toggleClass(conditionList,{columnId:0},'columnId')&&'active'" @click="toChecked(conditionList,{columnId:0},'columnId')">发起人</a>
              <a v-for="(item,index) in conditions" :key="index" :class="toggleClass(conditionList,item,'columnId')&&'active'" @click="toChecked(conditionList,item,'columnId')">{{item.showName}}</a>
            </p>
            <span slot="footer" class="dialog-footer">
              <el-button @click="conditionVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
              <el-button type="primary" @click="sureCondition" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <el-dialog title="选择成员" :visible.sync="conditionRoleVisible" width="600px" append-to-body class="promoter_person">
          <div class="person_body clear">
            <div class="person_tree l" style="float: left;">
              <input type="text" placeholder="搜索成员" v-model="conditionRoleSearchName" @input="getDebounceData($event,activeName)">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="组织架构" name="1"></el-tab-pane>
                <el-tab-pane label="角色列表" name="2"></el-tab-pane>
              </el-tabs>
              <p class="ellipsis tree_nav" v-if="activeName==1&&!conditionRoleSearchName">
                <span @click="getDepartmentList(0)" class="ellipsis">天下</span>
                <span v-for="(item,index) in departments.titleDepartments" class="ellipsis" :key="index+'a'" @click="getDepartmentList(item.id)">{{item.departmentName}}</span>
              </p>
              <ul style="height: 360px;" v-if="activeName==1">
                <li v-for="(item,index) in departments.childDepartments" :key="index+'b'" class="check_box">
                  <a :class="toggleClass(conditionDepartmentList,item)&&'active'" @click="toChecked(conditionDepartmentList,item)">
                    <img src="@/assets/images/icon_file.png">{{item.departmentName}}</a>
                  <!-- <i @click="getDepartmentList(item.id)">下级</i> -->
                </li>
                <li v-for="(item,index) in departments.employees" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(conditionEmployessList,item)&&'active'" @click="toChecked(conditionEmployessList,item)" :title="item.departmentNames">
                    <img src="@/assets/images/icon_people.png">{{item.employeeName}}</a>
                </li>
              </ul>
              <ul style="height: 360px;" v-if="activeName==2">
                <li v-for="(item,index) in roles" :key="index+'c'" class="check_box">
                  <a :class="toggleClass(conditionRoleList,item,'roleId')&&'active'" @click="toChecked(conditionRoleList,item,'roleId')" :title="item.description">
                    <img src="@/assets/images/icon_role.png">{{item.roleName}}</a>
                </li>
              </ul>
            </div>
            <div class="has_selected l" style="float: right;">
              <p class="clear">已选（{{conditionDepartmentList.length+conditionEmployessList.length+conditionRoleList.length}}）
                <a @click="conditionDepartmentList=[];conditionEmployessList=[];conditionRoleList=[]">清空</a>
              </p>
              <ul>
                <li v-for="(item,index) in conditionRoleList" :key="index+'e'">
                  <img src="@/assets/images/icon_role.png">
                  <span>{{item.roleName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(conditionRoleList,item,'roleId')">
                </li>
                <li v-for="(item,index) in conditionDepartmentList" :key="index+'e1'">
                  <img src="@/assets/images/icon_file.png">
                  <span>{{item.departmentName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(conditionDepartmentList,item)">
                </li>
                <li v-for="(item,index) in conditionEmployessList" :key="index+'e2'">
                  <img src="@/assets/images/icon_people.png">
                  <span>{{item.employeeName}}</span>
                  <img src="@/assets/images/cancel.png" @click="removeEle(conditionEmployessList,item)">
                </li>
              </ul>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="conditionRoleVisible = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消
            </el-button>
            <el-button type="primary" @click="sureConditionRole" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          </span>
        </el-dialog>
        <div class="demo-drawer__footer clear">
          <el-button type="primary" @click="saveCondition" size="mini" style="background: #66b1ff;color: #FFF;border-radius: 0px;font-size: 14px;">确 定</el-button>
          <el-button @click="conditionDrawer = false" size="mini" style="background: #f2f2f2;color: #323232;border-radius: 0px;font-size: 14px;">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <nodeWrap v-if="nodeConfig.childNode && nodeConfig.childNode" :nodeConfig.sync="nodeConfig.childNode" :tableId="tableId" :isTried.sync="isTried" :directorMaxLevel="directorMaxLevel" :flowType="flowType">
    </nodeWrap>
  </div>
</template>
<script>
import {
  getConditions,
  getEmployees,
  getRoles,
  getDepartments,
} from "@/api/approve/flowable";

import SelectTree from "@/components/SelectTree/index.vue";
import {
  getDepartmentList,
  getDepartmentAllList,
} from "@/api/oa/department";
export default {
  props: [
    "nodeConfig",
    "flowPermission",
    "directorMaxLevel",
    "isTried",
    "tableId",
    "flowType",
  ],
  components: {
    SelectTree,
  },
  data() {
    return {
      placeholderList: ["发起人", "审核人", "抄送人"],
      isInputList: [],
      isInput: false,
      promoterVisible: false,
      promoterDrawer: false,
      departments: {},
      checkedDepartmentList: [],
      checkedEmployessList: [],
      promoterSearchName: "",
      flowPermission1: this.flowPermission,
      approverDrawer: false,
      approverVisible: false,
      approverRoleVisible: false,
      approverDeptVisible: false,
      approverTableVisible: false,
      approverConfig: {},
      approverEmplyessList: [],
      approverSearchName: "",
      roles: [],
      roleList: [],
      approverRoleSearchName: "",
      copyerDrawer: false,
      copyerVisible: false,
      copyerConfig: {},
      copyerSearchName: "",
      activeName: "1",
      copyerEmployessList: [],
      copyerRoleList: [],
      ccSelfSelectFlag: [],
      conditionDrawer: false,
      conditionVisible: false,
      conditionConfig: {},
      conditionsConfig: {
        conditionNodes: [],
      },
      bPriorityLevel: "",
      conditions: [],
      conditionList: [],
      conditionRoleVisible: false,
      conditionRoleSearchName: "",
      conditionDepartmentList: [],
      conditionEmployessList: [],
      conditionRoleList: [],
      selectDeptId: null,
      selectTableCode: null,
      selectTableType: null,
      departmentsTrees: [],
      departmentsList: [],
      defaultProps: {
        parent: "parentId", // 父级唯一标识
        value: "departmentId", // 唯一标识
        label: "departmentName", // 标签显示
        children: "children", // 子级
      },
    };
  },
  mounted() {
    if (this.nodeConfig.type == 1) {
      this.nodeConfig.error = !this.setApproverStr(this.nodeConfig);
    } else if (this.nodeConfig.type == 2) {
      this.nodeConfig.error = !this.copyerStr(this.nodeConfig);
    } else if (this.nodeConfig.type == 4) {
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
            "请设置条件" && i != this.nodeConfig.conditionNodes.length - 1;
      }
    }
    this.listDept();
  },
  methods: {
    listDept() {
      getDepartmentList().then((res) => {
        console.log("🚀 ~ getDepartmentList ~ res:", res)
        this.departmentsTrees = res;
        getDepartmentAllList().then((ress) => {
          this.departmentsList = ress;
        });
      });
    },

    clickEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, true);
      } else {
        this.isInput = true;
      }
    },
    blurEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, false);
        this.nodeConfig.conditionNodes[index].nodeName = this.nodeConfig
          .conditionNodes[index].nodeName
          ? this.nodeConfig.conditionNodes[index].nodeName
          : "条件";
      } else {
        this.isInput = false;
        this.nodeConfig.nodeName = this.nodeConfig.nodeName
          ? this.nodeConfig.nodeName
          : this.placeholderList[this.nodeConfig.type];
      }
    },
    conditionStr(item, index) {
      var { conditionList, nodeUserList } = item;
      if (conditionList.length == 0) {
        return index == this.nodeConfig.conditionNodes.length - 1 &&
          this.nodeConfig.conditionNodes[0].conditionList.length != 0
          ? "其他条件进入此流程"
          : "请设置条件";
      } else {
        let str = "";
        for (var i = 0; i < conditionList.length; i++) {
          var {
            columnId,
            columnType,
            showType,
            showName,
            optType,
            zdy1,
            opt1,
            zdy2,
            opt2,
            fixedDownBoxValue,
            options,
          } = conditionList[i];
          if (columnId == 0) {
            if (nodeUserList.length != 0) {
              str += "发起人属于：";
              str +=
                nodeUserList
                  .map((item) => {
                    return item.name;
                  })
                  .join("或") + " 并且 ";
            }
          }
          if (columnType == "Boolean") {
            str +=
              showName + "：" + (fixedDownBoxValue ? "是" : "否") + " 并且 ";
          }
          if (columnType == "String") {
            if (showType == "3") {
              if (zdy1) {
                str += showName + "属于：" + fixedDownBoxValue + " 并且 ";
              }
            }
            if (showType == "4" || showType == "5") {
              if (
                fixedDownBoxValue != "" &&
                fixedDownBoxValue != null &&
                fixedDownBoxValue != undefined
              ) {
                let fixedDownBoxLabel = "";
                options.map((o) => {
                  if (o.value == fixedDownBoxValue) {
                    fixedDownBoxLabel = o.label;
                  }
                });
                if (zdy1) {
                  str += showName + "属于：" + fixedDownBoxLabel + " 并且 ";
                }
              }
            }
            if (showType == "6") {
              let fixedDownBoxLabel = "";
              if (
                fixedDownBoxValue != "" &&
                fixedDownBoxValue != null &&
                fixedDownBoxValue != undefined &&
                fixedDownBoxValue.length != 0
              ) {
                options.map((o) => {
                  fixedDownBoxValue.map((f) => {
                    if (o.value == f) {
                      if (fixedDownBoxLabel === "") {
                        fixedDownBoxLabel = o.label;
                      } else {
                        fixedDownBoxLabel += "," + o.label;
                      }
                    }
                  });
                });
                if (zdy1) {
                  str += showName + "属于：" + fixedDownBoxLabel + " 并且 ";
                }
              }
            }
          }
          if (columnType == "Double" || columnType == "Number") {
            if (optType != 6 && zdy1) {
              var optTypeStr = ["", "<", ">", "<=", "=", ">="][optType];
              str += `${showName} ${optTypeStr} ${zdy1} 并且 `;
            } else if (optType == 6 && zdy1 && zdy2) {
              str += `${zdy1} ${opt1} ${showName} ${opt2} ${zdy2} 并且 `;
            }
          }
        }
        return str ? str.substring(0, str.length - 4) : "请设置条件";
      }
    },
    dealStr(str, obj) {
      let arr = [];
      let list = str.split(",");
      for (var elem in obj) {
        list.map((item) => {
          if (item == elem) {
            arr.push(obj[elem].value);
          }
        });
      }
      return arr.join("或");
    },
    addConditionRole() {
      this.conditionRoleSearchName = "";
      this.conditionRoleVisible = true;
      this.activeName = "1";
      this.getDepartmentList();
      this.conditionDepartmentList = [];
      this.conditionEmployessList = [];
      this.conditionRoleList = [];
      for (var i = 0; i < this.conditionConfig.nodeUserList.length; i++) {
        var { type, name, targetId } = this.conditionConfig.nodeUserList[i];
        if (type == 1) {
          this.conditionEmployessList.push({
            employeeName: name,
            id: targetId,
          });
        } else if (type == 2) {
          this.conditionRoleList.push({
            roleName: name,
            roleId: targetId,
          });
        } else if (type == 3) {
          this.conditionDepartmentList.push({
            departmentName: name,
            id: targetId,
          });
        }
      }
    },
    sureConditionRole() {
      this.conditionConfig.nodeUserList = [];
      this.conditionRoleList.map((item) => {
        this.conditionConfig.nodeUserList.push({
          type: 2,
          targetId: item.roleId,
          name: item.roleName,
        });
      });
      this.conditionDepartmentList.map((item) => {
        this.conditionConfig.nodeUserList.push({
          type: 3,
          targetId: item.id,
          name: item.departmentName,
        });
      });
      this.conditionEmployessList.map((item) => {
        this.conditionConfig.nodeUserList.push({
          type: 1,
          targetId: item.id,
          name: item.employeeName,
        });
      });
      this.conditionRoleVisible = false;
    },
    addCondition() {
      if (
        this.tableId == null ||
        this.tableId == "" ||
        this.tableId == undefined
      ) {
        this.$message({
          message: "请选择流程类别",
          type: "warning",
        });
        return;
      }
      if (
        this.flowType == null ||
        this.flowType == "" ||
        this.flowType == undefined
      ) {
        this.$message({
          message: "请选择关联表单类型",
          type: "warning",
        });
        return;
      }
      this.conditionList = [];
      this.conditionVisible = true;
      const loading = this.$loading({
        lock: true,
        text: "条件加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getConditions(this.tableId, this.flowType)
        .then((res) => {
          this.conditions = res;
          if (this.conditionConfig.conditionList) {
            for (
              var i = 0;
              i < this.conditionConfig.conditionList.length;
              i++
            ) {
              var { columnId } = this.conditionConfig.conditionList[i];
              if (columnId == 0) {
                this.conditionList.push({ columnId: 0 });
              } else {
                this.conditionList.push(
                  this.conditions.filter((item) => {
                    return item.columnId == columnId;
                  })[0]
                );
              }
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    changeOptType(item) {
      if (item.optType == 1) {
        item.zdy1 = 2;
      } else {
        item.zdy1 = 1;
        item.zdy2 = 2;
      }
    },
    sureCondition() {
      // 1.弹窗有，外面无+
      // 2.弹窗有，外面有不变
      for (var i = 0; i < this.conditionList.length; i++) {
        var {
          columnId,
          showName,
          columnName,
          showType,
          columnType,
          fixedDownBoxValue,
          zdy1,
          options,
          columnDbname,
        } = this.conditionList[i];
        if (
          this.toggleClass(
            this.conditionConfig.conditionList,
            this.conditionList[i],
            "columnId"
          )
        ) {
          continue;
        }
        if (columnId == 0) {
          this.conditionConfig.nodeUserList == [];
          this.conditionConfig.conditionList.push({
            type: 1,
            columnId: columnId,
            showName: "发起人",
          });
        } else {
          if (columnType == "Double" || columnType == "Number") {
            this.conditionConfig.conditionList.push({
              showType: showType,
              columnId: columnId,
              type: 2,
              showName: showName,
              optType: "1",
              zdy1: "2",
              opt1: "<",
              zdy2: "",
              opt2: "<",
              columnDbname: columnDbname,
              columnType: columnType,
            });
          } else if (columnType == "Boolean") {
            this.conditionConfig.conditionList.push({
              showType: showType,
              columnId: columnId,
              type: 2,
              showName: showName,
              zdy1: zdy1,
              columnDbname: columnDbname,
              columnType: columnType,
              fixedDownBoxValue: fixedDownBoxValue,
              optType: "4",
              opt1: "==",
            });
          } else if (columnType == "String" && showType == "3") {
            this.conditionConfig.conditionList.push({
              showType: showType,
              columnId: columnId,
              type: 2,
              showName: showName,
              zdy1: zdy1,
              columnDbname: columnDbname,
              columnType: columnType,
              fixedDownBoxValue: fixedDownBoxValue,
              optType: "4",
              opt1: "==",
            });
          } else if (
            columnType == "String" &&
            (showType == "4" || showType == "5")
          ) {
            this.conditionConfig.conditionList.push({
              showType: showType,
              columnId: columnId,
              type: 2,
              showName: showName,
              zdy1: zdy1,
              columnDbname: columnDbname,
              columnType: columnType,
              fixedDownBoxValue: fixedDownBoxValue,
              options: options,
              optType: "4",
              opt1: "==",
            });
          } else if (columnType == "String" && showType == "6") {
            this.conditionConfig.conditionList.push({
              showType: showType,
              columnId: columnId,
              type: 2,
              showName: showName,
              zdy1: zdy1,
              columnDbname: columnDbname,
              columnType: columnType,
              fixedDownBoxValue: [],
              options: options,
              optType: "4",
              opt1: "==",
            });
          }
        }
      }
      // 3.弹窗无，外面有-
      for (let i = this.conditionConfig.conditionList.length - 1; i >= 0; i--) {
        if (
          !this.toggleClass(
            this.conditionList,
            this.conditionConfig.conditionList[i],
            "columnId"
          )
        ) {
          this.conditionConfig.conditionList.splice(i, 1);
        }
      }
      this.conditionConfig.conditionList.sort(function (a, b) {
        return a.columnId - b.columnId;
      });
      this.conditionVisible = false;
    },
    saveCondition() {
      this.conditionDrawer = false;
      var a = this.conditionsConfig.conditionNodes.splice(
        this.bPriorityLevel - 1,
        1
      ); // 截取旧下标
      this.conditionsConfig.conditionNodes.splice(
        this.conditionConfig.priorityLevel - 1,
        0,
        a[0]
      ); // 填充新下标
      this.conditionsConfig.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1;
      });
      for (var i = 0; i < this.conditionsConfig.conditionNodes.length; i++) {
        this.conditionsConfig.conditionNodes[i].error =
          this.conditionStr(this.conditionsConfig.conditionNodes[i], i) ==
            "请设置条件" &&
          i != this.conditionsConfig.conditionNodes.length - 1;
      }
      this.$emit("update:nodeConfig", this.conditionsConfig);
    },
    getDebounceData(event, type = 1) {
      this.$func.debounce(
        function () {
          if (event.target.value) {
            if (type == 1) {
              this.departments.childDepartments = [];
              getEmployees({ name: event.target.value }).then((res) => {
                this.departments.employees = res;
              });
            } else {
              getRoles({ name: event.target.value }).then((res) => {
                this.roles = res;
              });
            }
          } else {
            type == 1 ? this.getDepartmentList() : this.getRoleList();
          }
        }.bind(this)
      )();
    },
    handleClick() {
      this.copyerSearchName = "";
      this.conditionRoleSearchName = "";
      if (this.activeName == 1) {
        this.getDepartmentList();
      } else {
        this.getRoleList();
      }
    },
    addCopyer() {
      this.copyerSearchName = "";
      this.copyerVisible = true;
      this.activeName = "1";
      this.getDepartmentList();
      this.copyerEmployessList = [];
      this.copyerRoleList = [];
      for (var i = 0; i < this.copyerConfig.nodeUserList.length; i++) {
        var { type, name, targetId } = this.copyerConfig.nodeUserList[i];
        if (type == 1) {
          this.copyerEmployessList.push({
            employeeName: name,
            id: targetId,
          });
        } else if (type == 2) {
          this.copyerRoleList.push({
            roleName: name,
            roleId: targetId,
          });
        }
      }
    },
    sureCopyer() {
      this.copyerConfig.nodeUserList = [];
      this.copyerEmployessList.map((item) => {
        this.copyerConfig.nodeUserList.push({
          type: 1,
          targetId: item.id,
          name: item.employeeName,
        });
      });
      this.copyerRoleList.map((item) => {
        this.copyerConfig.nodeUserList.push({
          type: 2,
          targetId: item.roleId,
          name: item.roleName,
        });
      });
      this.copyerVisible = false;
    },
    saveCopyer() {
      this.copyerConfig.ccSelfSelectFlag =
        this.ccSelfSelectFlag.length == 0 ? 0 : 1;
      this.copyerConfig.error = !this.copyerStr(this.copyerConfig);
      this.$emit("update:nodeConfig", this.copyerConfig);
      this.copyerDrawer = false;
    },
    copyerStr(nodeConfig) {
      if (nodeConfig.nodeUserList.length != 0) {
        return this.arrToStr(nodeConfig.nodeUserList);
      } else {
        if (nodeConfig.ccSelfSelectFlag == 1) {
          return "发起人自选";
        }
      }
    },
    changeRange() {
      this.approverConfig.nodeUserList = [];
    },
    changeType(val) {
      console.log("🚀 ~ file: nodeWrap.vue:1008 ~ changeType ~ val:", val);
      this.approverConfig.nodeUserList = [];
      this.approverConfig.examineMode = 1;
      this.approverConfig.noHanderAction = 2;
      if (val == 2) {
        this.approverConfig.directorLevel = 1;
      } else if (val == 4) {
        this.approverConfig.selectMode = 1;
        this.approverConfig.selectRange = 1;
      } else if (val == 7) {
        this.approverConfig.examineEndDirectorLevel = 1;
      } else if (val == 3) {
        this.approverConfig.selectMode = 2;
        this.approverConfig.selectRange = 3;
      } else if (val == 9) {
        this.approverConfig.selectMode = 1;
        this.approverConfig.selectRange = 4;
      } else if (val == 10) {
        this.approverConfig.selectMode = 1;
        this.approverConfig.selectRange = 5;
      }
    },
    addApprover() {
      this.approverVisible = true;
      this.approverSearchName = "";
      this.getDepartmentList();
      this.approverEmplyessList = [];
      for (var i = 0; i < this.approverConfig.nodeUserList.length; i++) {
        var { name, targetId } = this.approverConfig.nodeUserList[i];
        this.approverEmplyessList.push({
          employeeName: name,
          id: targetId,
        });
      }
    },
    addRoleApprover() {
      this.approverRoleVisible = true;
      this.approverRoleSearchName = "";
      this.getRoleList();
      this.roleList = [];
      for (var i = 0; i < this.approverConfig.nodeUserList.length; i++) {
        var { name, targetId } = this.approverConfig.nodeUserList[i];
        this.roleList.push({
          roleName: name,
          roleId: targetId,
        });
      }
    },
    addDeptApprover() {
      this.approverDeptVisible = true;
      if (
        this.approverConfig.nodeUserList &&
        this.approverConfig.nodeUserList.length > 0
      ) {
        this.selectDeptId = this.approverConfig.nodeUserList[0].targetId;
      }
    },
    showConditions() {
      getConditions(this.tableId, this.flowType).then((res) => {
        this.conditions = res;
      });
    },

    addTableApprover() {
      this.approverTableVisible = true;
      if (
        this.approverConfig.nodeUserList &&
        this.approverConfig.nodeUserList.length > 0
      ) {
        this.selectTableCode = this.approverConfig.nodeUserList[0].targetId;
      }
      getConditions(this.tableId, this.flowType).then((res) => {
        this.conditions = res;
      });
    },

    sureApprover() {
      this.approverConfig.nodeUserList = [];
      if (
        this.approverConfig.settype == 1 ||
        (this.approverConfig.settype == 4 &&
          this.approverConfig.selectRange == 2)
      ) {
        this.approverEmplyessList.map((item) => {
          this.approverConfig.nodeUserList.push({
            type: 1,
            targetId: item.id,
            name: item.employeeName,
          });
        });
        this.approverVisible = false;
      } else if (
        this.approverConfig.settype == 4 &&
        this.approverConfig.selectRange == 3
      ) {
        this.roleList.map((item) => {
          this.approverConfig.nodeUserList.push({
            type: 2,
            targetId: item.roleId,
            name: item.roleName,
          });
        });
        this.approverRoleVisible = false;
      } else if (this.approverConfig.settype == 3) {
        this.roleList.map((item) => {
          this.approverConfig.nodeUserList.push({
            type: 2,
            targetId: item.roleId,
            name: item.roleName,
          });
        });
        this.approverRoleVisible = false;
      } else if (this.approverConfig.settype == 9) {
        if (this.selectDeptId) {
          let dept = null;
          this.departmentsList.some((t) => {
            if (t.departmentId == this.selectDeptId) {
              dept = t;
              return true;
            }
          });
          this.approverConfig.nodeUserList.push({
            type: 3,
            targetId: dept.departmentId,
            name: dept.departmentName,
          });
        }
        this.approverDeptVisible = false;
      } else if (this.approverConfig.settype == 10) {
        if (this.selectDeptId) {
          let dept = null;
          this.departmentsList.some((t) => {
            if (t.departmentId == this.selectDeptId) {
              dept = t;
              return true;
            }
          });
          this.approverConfig.nodeUserList.push({
            type: 4,
            targetId: dept.departmentId,
            name: dept.departmentName,
          });
        }
        this.approverDeptVisible = false;
      } else if (this.approverConfig.settype == 11) {
        if (this.selectTableCode && this.selectTableType) {
          let str = "";
          this.conditions.some((t) => {
            if (t.columnDbname == this.selectTableCode) {
              str = t.columnName;
              return true;
            }
          });
          if (this.selectTableType == 5) {
            str += "的部门负责人";
          } else if (this.selectTableType == 6) {
            str += "的部门分管领导";
          }

          this.approverConfig.nodeUserList.push({
            type: this.selectTableType,
            targetId: this.selectTableCode,
            name: str,
          });
        }

        this.approverTableVisible = false;
      }
    },
    setApproverStr(nodeConfig) {
      if (nodeConfig.settype == 1) {
        if (nodeConfig.nodeUserList.length == 1) {
          return nodeConfig.nodeUserList[0].name;
        } else if (nodeConfig.nodeUserList.length > 1) {
          if (nodeConfig.examineMode == 1) {
            return this.arrToStr(nodeConfig.nodeUserList);
          } else if (nodeConfig.examineMode == 2) {
            return nodeConfig.nodeUserList.length + "人会签";
          }
        }
      } else if (nodeConfig.settype == 2) {
        let level =
          nodeConfig.directorLevel == 1
            ? "直接主管"
            : "第" + nodeConfig.directorLevel + "级主管";
        if (nodeConfig.examineMode == 1) {
          return level;
        } else if (nodeConfig.examineMode == 2) {
          return level + "会签";
        }
      } else if (nodeConfig.settype == 3) {
        if (nodeConfig.nodeUserList.length > 0) {
          return "所有角色是" + nodeConfig.nodeUserList[0].name + "的人会签";
        } else {
          return "";
        }
      } else if (nodeConfig.settype == 4) {
        if (nodeConfig.selectRange == 1) {
          return "发起人自选";
        } else {
          if (nodeConfig.nodeUserList.length > 0) {
            if (nodeConfig.selectRange == 2) {
              return "发起人自选";
            } else {
              return "发起人从" + nodeConfig.nodeUserList[0].name + "中自选";
            }
          } else {
            return "";
          }
        }
      } else if (nodeConfig.settype == 5) {
        return "发起人自己";
      } else if (nodeConfig.settype == 7) {
        return (
          "从直接主管到通讯录中级别最高的第" +
          nodeConfig.examineEndDirectorLevel +
          "个层级主管"
        );
      } else if (nodeConfig.settype == 8) {
        let level =
          nodeConfig.leaderLevel == 1
            ? "发起人部门分管领导"
            : "第" + nodeConfig.leaderLevel + "级部门分管领导";
        if (nodeConfig.examineMode == 1) {
          return level;
        } else if (nodeConfig.examineMode == 2) {
          return level + "会签";
        }
      } else if (nodeConfig.settype == 9) {
        if (nodeConfig.nodeUserList.length > 0) {
          return nodeConfig.nodeUserList[0].name + "部门的负责人审批";
        } else {
          return "";
        }
      } else if (nodeConfig.settype == 10) {
        if (nodeConfig.nodeUserList.length > 0) {
          return nodeConfig.nodeUserList[0].name + "部门的分管领导审批";
        } else {
          return "";
        }
      } else if (nodeConfig.settype == 11) {
        if (nodeConfig.nodeUserList.length > 0) {
          return nodeConfig.nodeUserList[0].name + "审批";
        } else {
          return "";
        }
      }
    },
    saveApprover() {
      console.log("111");
      this.approverConfig.error = !this.setApproverStr(this.approverConfig);
      this.$emit("update:nodeConfig", this.approverConfig);
      this.approverDrawer = false;
    },
    addPromoter() {
      this.promoterVisible = true;
      this.getDepartmentList();
      this.promoterSearchName = "";
      this.checkedEmployessList = [];
      this.checkedDepartmentList = [];
      for (var i = 0; i < this.flowPermission1.length; i++) {
        var { type, name, targetId } = this.flowPermission1[i];
        if (type == 1) {
          this.checkedEmployessList.push({
            employeeName: name,
            id: targetId,
          });
        } else if (type == 3) {
          this.checkedDepartmentList.push({
            departmentName: name,
            id: targetId,
          });
        }
      }
    },
    surePromoter() {
      this.flowPermission1 = [];
      this.checkedDepartmentList.map((item) => {
        this.flowPermission1.push({
          type: 3,
          targetId: item.id,
          name: item.departmentName,
        });
      });
      this.checkedEmployessList.map((item) => {
        this.flowPermission1.push({
          type: 1,
          targetId: item.id,
          name: item.employeeName,
        });
      });
      this.promoterVisible = false;
    },
    savePromoter() {
      this.$emit("update:flowPermission", this.flowPermission1);
      this.promoterDrawer = false;
    },
    arrToStr(arr) {
      if (arr) {
        return arr
          .map((item) => {
            return item.name;
          })
          .toString();
      }
    },
    toggleStrClass(item, key) {
      let a = item.zdy1 ? item.zdy1.split(",") : [];
      return a.some((item) => {
        return item == key;
      });
    },
    toStrChecked(item, key) {
      let a = item.zdy1 ? item.zdy1.split(",") : [];
      var isIncludes = this.toggleStrClass(item, key);
      if (!isIncludes) {
        a.push(key);
        item.zdy1 = a.toString();
      } else {
        this.removeStrEle(item, key);
      }
    },
    removeStrEle(item, key) {
      let a = item.zdy1 ? item.zdy1.split(",") : [];
      var includesIndex;
      a.map((item, index) => {
        if (item == key) {
          includesIndex = index;
        }
      });
      a.splice(includesIndex, 1);
      item.zdy1 = a.toString();
    },
    toggleClass(arr, elem, key = "id") {
      return arr.some((item) => {
        return item[key] == elem[key];
      });
    },
    toChecked(arr, elem, key = "id") {
      var isIncludes = this.toggleClass(arr, elem, key);
      !isIncludes ? arr.push(elem) : this.removeEle(arr, elem, key);
    },
    removeEle(arr, elem, key = "id") {
      var includesIndex;
      arr.map((item, index) => {
        if (item[key] == elem[key]) {
          includesIndex = index;
        }
      });
      arr.splice(includesIndex, 1);
    },
    getRoleList() {
      // axios.get(`http://localhost:9100/roles.json`).then(res => {
      //     this.roles = res.data.data.list
      // })
      getRoles().then((res) => {
        this.roles = res;
      });
    },
    getDepartmentList(parentId) {
      if (parentId == undefined || parentId == null) {
        parentId = 0;
      }
      getDepartments(parentId).then((res) => {
        this.departments = res;
      });
      // axios.get(`http://localhost:9100/departments.json?parentId=${parentId}`).then(res => {
      //     this.departments = res.data.data
      // })
    },
    delNode() {
      this.$emit("update:nodeConfig", this.nodeConfig.childNode);
    },
    addTerm() {
      let len = this.nodeConfig.conditionNodes.length + 1;
      this.nodeConfig.conditionNodes.push({
        nodeName: "条件" + len,
        type: 3,
        priorityLevel: len,
        conditionList: [],
        nodeUserList: [],
        childNode: null,
      });
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
            "请设置条件" && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit("update:nodeConfig", this.nodeConfig);
    },
    delTerm(index) {
      this.nodeConfig.conditionNodes.splice(index, 1);
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
            "请设置条件" && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit("update:nodeConfig", this.nodeConfig);
      if (this.nodeConfig.conditionNodes.length == 1) {
        if (this.nodeConfig.childNode) {
          if (this.nodeConfig.conditionNodes[0].childNode) {
            this.reData(
              this.nodeConfig.conditionNodes[0].childNode,
              this.nodeConfig.childNode
            );
          } else {
            this.nodeConfig.conditionNodes[0].childNode =
              this.nodeConfig.childNode;
          }
        }
        this.$emit(
          "update:nodeConfig",
          this.nodeConfig.conditionNodes[0].childNode
        );
      }
    },
    reData(data, addData) {
      if (!data.childNode) {
        data.childNode = addData;
      } else {
        this.reData(data.childNode, addData);
      }
    },
    setPerson(priorityLevel) {
      var { type } = this.nodeConfig;
      if (type === 0) {
        this.promoterDrawer = true;
        this.flowPermission1 = this.flowPermission;
      } else if (type === 1) {
        this.approverDrawer = true;
        this.approverConfig = JSON.parse(JSON.stringify(this.nodeConfig));
        this.approverConfig.settype = this.approverConfig.settype
          ? this.approverConfig.settype
          : 1;
      } else if (type === 2) {
        this.copyerDrawer = true;
        this.copyerConfig = JSON.parse(JSON.stringify(this.nodeConfig));
        this.ccSelfSelectFlag =
          this.copyerConfig.ccSelfSelectFlag == 0
            ? []
            : [this.copyerConfig.ccSelfSelectFlag];
      } else {
        this.conditionDrawer = true;
        this.bPriorityLevel = priorityLevel;
        this.conditionsConfig = JSON.parse(JSON.stringify(this.nodeConfig));
        this.conditionConfig =
          this.conditionsConfig.conditionNodes[priorityLevel - 1];
      }
    },
    arrTransfer(index, type = 1) {
      // 向左-1, 向右1
      this.nodeConfig.conditionNodes[index] =
        this.nodeConfig.conditionNodes.splice(
          index + type,
          1,
          this.nodeConfig.conditionNodes[index]
        )[0];
      this.nodeConfig.conditionNodes.map((item, index) => {
        item.priorityLevel = index + 1;
      });
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error =
          this.conditionStr(this.nodeConfig.conditionNodes[i], i) ==
            "请设置条件" && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit("update:nodeConfig", this.nodeConfig);
    },
  },
};
</script>
<style scoped>
.error_tip {
  position: absolute !important;
  top: 0px !important;
  right: 0px !important;
  transform: translate(150%, 0px) !important;
  font-size: 24px !important;
}
.add-node-popover-body {
  display: flex !important;
}
.promoter_content {
  padding: 0 20px !important;
}
.condition_content .el-button,
.copyer_content .el-button,
.approver_self_select .el-button,
.promoter_content .el-button,
.approver_content .el-button {
  margin-bottom: 20px !important;
}
.promoter_content p {
  padding: 18px 0 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #000000 !important;
}

.promoter_person .el-dialog__body {
  padding: 10px 20px 14px 20px !important;
}
.person_body {
  border: 1px solid #f5f5f5 !important;
  height: 500px !important;
}
.person_tree {
  padding: 10px 12px 0 8px !important;
  width: 280px !important;
  height: 100% !important;
  border-right: 1px solid #f5f5f5 !important;
}
.person_tree input {
  padding-left: 22px !important;
  width: 210px !important;
  height: 30px !important;
  font-size: 12px !important;
  border-radius: 2px !important;
  border: 1px solid #d5dadf !important;
  background: url(~@/assets/images/list_search.png) no-repeat 10px center !important;
  background-size: 14px 14px !important;
  margin-bottom: 14px !important;
}
.tree_nav span {
  display: inline-block;
  padding-right: 10px !important;
  margin-right: 5px !important;
  max-width: 6em !important;
  color: #38adff !important;
  font-size: 12px !important;
  cursor: pointer !important;
  background: url(~@/assets/images/jiaojiao.png) no-repeat right center !important;
}
.tree_nav span:last-of-type {
  background: none !important;
}
.person_tree ul,
.has_selected ul {
  height: 420px !important;
  overflow-y: auto !important;
}
.person_tree li {
  padding: 5px 0 !important;
}
.person_tree li i {
  float: right !important;
  padding-left: 24px !important;
  padding-right: 10px !important;
  color: #3195f8 !important;
  font-size: 12px !important;
  cursor: pointer !important;
  background: url(~@/assets/images/next_level_active.png) no-repeat 10px center !important;
  border-left: 1px solid rgb(238, 238, 238) !important;
}
.person_tree li a.active + i {
  color: rgb(197, 197, 197) !important;
  background-image: url(~@/assets/images/next_level.png) !important;
  pointer-events: none !important;
}
.person_tree img {
  width: 14px !important;
  vertical-align: middle !important;
  margin-right: 5px !important;
}
.has_selected {
  width: 276px !important;
  height: 100% !important;
  font-size: 12px !important;
}
.has_selected ul {
  height: 460px !important;
}
.has_selected p {
  padding-left: 19px !important;
  padding-right: 20px !important;
  line-height: 37px !important;
  border-bottom: 1px solid #f2f2f2 !important;
}
.has_selected p a {
  float: right !important;
}
.has_selected ul li {
  margin: 11px 26px 13px 19px !important;
  line-height: 17px !important;
}
.has_selected li span {
  vertical-align: middle !important;
}
.has_selected li img:first-of-type {
  width: 14px !important;
  vertical-align: middle !important;
  margin-right: 5px !important;
}
.has_selected li img:last-of-type {
  float: right !important;
  margin-top: 2px !important;
  width: 14px !important;
}
el-radio-group {
  padding: 20px 0 !important;
}
.approver_content {
  padding-bottom: 10px !important;
  border-bottom: 1px solid #f2f2f2 !important;
}
.approver_content .el-radio,
.approver_some .el-radio,
.approver_self_select .el-radio {
  width: 27% !important;
  margin-bottom: 20px !important;
}
.copyer_content .el-checkbox {
  margin-bottom: 20px !important;
}
.el-checkbox__label {
  font-size: 12px !important;
}
.condition_content,
.copyer_content,
.approver_self_select,
.approver_manager,
.approver_content,
.approver_some {
  padding: 20px 20px 0 !important;
}
.approver_manager p:first-of-type,
.approver_some p {
  line-height: 19px !important;
  font-size: 14px !important;
  margin-bottom: 14px !important;
}

.approver_manager p {
  line-height: 32px !important;
}
.approver_manager select {
  width: 420px !important;
  height: 32px !important;
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 4px !important;
  border: 1px solid rgba(217, 217, 217, 1) !important;
}
.approver_manager p.tip {
  margin: 10px 0 22px 0 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #f8642d !important;
}
.approver_self {
  padding: 28px 20px !important;
}
.selected_list {
  margin-bottom: 20px !important;
  line-height: 30px !important;
}
.selected_list span {
  margin-right: 10px !important;
  padding: 3px 6px 3px 9px !important;
  line-height: 12px !important;
  white-space: nowrap !important;
  border-radius: 2px !important;
  border: 1px solid rgba(220, 220, 220, 1) !important;
}
.selected_list img {
  margin-left: 5px !important;
  width: 7px !important;
  height: 7px !important;
  cursor: pointer !important;
}
.approver_self_select h3 {
  margin: 5px 0 20px !important;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 19px !important;
}
.condition_copyer .el-drawer__body .priority_level {
  position: absolute !important;
  top: 11px !important;
  right: 30px !important;
  width: 100px !important;
  height: 32px !important;
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 4px !important;
  border: 1px solid rgba(217, 217, 217, 1) !important;
}
.condition_content p.tip {
  margin: 20px 0 !important;
  width: 510px !important;
  text-indent: 17px !important;
  line-height: 45px !important;
  background: rgba(241, 249, 255, 1) !important;
  border: 1px solid rgba(64, 163, 247, 1) !important;
  color: #46a6fe !important;
  font-size: 14px !important;
}
.condition_content ul {
  max-height: 650px !important;
  overflow-y: scroll !important;
  margin-bottom: 20px !important;
}
.condition_content li > span {
  float: left !important;
  margin-right: 8px !important;
  width: 70px !important;
  line-height: 32px !important;
  text-align: right !important;
}
.condition_content li > div {
  display: inline-block !important;
  width: 370px !important;
}
.condition_content li:not(:last-child) > div > p {
  margin-bottom: 20px !important;
}
.condition_content li > div > p:not(:last-child) {
  margin-bottom: 10px !important;
}
.condition_content li > a {
  float: right !important;
  margin-right: 10px !important;
  margin-top: 7px !important;
}
.condition_content li select,
.condition_content li input {
  width: 100% !important;
  height: 32px !important;
  background: rgba(255, 255, 255, 1) !important;
  border-radius: 4px !important;
  border: 1px solid rgba(217, 217, 217, 1) !important;
}
.condition_content li select + input {
  width: 260px !important;
}
.condition_content li select {
  margin-right: 10px !important;
  width: 100px !important;
}
.condition_content li p.selected_list {
  padding-left: 10px !important;
  border-radius: 4px !important;
  min-height: 32px !important;
  border: 1px solid rgba(217, 217, 217, 1) !important;
}
.condition_content li p.check_box {
  line-height: 32px !important;
}
.condition_list .el-dialog__body {
  padding: 16px 26px !important;
}
.condition_list p {
  color: #666666 !important;
  margin-bottom: 10px !important;
}
.condition_list p.check_box {
  margin-bottom: 0 !important;
  line-height: 36px !important;
}
.demo-drawer__content {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

.drawer_content {
  flex: 1 !important;
}

.demo-drawer__content > div {
  border-top: 1px solid #f2f2f2 !important;
}
.demo-drawer__footer {
  padding: 10px 30px;
  border-top: 1px solid #f2f2f2 !important;
}

.demo-drawer__footer .el-button {
  float: right !important;
  margin-right: 10px !important;
}
.el-drawer__header {
  margin-bottom: 0 !important;
  padding: 14px 0 14px 20px !important;
  /* border-bottom: 1px solid #f2f2f2; */
  color: #323232 !important;
  font-size: 16px !important;
}
.el-drawer__header button.el-drawer__close-btn {
  display: none !important;
}
.demo-drawer__footer {
  padding: 10px 30px !important;
  border-top: 1px solid #f2f2f2 !important;
}

.demo-drawer__footer .el-button {
  float: right !important;
  margin-right: 10px !important;
}
</style>
<style scoped>
a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
.clear:before,
.clear:after {
  content: " ";
  display: table;
}
.clear:after {
  clear: both;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.l {
  float: left;
}
input {
  text-indent: 10px;
}
select {
  text-indent: 8px;
}
.ml_10 {
  margin-left: 10px;
}
.mr_10 {
  margin-right: 10px;
}
.radio_box a,
.check_box a {
  font-size: 12px;
  position: relative;
  padding-left: 20px;
  margin-right: 30px;
  cursor: pointer;
  color: #333;
  white-space: pre;
}
.check_box.not a:hover {
  color: #333;
}
.check_box.not a::before,
.check_box.not a:hover::before {
  border: none;
}
.check_box.not.active {
  background: #f3f3f3;
}
.radio_box a:hover::before,
.check_box a:hover::before {
  border: 1px solid #46a6fe;
}
.radio_box a::before,
.check_box a::before {
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  left: 0;
  top: 1px;
  content: "";
}
.radio_box a::before {
  border-radius: 50%;
}
.check-dot.active::after,
.radio_box a.active::after,
.check_box a.active::after {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  content: "";
}
.radio_box a.active::after {
  background: #46a6fe;
}
.check_box a.active::after {
  background: url(~@/assets/images/check_box.png) no-repeat center;
}

.error-modal-list {
  width: 455px;
}
body {
  background: #eee;
}

.browsers-guide {
  position: absolute;
  left: 50%;
  width: 800px;
  padding: 0 25px;
  margin-left: -400px;
  top: 100px;
  height: auto;
}

.browsers-guide .headline {
  font-family: PingHei, Lucida Grande, Lucida Sans Unicode, STHeitiSC, Helvetica,
    Arial, Verdana, "sans-serif";
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  cursor: default;
  color: #333;
  text-align: center;
}

.browsers-guide .dock {
  margin-top: 60px;
  overflow: hidden;
}

.browsers-guide .browser {
  display: block;
  float: left;
  width: 250px;
  text-align: center;
}

.browsers-guide .browser img {
  border: none;
  width: 90px;
  height: 90px;
}

.browsers-guide .browser span {
  display: block;
  font-size: 14px;
  margin-top: 30px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  color: #aaa;
}

.browsers-guide .browser:hover span {
  color: #333;
}

@font-face {
  font-family: Chinese Quote;
  src: local("PingFang SC"), local("SimSun");
  unicode-range: u+2018, u+2019, u+201c, u+201d;
}

body,
html {
  width: 100%;
  /* height: 100% */
}

input::-ms-clear,
input::-ms-reveal {
  display: none;
}

*,
:after,
:before {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@-ms-viewport {
  width: device-width;
}

article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
}

[tabindex="-1"]:focus {
  outline: none !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

p {
  margin-top: 0;
  margin-bottom: 1em;
}

abbr[data-original-title],
abbr[title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}

address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}

input[type="number"],
input[type="password"],
input[type="text"],
textarea {
  -webkit-appearance: none;
}

dl,
ol,
ul {
  margin-top: 0;
  margin-bottom: 1em;
}

ol ol,
ol ul,
ul ol,
ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1em;
}

dfn {
  font-style: italic;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #1890ff;
  background-color: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}

a:focus {
  text-decoration: underline;
  text-decoration-skip: auto;
}

a:hover {
  color: #40a9ff;
}

a:active {
  color: #096dd9;
}

a:active,
a:hover {
  outline: 0;
  text-decoration: none;
}

a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}

code,
kbd,
pre,
samp {
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier,
    monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}

figure {
  margin: 0 0 1em;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg:not(:root) {
  overflow: hidden;
}

[role="button"],
a,
area,
button,
input:not([type="range"]),
label,
select,
summary,
textarea {
  touch-action: manipulation;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[type="reset"],
[type="submit"],
button,
html [type="button"] {
  -webkit-appearance: button;
}

[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="date"],
input[type="datetime-local"],
input[type="month"],
input[type="time"] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5em;
  font-size: 1.5em;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

mark {
  padding: 0.2em;
  background-color: #feffe6;
}

::selection {
  background: #1890ff;
  color: #fff;
}

.clearfix {
  zoom: 1;
}

.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

@font-face {
  font-family: anticon;
  font-display: fallback;
  src: url("https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.eot");
  src: url("https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.woff")
      format("woff"),
    url("https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.ttf")
      format("truetype"),
    url("https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.svg#iconfont")
      format("svg");
}

.anticon {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon:before {
  display: block;
  font-family: anticon !important;
}

.anticon-step-forward:before {
  content: "\E600";
}

.anticon-step-backward:before {
  content: "\E601";
}

.anticon-forward:before {
  content: "\E602";
}

.anticon-backward:before {
  content: "\E603";
}

.anticon-caret-right:before {
  content: "\E604";
}

.anticon-caret-left:before {
  content: "\E605";
}

.anticon-caret-down:before {
  content: "\E606";
}

.anticon-caret-up:before {
  content: "\E607";
}

.anticon-caret-circle-right:before,
.anticon-circle-right:before,
.anticon-right-circle:before {
  content: "\E608";
}

.anticon-caret-circle-left:before,
.anticon-circle-left:before,
.anticon-left-circle:before {
  content: "\E609";
}

.anticon-caret-circle-up:before,
.anticon-circle-up:before,
.anticon-up-circle:before {
  content: "\E60A";
}

.anticon-caret-circle-down:before,
.anticon-circle-down:before,
.anticon-down-circle:before {
  content: "\E60B";
}

.anticon-right-circle-o:before {
  content: "\E60C";
}

.anticon-caret-circle-o-right:before,
.anticon-circle-o-right:before {
  content: "\E60C";
}

.anticon-left-circle-o:before {
  content: "\E60D";
}

.anticon-caret-circle-o-left:before,
.anticon-circle-o-left:before {
  content: "\E60D";
}

.anticon-up-circle-o:before {
  content: "\E60E";
}

.anticon-caret-circle-o-up:before,
.anticon-circle-o-up:before {
  content: "\E60E";
}

.anticon-down-circle-o:before {
  content: "\E60F";
}

.anticon-caret-circle-o-down:before,
.anticon-circle-o-down:before {
  content: "\E60F";
}

.anticon-verticle-left:before {
  content: "\E610";
}

.anticon-verticle-right:before {
  content: "\E611";
}

.anticon-rollback:before {
  content: "\E612";
}

.anticon-retweet:before {
  content: "\E613";
}

.anticon-shrink:before {
  content: "\E614";
}

.anticon-arrow-salt:before,
.anticon-arrows-alt:before {
  content: "\E615";
}

.anticon-reload:before {
  content: "\E616";
}

.anticon-double-right:before {
  content: "\E617";
}

.anticon-double-left:before {
  content: "\E618";
}

.anticon-arrow-down:before {
  content: "\E619";
}

.anticon-arrow-up:before {
  content: "\E61A";
}

.anticon-arrow-right:before {
  content: "\E61B";
}

.anticon-arrow-left:before {
  content: "\E61C";
}

.anticon-down:before {
  content: "\E61D";
}

.anticon-up:before {
  content: "\E61E";
}

.anticon-right:before {
  content: "\E61F";
}

.anticon-left:before {
  content: "\E620";
}

.anticon-minus-square-o:before {
  content: "\E621";
}

.anticon-minus-circle:before {
  content: "\E622";
}

.anticon-minus-circle-o:before {
  content: "\E623";
}

.anticon-minus:before {
  content: "\E624";
}

.anticon-plus-circle-o:before {
  content: "\E625";
}

.anticon-plus-circle:before {
  content: "\E626";
}

.anticon-plus:before {
  content: "\E627";
}

.anticon-info-circle:before {
  content: "\E628";
}

.anticon-info-circle-o:before {
  content: "\E629";
}

.anticon-info:before {
  content: "\E62A";
}

.anticon-exclamation:before {
  content: "\E62B";
}

.anticon-exclamation-circle:before {
  content: "\E62C";
}

.anticon-exclamation-circle-o:before {
  content: "\E62D";
}

.anticon-close-circle:before,
.anticon-cross-circle:before {
  content: "\E62E";
}

.anticon-close-circle-o:before,
.anticon-cross-circle-o:before {
  content: "\E62F";
}

.anticon-check-circle:before {
  content: "\E630";
}

.anticon-check-circle-o:before {
  content: "\E631";
}

.anticon-check:before {
  content: "\E632";
}

.anticon-close:before,
.anticon-cross:before {
  content: "\E633";
}

.anticon-customer-service:before,
.anticon-customerservice:before {
  content: "\E634";
}

.anticon-credit-card:before {
  content: "\E635";
}

.anticon-code-o:before {
  content: "\E636";
}

.anticon-book:before {
  content: "\E637";
}

.anticon-bars:before {
  content: "\E639";
}

.anticon-question:before {
  content: "\E63A";
}

.anticon-question-circle:before {
  content: "\E63B";
}

.anticon-question-circle-o:before {
  content: "\E63C";
}

.anticon-pause:before {
  content: "\E63D";
}

.anticon-pause-circle:before {
  content: "\E63E";
}

.anticon-pause-circle-o:before {
  content: "\E63F";
}

.anticon-clock-circle:before {
  content: "\E640";
}

.anticon-clock-circle-o:before {
  content: "\E641";
}

.anticon-swap:before {
  content: "\E642";
}

.anticon-swap-left:before {
  content: "\E643";
}

.anticon-swap-right:before {
  content: "\E644";
}

.anticon-plus-square-o:before {
  content: "\E645";
}

.anticon-frown-circle:before,
.anticon-frown:before {
  content: "\E646";
}

.anticon-ellipsis:before {
  content: "\E647";
}

.anticon-copy:before {
  content: "\E648";
}

.anticon-menu-fold:before {
  content: "\E9AC";
}

.anticon-mail:before {
  content: "\E659";
}

.anticon-logout:before {
  content: "\E65A";
}

.anticon-link:before {
  content: "\E65B";
}

.anticon-area-chart:before {
  content: "\E65C";
}

.anticon-line-chart:before {
  content: "\E65D";
}

.anticon-home:before {
  content: "\E65E";
}

.anticon-laptop:before {
  content: "\E65F";
}

.anticon-star:before {
  content: "\E660";
}

.anticon-star-o:before {
  content: "\E661";
}

.anticon-folder:before {
  content: "\E662";
}

.anticon-filter:before {
  content: "\E663";
}

.anticon-file:before {
  content: "\E664";
}

.anticon-exception:before {
  content: "\E665";
}

.anticon-meh-circle:before,
.anticon-meh:before {
  content: "\E666";
}

.anticon-meh-o:before {
  content: "\E667";
}

.anticon-shopping-cart:before {
  content: "\E668";
}

.anticon-save:before {
  content: "\E669";
}

.anticon-user:before {
  content: "\E66A";
}

.anticon-video-camera:before {
  content: "\E66B";
}

.anticon-to-top:before {
  content: "\E66C";
}

.anticon-team:before {
  content: "\E66D";
}

.anticon-tablet:before {
  content: "\E66E";
}

.anticon-solution:before {
  content: "\E66F";
}

.anticon-search:before {
  content: "\E670";
}

.anticon-share-alt:before {
  content: "\E671";
}

.anticon-setting:before {
  content: "\E672";
}

.anticon-poweroff:before {
  content: "\E6D5";
}

.anticon-picture:before {
  content: "\E674";
}

.anticon-phone:before {
  content: "\E675";
}

.anticon-paper-clip:before {
  content: "\E676";
}

.anticon-notification:before {
  content: "\E677";
}

.anticon-mobile:before {
  content: "\E678";
}

.anticon-menu-unfold:before {
  content: "\E9AD";
}

.anticon-inbox:before {
  content: "\E67A";
}

.anticon-lock:before {
  content: "\E67B";
}

.anticon-qrcode:before {
  content: "\E67C";
}

.anticon-play-circle:before {
  content: "\E6D0";
}

.anticon-play-circle-o:before {
  content: "\E6D1";
}

.anticon-tag:before {
  content: "\E6D2";
}

.anticon-tag-o:before {
  content: "\E6D3";
}

.anticon-tags:before {
  content: "\E67D";
}

.anticon-tags-o:before {
  content: "\E67E";
}

.anticon-cloud-o:before {
  content: "\E67F";
}

.anticon-cloud:before {
  content: "\E680";
}

.anticon-cloud-upload:before {
  content: "\E681";
}

.anticon-cloud-download:before {
  content: "\E682";
}

.anticon-cloud-download-o:before {
  content: "\E683";
}

.anticon-cloud-upload-o:before {
  content: "\E684";
}

.anticon-environment:before {
  content: "\E685";
}

.anticon-environment-o:before {
  content: "\E686";
}

.anticon-eye:before {
  content: "\E687";
}

.anticon-eye-o:before {
  content: "\E688";
}

.anticon-camera:before {
  content: "\E689";
}

.anticon-camera-o:before {
  content: "\E68A";
}

.anticon-windows:before {
  content: "\E68B";
}

.anticon-apple:before {
  content: "\E68C";
}

.anticon-apple-o:before {
  content: "\E6D4";
}

.anticon-android:before {
  content: "\E938";
}

.anticon-android-o:before {
  content: "\E68D";
}

.anticon-aliwangwang:before {
  content: "\E68E";
}

.anticon-aliwangwang-o:before {
  content: "\E68F";
}

.anticon-export:before {
  content: "\E691";
}

.anticon-edit:before {
  content: "\E692";
}

.anticon-appstore-o:before {
  content: "\E695";
}

.anticon-appstore:before {
  content: "\E696";
}

.anticon-scan:before {
  content: "\E697";
}

.anticon-file-text:before {
  content: "\E698";
}

.anticon-folder-open:before {
  content: "\E699";
}

.anticon-hdd:before {
  content: "\E69A";
}

.anticon-ie:before {
  content: "\E69B";
}

.anticon-file-jpg:before {
  content: "\E69C";
}

.anticon-like:before {
  content: "\E64C";
}

.anticon-like-o:before {
  content: "\E69D";
}

.anticon-dislike:before {
  content: "\E64B";
}

.anticon-dislike-o:before {
  content: "\E69E";
}

.anticon-delete:before {
  content: "\E69F";
}

.anticon-enter:before {
  content: "\E6A0";
}

.anticon-pushpin-o:before {
  content: "\E6A1";
}

.anticon-pushpin:before {
  content: "\E6A2";
}

.anticon-heart:before {
  content: "\E6A3";
}

.anticon-heart-o:before {
  content: "\E6A4";
}

.anticon-pay-circle:before {
  content: "\E6A5";
}

.anticon-pay-circle-o:before {
  content: "\E6A6";
}

.anticon-smile-circle:before,
.anticon-smile:before {
  content: "\E6A7";
}

.anticon-smile-o:before {
  content: "\E6A8";
}

.anticon-frown-o:before {
  content: "\E6A9";
}

.anticon-calculator:before {
  content: "\E6AA";
}

.anticon-message:before {
  content: "\E6AB";
}

.anticon-chrome:before {
  content: "\E6AC";
}

.anticon-github:before {
  content: "\E6AD";
}

.anticon-file-unknown:before {
  content: "\E6AF";
}

.anticon-file-excel:before {
  content: "\E6B0";
}

.anticon-file-ppt:before {
  content: "\E6B1";
}

.anticon-file-word:before {
  content: "\E6B2";
}

.anticon-file-pdf:before {
  content: "\E6B3";
}

.anticon-desktop:before {
  content: "\E6B4";
}

.anticon-upload:before {
  content: "\E6B6";
}

.anticon-download:before {
  content: "\E6B7";
}

.anticon-pie-chart:before {
  content: "\E6B8";
}

.anticon-unlock:before {
  content: "\E6BA";
}

.anticon-calendar:before {
  content: "\E6BB";
}

.anticon-windows-o:before {
  content: "\E6BC";
}

.anticon-dot-chart:before {
  content: "\E6BD";
}

.anticon-bar-chart:before {
  content: "\E6BE";
}

.anticon-code:before {
  content: "\E6BF";
}

.anticon-api:before {
  content: "\E951";
}

.anticon-plus-square:before {
  content: "\E6C0";
}

.anticon-minus-square:before {
  content: "\E6C1";
}

.anticon-close-square:before {
  content: "\E6C2";
}

.anticon-close-square-o:before {
  content: "\E6C3";
}

.anticon-check-square:before {
  content: "\E6C4";
}

.anticon-check-square-o:before {
  content: "\E6C5";
}

.anticon-fast-backward:before {
  content: "\E6C6";
}

.anticon-fast-forward:before {
  content: "\E6C7";
}

.anticon-up-square:before {
  content: "\E6C8";
}

.anticon-down-square:before {
  content: "\E6C9";
}

.anticon-left-square:before {
  content: "\E6CA";
}

.anticon-right-square:before {
  content: "\E6CB";
}

.anticon-right-square-o:before {
  content: "\E6CC";
}

.anticon-left-square-o:before {
  content: "\E6CD";
}

.anticon-down-square-o:before {
  content: "\E6CE";
}

.anticon-up-square-o:before {
  content: "\E6CF";
}

.anticon-loading:before {
  content: "\E64D";
}

.anticon-loading-3-quarters:before {
  content: "\E6AE";
}

.anticon-bulb:before {
  content: "\E649";
}

.anticon-select:before {
  content: "\E64A";
}

.anticon-addfile:before,
.anticon-file-add:before {
  content: "\E910";
}

.anticon-addfolder:before,
.anticon-folder-add:before {
  content: "\E914";
}

.anticon-switcher:before {
  content: "\E913";
}

.anticon-rocket:before {
  content: "\E90F";
}

.anticon-dingding:before {
  content: "\E923";
}

.anticon-dingding-o:before {
  content: "\E925";
}

.anticon-bell:before {
  content: "\E64E";
}

.anticon-disconnect:before {
  content: "\E64F";
}

.anticon-database:before {
  content: "\E650";
}

.anticon-compass:before {
  content: "\E6DB";
}

.anticon-barcode:before {
  content: "\E652";
}

.anticon-hourglass:before {
  content: "\E653";
}

.anticon-key:before {
  content: "\E654";
}

.anticon-flag:before {
  content: "\E655";
}

.anticon-layout:before {
  content: "\E656";
}

.anticon-login:before {
  content: "\E657";
}

.anticon-printer:before {
  content: "\E673";
}

.anticon-sound:before {
  content: "\E6E9";
}

.anticon-usb:before {
  content: "\E6D7";
}

.anticon-skin:before {
  content: "\E6D8";
}

.anticon-tool:before {
  content: "\E6D9";
}

.anticon-sync:before {
  content: "\E6DA";
}

.anticon-wifi:before {
  content: "\E6D6";
}

.anticon-car:before {
  content: "\E6DC";
}

.anticon-copyright:before {
  content: "\E6DE";
}

.anticon-schedule:before {
  content: "\E6DF";
}

.anticon-user-add:before {
  content: "\E6ED";
}

.anticon-user-delete:before {
  content: "\E6E0";
}

.anticon-usergroup-add:before {
  content: "\E6DD";
}

.anticon-usergroup-delete:before {
  content: "\E6E1";
}

.anticon-man:before {
  content: "\E6E2";
}

.anticon-woman:before {
  content: "\E6EC";
}

.anticon-shop:before {
  content: "\E6E3";
}

.anticon-gift:before {
  content: "\E6E4";
}

.anticon-idcard:before {
  content: "\E6E5";
}

.anticon-medicine-box:before {
  content: "\E6E6";
}

.anticon-red-envelope:before {
  content: "\E6E7";
}

.anticon-coffee:before {
  content: "\E6E8";
}

.anticon-trademark:before {
  content: "\E651";
}

.anticon-safety:before {
  content: "\E6EA";
}

.anticon-wallet:before {
  content: "\E6EB";
}

.anticon-bank:before {
  content: "\E6EE";
}

.anticon-trophy:before {
  content: "\E6EF";
}

.anticon-contacts:before {
  content: "\E6F0";
}

.anticon-global:before {
  content: "\E6F1";
}

.anticon-shake:before {
  content: "\E94F";
}

.anticon-fork:before {
  content: "\E6F2";
}

.anticon-dashboard:before {
  content: "\E99A";
}

.anticon-profile:before {
  content: "\E999";
}

.anticon-table:before {
  content: "\E998";
}

.anticon-warning:before {
  content: "\E997";
}

.anticon-form:before {
  content: "\E996";
}

.anticon-spin:before {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}

.anticon-weibo-square:before {
  content: "\E6F5";
}

.anticon-weibo-circle:before {
  content: "\E6F4";
}

.anticon-taobao-circle:before {
  content: "\E6F3";
}

.anticon-html5:before {
  content: "\E9C7";
}

.anticon-weibo:before {
  content: "\E9C6";
}

.anticon-twitter:before {
  content: "\E9C5";
}

.anticon-wechat:before {
  content: "\E9C4";
}

.anticon-youtube:before {
  content: "\E9C3";
}

.anticon-alipay-circle:before {
  content: "\E9C2";
}

.anticon-taobao:before {
  content: "\E9C1";
}

.anticon-skype:before {
  content: "\E9C0";
}

.anticon-qq:before {
  content: "\E9BF";
}

.anticon-medium-workmark:before {
  content: "\E9BE";
}

.anticon-gitlab:before {
  content: "\E9BD";
}

.anticon-medium:before {
  content: "\E9BC";
}

.anticon-linkedin:before {
  content: "\E9BB";
}

.anticon-google-plus:before {
  content: "\E9BA";
}

.anticon-dropbox:before {
  content: "\E9B9";
}

.anticon-facebook:before {
  content: "\E9B8";
}

.anticon-codepen:before {
  content: "\E9B7";
}

.anticon-amazon:before {
  content: "\E9B6";
}

.anticon-google:before {
  content: "\E9B5";
}

.anticon-codepen-circle:before {
  content: "\E9B4";
}

.anticon-alipay:before {
  content: "\E9B3";
}

.anticon-ant-design:before {
  content: "\E9B2";
}

.anticon-aliyun:before {
  content: "\E9F4";
}

.anticon-zhihu:before {
  content: "\E703";
}

.anticon-file-markdown:before {
  content: "\E704";
}

.anticon-slack:before {
  content: "\E705";
}

.anticon-slack-square:before {
  content: "\E706";
}

.anticon-behance:before {
  content: "\E707";
}

.anticon-behance-square:before {
  content: "\E708";
}

.anticon-dribbble:before {
  content: "\E709";
}

.anticon-dribbble-square:before {
  content: "\E70A";
}

.anticon-instagram:before {
  content: "\E70B";
}

.anticon-yuque:before {
  content: "\E70C";
}

.fade-appear,
.fade-enter,
.fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.fade-appear.fade-appear-active,
.fade-enter.fade-enter-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}

.fade-leave.fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}

.fade-appear,
.fade-enter {
  opacity: 0;
}

.fade-appear,
.fade-enter,
.fade-leave {
  animation-timing-function: linear;
}

@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.move-up-appear,
.move-up-enter,
.move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.move-up-appear.move-up-appear-active,
.move-up-enter.move-up-enter-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}

.move-up-leave.move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.move-up-appear,
.move-up-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.move-down-appear,
.move-down-enter,
.move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.move-down-appear.move-down-appear-active,
.move-down-enter.move-down-enter-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}

.move-down-leave.move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.move-down-appear,
.move-down-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.move-left-appear,
.move-left-enter,
.move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.move-left-appear.move-left-appear-active,
.move-left-enter.move-left-enter-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}

.move-left-leave.move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.move-left-appear,
.move-left-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

.move-right-appear,
.move-right-enter,
.move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.move-right-appear.move-right-appear-active,
.move-right-enter.move-right-enter-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}

.move-right-leave.move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.move-right-appear,
.move-right-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}

@keyframes antMoveDownIn {
  0% {
    transform-origin: 0 0;
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes antMoveDownOut {
  0% {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform-origin: 0 0;
    transform: translateY(100%);
    opacity: 0;
  }
}

@keyframes antMoveLeftIn {
  0% {
    transform-origin: 0 0;
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform-origin: 0 0;
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes antMoveLeftOut {
  0% {
    transform-origin: 0 0;
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform-origin: 0 0;
    transform: translateX(-100%);
    opacity: 0;
  }
}

@keyframes antMoveRightIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform-origin: 0 0;
    transform: translateX(0);
  }
}

@keyframes antMoveRightOut {
  0% {
    transform-origin: 0 0;
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform-origin: 0 0;
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes antMoveUpIn {
  0% {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes antMoveUpOut {
  0% {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
}

@keyframes loadingCircle {
  to {
    transform: rotate(1turn);
  }
}

[ant-click-animating-without-extra-node],
[ant-click-animating] {
  position: relative;
}

.ant-click-animating-node,
[ant-click-animating-without-extra-node]:after {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  border-radius: inherit;
  border: 0 solid #1890ff;
  opacity: 0.4;
  animation: waveEffect 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: block;
}

@keyframes waveEffect {
  to {
    opacity: 0;
    top: -6px;
    left: -6px;
    bottom: -6px;
    right: -6px;
    border-width: 6px;
  }
}

.slide-up-appear,
.slide-up-enter,
.slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.slide-up-appear.slide-up-appear-active,
.slide-up-enter.slide-up-enter-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}

.slide-up-leave.slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.slide-up-appear,
.slide-up-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.slide-down-appear,
.slide-down-enter,
.slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.slide-down-appear.slide-down-appear-active,
.slide-down-enter.slide-down-enter-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}

.slide-down-leave.slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.slide-down-appear,
.slide-down-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.slide-left-appear,
.slide-left-enter,
.slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.slide-left-appear.slide-left-appear-active,
.slide-left-enter.slide-left-enter-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}

.slide-left-leave.slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.slide-left-appear,
.slide-left-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.slide-right-appear,
.slide-right-enter,
.slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.slide-right-appear.slide-right-appear-active,
.slide-right-enter.slide-right-enter-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}

.slide-right-leave.slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.slide-right-appear,
.slide-right-enter {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes antSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0.8);
  }
  to {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
}

@keyframes antSlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0.8);
  }
}

@keyframes antSlideDownIn {
  0% {
    opacity: 0;
    transform-origin: 100% 100%;
    transform: scaleY(0.8);
  }
  to {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: scaleY(1);
  }
}

@keyframes antSlideDownOut {
  0% {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform-origin: 100% 100%;
    transform: scaleY(0.8);
  }
}

@keyframes antSlideLeftIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleX(0.8);
  }
  to {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleX(1);
  }
}

@keyframes antSlideLeftOut {
  0% {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleX(1);
  }
  to {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleX(0.8);
  }
}

@keyframes antSlideRightIn {
  0% {
    opacity: 0;
    transform-origin: 100% 0;
    transform: scaleX(0.8);
  }
  to {
    opacity: 1;
    transform-origin: 100% 0;
    transform: scaleX(1);
  }
}

@keyframes antSlideRightOut {
  0% {
    opacity: 1;
    transform-origin: 100% 0;
    transform: scaleX(1);
  }
  to {
    opacity: 0;
    transform-origin: 100% 0;
    transform: scaleX(0.8);
  }
}

.swing-appear,
.swing-enter {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.swing-appear.swing-appear-active,
.swing-enter.swing-enter-active {
  animation-name: antSwingIn;
  animation-play-state: running;
}

@keyframes antSwingIn {
  0%,
  to {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(10px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
}

.zoom-appear,
.zoom-enter,
.zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-appear.zoom-appear-active,
.zoom-enter.zoom-enter-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}

.zoom-leave.zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-appear,
.zoom-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-big-appear,
.zoom-big-enter,
.zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-big-appear.zoom-big-appear-active,
.zoom-big-enter.zoom-big-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.zoom-big-leave.zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-big-appear,
.zoom-big-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-big-fast-appear,
.zoom-big-fast-enter,
.zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-big-fast-appear.zoom-big-fast-appear-active,
.zoom-big-fast-enter.zoom-big-fast-enter-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}

.zoom-big-fast-leave.zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-big-fast-appear,
.zoom-big-fast-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-up-appear,
.zoom-up-enter,
.zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-up-appear.zoom-up-appear-active,
.zoom-up-enter.zoom-up-enter-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}

.zoom-up-leave.zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-up-appear,
.zoom-up-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-down-appear,
.zoom-down-enter,
.zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-down-appear.zoom-down-appear-active,
.zoom-down-enter.zoom-down-enter-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}

.zoom-down-leave.zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-down-appear,
.zoom-down-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-left-appear,
.zoom-left-enter,
.zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-left-appear.zoom-left-appear-active,
.zoom-left-enter.zoom-left-enter-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}

.zoom-left-leave.zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-left-appear,
.zoom-left-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.zoom-right-appear,
.zoom-right-enter,
.zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.zoom-right-appear.zoom-right-appear-active,
.zoom-right-enter.zoom-right-enter-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}

.zoom-right-leave.zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}

.zoom-right-appear,
.zoom-right-enter {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}

.zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

@keyframes antZoomIn {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.2);
  }
}

@keyframes antZoomBigIn {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
}

@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

@keyframes antZoomUpIn {
  0% {
    opacity: 0;
    transform-origin: 50% 0;
    transform: scale(0.8);
  }
  to {
    transform-origin: 50% 0;
    transform: scale(1);
  }
}

@keyframes antZoomUpOut {
  0% {
    transform-origin: 50% 0;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform-origin: 50% 0;
    transform: scale(0.8);
  }
}

@keyframes antZoomLeftIn {
  0% {
    opacity: 0;
    transform-origin: 0 50%;
    transform: scale(0.8);
  }
  to {
    transform-origin: 0 50%;
    transform: scale(1);
  }
}

@keyframes antZoomLeftOut {
  0% {
    transform-origin: 0 50%;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform-origin: 0 50%;
    transform: scale(0.8);
  }
}

@keyframes antZoomRightIn {
  0% {
    opacity: 0;
    transform-origin: 100% 50%;
    transform: scale(0.8);
  }
  to {
    transform-origin: 100% 50%;
    transform: scale(1);
  }
}

@keyframes antZoomRightOut {
  0% {
    transform-origin: 100% 50%;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform-origin: 100% 50%;
    transform: scale(0.8);
  }
}

@keyframes antZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0.8);
  }
  to {
    transform-origin: 50% 100%;
    transform: scale(1);
  }
}

@keyframes antZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0.8);
  }
}

.ant-motion-collapse {
  overflow: hidden;
}

.ant-motion-collapse-active {
  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
    opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}

.ant-message {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: fixed;
  z-index: 1010;
  width: 100%;
  top: 16px;
  left: 0;
  pointer-events: none;
}

.ant-message-notice {
  padding: 8px;
  text-align: center;
}

.ant-message-notice:first-child {
  margin-top: -8px;
}

.ant-message-notice-content {
  padding: 10px 16px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: #fff;
  display: inline-block;
  pointer-events: all;
}

.ant-message-success .anticon {
  color: #52c41a;
}

.ant-message-error .anticon {
  color: #f5222d;
}

.ant-message-warning .anticon {
  color: #faad14;
}

.ant-message-info .anticon,
.ant-message-loading .anticon {
  color: #1890ff;
}

.ant-message .anticon {
  margin-right: 8px;
  font-size: 16px;
  top: 1px;
  position: relative;
}

.ant-message-notice.move-up-leave.move-up-leave-active {
  animation-name: MessageMoveOut;
  overflow: hidden;
  animation-duration: 0.3s;
}

@keyframes MessageMoveOut {
  0% {
    opacity: 1;
    max-height: 150px;
    padding: 8px;
  }
  to {
    opacity: 0;
    max-height: 0;
    padding: 0;
  }
}

.ant-tooltip {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  z-index: 1060;
  display: block;
  visibility: visible;
  max-width: 250px;
}

.ant-tooltip-hidden {
  display: none;
}

.ant-tooltip-placement-top,
.ant-tooltip-placement-topLeft,
.ant-tooltip-placement-topRight {
  padding-bottom: 8px;
}

.ant-tooltip-placement-right,
.ant-tooltip-placement-rightBottom,
.ant-tooltip-placement-rightTop {
  padding-left: 8px;
}

.ant-tooltip-placement-bottom,
.ant-tooltip-placement-bottomLeft,
.ant-tooltip-placement-bottomRight {
  padding-top: 8px;
}

.ant-tooltip-placement-left,
.ant-tooltip-placement-leftBottom,
.ant-tooltip-placement-leftTop {
  padding-right: 8px;
}

.ant-tooltip-inner {
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-height: 32px;
  word-break: break-all;
}

.ant-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.ant-tooltip-placement-top .ant-tooltip-arrow,
.ant-tooltip-placement-topLeft .ant-tooltip-arrow,
.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  bottom: 3px;
  border-width: 5px 5px 0;
  border-top-color: rgba(0, 0, 0, 0.75);
}

.ant-tooltip-placement-top .ant-tooltip-arrow {
  left: 50%;
  margin-left: -5px;
}

.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  left: 16px;
}

.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  right: 16px;
}

.ant-tooltip-placement-right .ant-tooltip-arrow,
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow,
.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  left: 3px;
  border-width: 5px 5px 5px 0;
  border-right-color: rgba(0, 0, 0, 0.75);
}

.ant-tooltip-placement-right .ant-tooltip-arrow {
  top: 50%;
  margin-top: -5px;
}

.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  top: 8px;
}

.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  bottom: 8px;
}

.ant-tooltip-placement-left .ant-tooltip-arrow,
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow,
.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  right: 3px;
  border-width: 5px 0 5px 5px;
  border-left-color: rgba(0, 0, 0, 0.75);
}

.ant-tooltip-placement-left .ant-tooltip-arrow {
  top: 50%;
  margin-top: -5px;
}

.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  top: 8px;
}

.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  bottom: 8px;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: 3px;
  border-width: 0 5px 5px;
  border-bottom-color: rgba(0, 0, 0, 0.75);
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  left: 50%;
  margin-left: -5px;
}

.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {
  left: 16px;
}

.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  right: 16px;
}

.ant-btn {
  line-height: 1.5;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border-color: #d9d9d9;
}

.ant-btn > .anticon {
  line-height: 1;
}

.ant-btn,
.ant-btn:active,
.ant-btn:focus {
  outline: 0;
}

.ant-btn:not([disabled]):hover {
  text-decoration: none;
}

.ant-btn:not([disabled]):active {
  outline: 0;
  transition: none;
}

.ant-btn.disabled,
.ant-btn[disabled] {
  cursor: not-allowed;
}

.ant-btn.disabled > *,
.ant-btn[disabled] > * {
  pointer-events: none;
}

.ant-btn-lg {
  padding: 0 15px;
  font-size: 16px;
  border-radius: 4px;
  height: 40px;
}

.ant-btn-sm {
  padding: 0 7px;
  font-size: 14px;
  border-radius: 4px;
  height: 24px;
}

.ant-btn > a:only-child {
  color: currentColor;
}

.ant-btn > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn:focus,
.ant-btn:hover {
  color: #40a9ff;
  background-color: #fff;
  border-color: #40a9ff;
}

.ant-btn:focus > a:only-child,
.ant-btn:hover > a:only-child {
  color: currentColor;
}

.ant-btn:focus > a:only-child:after,
.ant-btn:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn.active,
.ant-btn:active {
  color: #096dd9;
  background-color: #fff;
  border-color: #096dd9;
}

.ant-btn.active > a:only-child,
.ant-btn:active > a:only-child {
  color: currentColor;
}

.ant-btn.active > a:only-child:after,
.ant-btn:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn.disabled,
.ant-btn.disabled.active,
.ant-btn.disabled:active,
.ant-btn.disabled:focus,
.ant-btn.disabled:hover,
.ant-btn[disabled],
.ant-btn[disabled].active,
.ant-btn[disabled]:active,
.ant-btn[disabled]:focus,
.ant-btn[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn.disabled.active > a:only-child,
.ant-btn.disabled:active > a:only-child,
.ant-btn.disabled:focus > a:only-child,
.ant-btn.disabled:hover > a:only-child,
.ant-btn.disabled > a:only-child,
.ant-btn[disabled].active > a:only-child,
.ant-btn[disabled]:active > a:only-child,
.ant-btn[disabled]:focus > a:only-child,
.ant-btn[disabled]:hover > a:only-child,
.ant-btn[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn.disabled.active > a:only-child:after,
.ant-btn.disabled:active > a:only-child:after,
.ant-btn.disabled:focus > a:only-child:after,
.ant-btn.disabled:hover > a:only-child:after,
.ant-btn.disabled > a:only-child:after,
.ant-btn[disabled].active > a:only-child:after,
.ant-btn[disabled]:active > a:only-child:after,
.ant-btn[disabled]:focus > a:only-child:after,
.ant-btn[disabled]:hover > a:only-child:after,
.ant-btn[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn.active,
.ant-btn:active,
.ant-btn:focus,
.ant-btn:hover {
  background: #fff;
  text-decoration: none;
}

.ant-btn > i,
.ant-btn > span {
  pointer-events: none;
}

.ant-btn-primary {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-btn-primary > a:only-child {
  color: currentColor;
}

.ant-btn-primary > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-primary:focus,
.ant-btn-primary:hover {
  color: #fff;
  background-color: #40a9ff;
  border-color: #40a9ff;
}

.ant-btn-primary:focus > a:only-child,
.ant-btn-primary:hover > a:only-child {
  color: currentColor;
}

.ant-btn-primary:focus > a:only-child:after,
.ant-btn-primary:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-primary.active,
.ant-btn-primary:active {
  color: #fff;
  background-color: #096dd9;
  border-color: #096dd9;
}

.ant-btn-primary.active > a:only-child,
.ant-btn-primary:active > a:only-child {
  color: currentColor;
}

.ant-btn-primary.active > a:only-child:after,
.ant-btn-primary:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-primary.disabled,
.ant-btn-primary.disabled.active,
.ant-btn-primary.disabled:active,
.ant-btn-primary.disabled:focus,
.ant-btn-primary.disabled:hover,
.ant-btn-primary[disabled],
.ant-btn-primary[disabled].active,
.ant-btn-primary[disabled]:active,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-primary.disabled.active > a:only-child,
.ant-btn-primary.disabled:active > a:only-child,
.ant-btn-primary.disabled:focus > a:only-child,
.ant-btn-primary.disabled:hover > a:only-child,
.ant-btn-primary.disabled > a:only-child,
.ant-btn-primary[disabled].active > a:only-child,
.ant-btn-primary[disabled]:active > a:only-child,
.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-primary[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-primary.disabled.active > a:only-child:after,
.ant-btn-primary.disabled:active > a:only-child:after,
.ant-btn-primary.disabled:focus > a:only-child:after,
.ant-btn-primary.disabled:hover > a:only-child:after,
.ant-btn-primary.disabled > a:only-child:after,
.ant-btn-primary[disabled].active > a:only-child:after,
.ant-btn-primary[disabled]:active > a:only-child:after,
.ant-btn-primary[disabled]:focus > a:only-child:after,
.ant-btn-primary[disabled]:hover > a:only-child:after,
.ant-btn-primary[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #40a9ff;
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #d9d9d9;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary,
.ant-btn-group .ant-btn-primary:last-child:not(:first-child) {
  border-left-color: #40a9ff;
}

.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled],
.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled] {
  border-left-color: #d9d9d9;
}

.ant-btn-ghost {
  color: rgba(0, 0, 0, 0.65);
  background-color: transparent;
  border-color: #d9d9d9;
}

.ant-btn-ghost > a:only-child {
  color: currentColor;
}

.ant-btn-ghost > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-ghost:focus,
.ant-btn-ghost:hover {
  color: #40a9ff;
  background-color: transparent;
  border-color: #40a9ff;
}

.ant-btn-ghost:focus > a:only-child,
.ant-btn-ghost:hover > a:only-child {
  color: currentColor;
}

.ant-btn-ghost:focus > a:only-child:after,
.ant-btn-ghost:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-ghost.active,
.ant-btn-ghost:active {
  color: #096dd9;
  background-color: transparent;
  border-color: #096dd9;
}

.ant-btn-ghost.active > a:only-child,
.ant-btn-ghost:active > a:only-child {
  color: currentColor;
}

.ant-btn-ghost.active > a:only-child:after,
.ant-btn-ghost:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-ghost.disabled,
.ant-btn-ghost.disabled.active,
.ant-btn-ghost.disabled:active,
.ant-btn-ghost.disabled:focus,
.ant-btn-ghost.disabled:hover,
.ant-btn-ghost[disabled],
.ant-btn-ghost[disabled].active,
.ant-btn-ghost[disabled]:active,
.ant-btn-ghost[disabled]:focus,
.ant-btn-ghost[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-ghost.disabled.active > a:only-child,
.ant-btn-ghost.disabled:active > a:only-child,
.ant-btn-ghost.disabled:focus > a:only-child,
.ant-btn-ghost.disabled:hover > a:only-child,
.ant-btn-ghost.disabled > a:only-child,
.ant-btn-ghost[disabled].active > a:only-child,
.ant-btn-ghost[disabled]:active > a:only-child,
.ant-btn-ghost[disabled]:focus > a:only-child,
.ant-btn-ghost[disabled]:hover > a:only-child,
.ant-btn-ghost[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-ghost.disabled.active > a:only-child:after,
.ant-btn-ghost.disabled:active > a:only-child:after,
.ant-btn-ghost.disabled:focus > a:only-child:after,
.ant-btn-ghost.disabled:hover > a:only-child:after,
.ant-btn-ghost.disabled > a:only-child:after,
.ant-btn-ghost[disabled].active > a:only-child:after,
.ant-btn-ghost[disabled]:active > a:only-child:after,
.ant-btn-ghost[disabled]:focus > a:only-child:after,
.ant-btn-ghost[disabled]:hover > a:only-child:after,
.ant-btn-ghost[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-dashed {
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border-color: #d9d9d9;
  border-style: dashed;
}

.ant-btn-dashed > a:only-child {
  color: currentColor;
}

.ant-btn-dashed > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-dashed:focus,
.ant-btn-dashed:hover {
  color: #40a9ff;
  background-color: #fff;
  border-color: #40a9ff;
}

.ant-btn-dashed:focus > a:only-child,
.ant-btn-dashed:hover > a:only-child {
  color: currentColor;
}

.ant-btn-dashed:focus > a:only-child:after,
.ant-btn-dashed:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-dashed.active,
.ant-btn-dashed:active {
  color: #096dd9;
  background-color: #fff;
  border-color: #096dd9;
}

.ant-btn-dashed.active > a:only-child,
.ant-btn-dashed:active > a:only-child {
  color: currentColor;
}

.ant-btn-dashed.active > a:only-child:after,
.ant-btn-dashed:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-dashed.disabled,
.ant-btn-dashed.disabled.active,
.ant-btn-dashed.disabled:active,
.ant-btn-dashed.disabled:focus,
.ant-btn-dashed.disabled:hover,
.ant-btn-dashed[disabled],
.ant-btn-dashed[disabled].active,
.ant-btn-dashed[disabled]:active,
.ant-btn-dashed[disabled]:focus,
.ant-btn-dashed[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-dashed.disabled.active > a:only-child,
.ant-btn-dashed.disabled:active > a:only-child,
.ant-btn-dashed.disabled:focus > a:only-child,
.ant-btn-dashed.disabled:hover > a:only-child,
.ant-btn-dashed.disabled > a:only-child,
.ant-btn-dashed[disabled].active > a:only-child,
.ant-btn-dashed[disabled]:active > a:only-child,
.ant-btn-dashed[disabled]:focus > a:only-child,
.ant-btn-dashed[disabled]:hover > a:only-child,
.ant-btn-dashed[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-dashed.disabled.active > a:only-child:after,
.ant-btn-dashed.disabled:active > a:only-child:after,
.ant-btn-dashed.disabled:focus > a:only-child:after,
.ant-btn-dashed.disabled:hover > a:only-child:after,
.ant-btn-dashed.disabled > a:only-child:after,
.ant-btn-dashed[disabled].active > a:only-child:after,
.ant-btn-dashed[disabled]:active > a:only-child:after,
.ant-btn-dashed[disabled]:focus > a:only-child:after,
.ant-btn-dashed[disabled]:hover > a:only-child:after,
.ant-btn-dashed[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-danger {
  color: #f5222d;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-danger > a:only-child {
  color: currentColor;
}

.ant-btn-danger > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-danger:hover {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
}

.ant-btn-danger:hover > a:only-child {
  color: currentColor;
}

.ant-btn-danger:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-danger:focus {
  color: #ff4d4f;
  background-color: #fff;
  border-color: #ff4d4f;
}

.ant-btn-danger:focus > a:only-child {
  color: currentColor;
}

.ant-btn-danger:focus > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-danger.active,
.ant-btn-danger:active {
  color: #fff;
  background-color: #cf1322;
  border-color: #cf1322;
}

.ant-btn-danger.active > a:only-child,
.ant-btn-danger:active > a:only-child {
  color: currentColor;
}

.ant-btn-danger.active > a:only-child:after,
.ant-btn-danger:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-danger.disabled,
.ant-btn-danger.disabled.active,
.ant-btn-danger.disabled:active,
.ant-btn-danger.disabled:focus,
.ant-btn-danger.disabled:hover,
.ant-btn-danger[disabled],
.ant-btn-danger[disabled].active,
.ant-btn-danger[disabled]:active,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-danger.disabled.active > a:only-child,
.ant-btn-danger.disabled:active > a:only-child,
.ant-btn-danger.disabled:focus > a:only-child,
.ant-btn-danger.disabled:hover > a:only-child,
.ant-btn-danger.disabled > a:only-child,
.ant-btn-danger[disabled].active > a:only-child,
.ant-btn-danger[disabled]:active > a:only-child,
.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-danger[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-danger.disabled.active > a:only-child:after,
.ant-btn-danger.disabled:active > a:only-child:after,
.ant-btn-danger.disabled:focus > a:only-child:after,
.ant-btn-danger.disabled:hover > a:only-child:after,
.ant-btn-danger.disabled > a:only-child:after,
.ant-btn-danger[disabled].active > a:only-child:after,
.ant-btn-danger[disabled]:active > a:only-child:after,
.ant-btn-danger[disabled]:focus > a:only-child:after,
.ant-btn-danger[disabled]:hover > a:only-child:after,
.ant-btn-danger[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-circle,
.ant-btn-circle-outline {
  width: 32px;
  padding: 0;
  font-size: 16px;
  border-radius: 50%;
  height: 32px;
}

.ant-btn-circle-outline.ant-btn-lg,
.ant-btn-circle.ant-btn-lg {
  width: 40px;
  padding: 0;
  font-size: 18px;
  border-radius: 50%;
  height: 40px;
}

.ant-btn-circle-outline.ant-btn-sm,
.ant-btn-circle.ant-btn-sm {
  width: 24px;
  padding: 0;
  font-size: 14px;
  border-radius: 50%;
  height: 24px;
}

.ant-btn:before {
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  background: #fff;
  opacity: 0.35;
  content: "";
  border-radius: inherit;
  z-index: 1;
  transition: opacity 0.2s;
  pointer-events: none;
  display: none;
}

.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn.ant-btn-loading:before {
  display: block;
}

.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(
    .ant-btn-icon-only
  ) {
  padding-left: 29px;
  pointer-events: none;
  position: relative;
}

.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(
    .ant-btn-icon-only
  )
  .anticon {
  margin-left: -14px;
}

.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(
    .ant-btn-circle-outline
  ):not(.ant-btn-icon-only) {
  padding-left: 24px;
}

.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(
    .ant-btn-circle-outline
  ):not(.ant-btn-icon-only)
  .anticon {
  margin-left: -17px;
}

.ant-btn-group {
  position: relative;
  display: inline-block;
}

.ant-btn-group > .ant-btn,
.ant-btn-group > span > .ant-btn {
  position: relative;
  line-height: 30px;
}

.ant-btn-group > .ant-btn.active,
.ant-btn-group > .ant-btn:active,
.ant-btn-group > .ant-btn:focus,
.ant-btn-group > .ant-btn:hover,
.ant-btn-group > span > .ant-btn.active,
.ant-btn-group > span > .ant-btn:active,
.ant-btn-group > span > .ant-btn:focus,
.ant-btn-group > span > .ant-btn:hover {
  z-index: 2;
}

.ant-btn-group > .ant-btn:disabled,
.ant-btn-group > span > .ant-btn:disabled {
  z-index: 0;
}

.ant-btn-group-lg > .ant-btn,
.ant-btn-group-lg > span > .ant-btn {
  padding: 0 15px;
  font-size: 16px;
  border-radius: 0;
  height: 40px;
  line-height: 38px;
}

.ant-btn-group-sm > .ant-btn,
.ant-btn-group-sm > span > .ant-btn {
  padding: 0 7px;
  font-size: 14px;
  border-radius: 0;
  height: 24px;
  line-height: 22px;
}

.ant-btn-group-sm > .ant-btn > .anticon,
.ant-btn-group-sm > span > .ant-btn > .anticon {
  font-size: 14px;
}

.ant-btn + .ant-btn-group,
.ant-btn-group + .ant-btn,
.ant-btn-group + .ant-btn-group,
.ant-btn-group .ant-btn + .ant-btn,
.ant-btn-group .ant-btn + span,
.ant-btn-group > span + span,
.ant-btn-group span + .ant-btn {
  margin-left: -1px;
}

.ant-btn-group
  .ant-btn-primary
  + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}

.ant-btn-group .ant-btn {
  border-radius: 0;
}

.ant-btn-group > .ant-btn:first-child,
.ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}

.ant-btn-group > .ant-btn:only-child,
.ant-btn-group > span:only-child > .ant-btn {
  border-radius: 4px;
}

.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.ant-btn-group-sm > .ant-btn:only-child,
.ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 4px;
}

.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.ant-btn-group > .ant-btn-group {
  float: left;
}

.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}

.ant-btn-group
  > .ant-btn-group:first-child:not(:last-child)
  > .ant-btn:last-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  padding-right: 8px;
}

.ant-btn-group
  > .ant-btn-group:last-child:not(:first-child)
  > .ant-btn:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding-left: 8px;
}

.ant-btn:not(.ant-btn-circle):not(.ant-btn-circle-outline).ant-btn-icon-only {
  padding-left: 8px;
  padding-right: 8px;
}

.ant-btn:active > span,
.ant-btn:focus > span {
  position: relative;
}

.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 8px;
}

.ant-btn-background-ghost {
  background: transparent !important;
  border-color: #fff;
  color: #fff;
}

.ant-btn-background-ghost.ant-btn-primary {
  color: #1890ff;
  background-color: transparent;
  border-color: #1890ff;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-primary > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-primary:focus,
.ant-btn-background-ghost.ant-btn-primary:hover {
  color: #40a9ff;
  background-color: transparent;
  border-color: #40a9ff;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-primary.active,
.ant-btn-background-ghost.ant-btn-primary:active {
  color: #096dd9;
  background-color: transparent;
  border-color: #096dd9;
}

.ant-btn-background-ghost.ant-btn-primary.active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-primary.active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-primary.disabled,
.ant-btn-background-ghost.ant-btn-primary.disabled.active,
.ant-btn-background-ghost.ant-btn-primary.disabled:active,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover,
.ant-btn-background-ghost.ant-btn-primary[disabled],
.ant-btn-background-ghost.ant-btn-primary[disabled].active,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child:after,
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-danger {
  color: #f5222d;
  background-color: transparent;
  border-color: #f5222d;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-danger > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-danger:focus,
.ant-btn-background-ghost.ant-btn-danger:hover {
  color: #ff4d4f;
  background-color: transparent;
  border-color: #ff4d4f;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-danger.active,
.ant-btn-background-ghost.ant-btn-danger:active {
  color: #cf1322;
  background-color: transparent;
  border-color: #cf1322;
}

.ant-btn-background-ghost.ant-btn-danger.active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-danger.active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-background-ghost.ant-btn-danger.disabled,
.ant-btn-background-ghost.ant-btn-danger.disabled.active,
.ant-btn-background-ghost.ant-btn-danger.disabled:active,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover,
.ant-btn-background-ghost.ant-btn-danger[disabled],
.ant-btn-background-ghost.ant-btn-danger[disabled].active,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child {
  color: currentColor;
}

.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child:after,
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}

.ant-btn-two-chinese-chars:first-letter {
  letter-spacing: 0.34em;
}

.ant-btn-two-chinese-chars > * {
  letter-spacing: 0.34em;
  margin-right: -0.34em;
}

.ant-btn-block {
  width: 100%;
}

a.ant-btn {
  line-height: 30px;
}

a.ant-btn-lg {
  line-height: 38px;
}

a.ant-btn-sm {
  line-height: 22px;
}

.ant-modal {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  width: auto;
  margin: 0 auto;
  top: 100px;
  padding-bottom: 24px;
}

.ant-modal-wrap {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}

.ant-modal-title {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.ant-modal-content {
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 4px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.ant-modal-close {
  cursor: pointer;
  border: 0;
  background: transparent;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  transition: color 0.3s;
  color: rgba(0, 0, 0, 0.45);
  outline: 0;
  padding: 0;
}

.ant-modal-close-x {
  display: block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  width: 56px;
  height: 56px;
  line-height: 56px;
  font-size: 16px;
}

.ant-modal-close-x:before {
  content: "\E633";
  display: block;
  font-family: anticon !important;
}

.ant-modal-close:focus,
.ant-modal-close:hover {
  color: #444;
  text-decoration: none;
}

.ant-modal-header {
  padding: 16px 24px;
  border-radius: 4px 4px 0 0;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  border-bottom: 1px solid #e8e8e8;
}

.ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

.ant-modal-footer {
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  border-radius: 0 0 4px 4px;
}

.ant-modal-footer button + button {
  margin-left: 8px;
  margin-bottom: 0;
}

.ant-modal.zoom-appear,
.ant-modal.zoom-enter {
  animation-duration: 0.3s;
  transform: none;
  opacity: 0;
  user-select: none;
}

.ant-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.65);
  height: 100%;
  z-index: 1000;
  filter: alpha(opacity=50);
}

.ant-modal-mask-hidden {
  display: none;
}

.ant-modal-open {
  overflow: hidden;
}

.ant-modal-centered {
  text-align: center;
}

.ant-modal-centered:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  width: 0;
}

.ant-modal-centered .ant-modal {
  display: inline-block;
  vertical-align: middle;
  top: 0;
  text-align: left;
}

.ant-modal-centered .ant-table-body {
  white-space: nowrap;
  overflow-x: auto;
}

@media (max-width: 767px) {
  .ant-modal {
    width: auto !important;
    margin: 10px;
  }
  .ant-modal-centered .ant-modal {
    flex: 1;
  }
}

.ant-confirm .ant-modal-close,
.ant-confirm .ant-modal-header {
  display: none;
}

.ant-confirm .ant-modal-body {
  padding: 32px 32px 24px;
}

.ant-confirm-body-wrapper {
  zoom: 1;
}

.ant-confirm-body-wrapper:after,
.ant-confirm-body-wrapper:before {
  content: "";
  display: table;
}

.ant-confirm-body-wrapper:after {
  clear: both;
}

.ant-confirm-body .ant-confirm-title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
  display: block;
  overflow: hidden;
}

.ant-confirm-body .ant-confirm-content {
  margin-left: 38px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 8px;
}

.ant-confirm-body > .anticon {
  font-size: 22px;
  margin-right: 16px;
  float: left;
}

.ant-confirm .ant-confirm-btns {
  margin-top: 24px;
  float: right;
}

.ant-confirm .ant-confirm-btns button + button {
  margin-left: 8px;
  margin-bottom: 0;
}

.ant-confirm-error .ant-confirm-body > .anticon {
  color: #f5222d;
}

.ant-confirm-confirm .ant-confirm-body > .anticon,
.ant-confirm-warning .ant-confirm-body > .anticon {
  color: #faad14;
}

.ant-confirm-info .ant-confirm-body > .anticon {
  color: #1890ff;
}

.ant-confirm-success .ant-confirm-body > .anticon {
  color: #52c41a;
}

@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}

.ant-checkbox {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: middle;
  top: -0.09em;
}

.ant-checkbox-input:focus + .ant-checkbox-inner,
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner {
  border-color: #1890ff;
}

.ant-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #1890ff;
  content: "";
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}

.ant-checkbox-wrapper:hover .ant-checkbox:after,
.ant-checkbox:hover:after {
  visibility: visible;
}

.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  transition: all 0.3s;
}

.ant-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4.57142857px;
  top: 1.14285714px;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  opacity: 0;
}

.ant-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  content: " ";
  transform: translate(-50%, -50%) scale(1);
  border: 0;
  left: 50%;
  top: 50%;
  width: 9px;
  height: 9px;
  background-color: #1890ff;
  opacity: 1;
}

.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-checkbox-checked .ant-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  opacity: 1;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-checkbox-disabled {
  cursor: not-allowed;
}

.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
}

.ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #f5f5f5;
}

.ant-checkbox-disabled .ant-checkbox-inner:after {
  animation-name: none;
  border-color: #f5f5f5;
}

.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-checkbox-wrapper {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: unset;
  cursor: pointer;
  display: inline-block;
}

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 8px;
}

.ant-checkbox + span,
.ant-checkbox-wrapper + span {
  padding-left: 8px;
  padding-right: 8px;
}

.ant-checkbox-group {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
}

.ant-checkbox-group-item {
  display: inline-block;
  margin-right: 8px;
}

.ant-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 0;
}

.upgrade-new-version-modal .ant-modal-body {
  padding: 0;
}

.upgrade-new-version-modal .ant-modal-footer {
  padding: 0 0 23px;
}

.upgrade-new-version-modal .operate-footer {
  text-align: center;
  line-height: 50px;
}

.xiaomi {
  position: fixed;
  right: 36px;
  bottom: 36px;
  z-index: 9999;
}

.xiaomiIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  cursor: pointer;
}

.xiaomiIcon img {
  width: 100%;
  height: 100%;
}

.xiaomiAvatar {
  background-image: url(https://img.alicdn.com/tfs/TB1c5.HgL6H8KJjy0FjXXaXepXa-324-394.png);
  width: 162px;
  height: 197px;
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.xiaomiQuestions {
  font-size: 12px;
  color: #000;
  line-height: 28px;
  padding-top: 68px;
  padding-left: 13px;
}

.xiaomiAvatarCloseIcon {
  background-image: url(https://img.alicdn.com/tfs/TB1Hl3YgN6I8KJjy0FgXXXXzVXa-16-16.png);
  width: 16px;
  height: 16px;
  background-size: 8px 8px;
  background-repeat: no-repeat;
  background-position: 50%;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 1px;
}

.xiaomiIframeOpenWrap {
  position: relative;
  width: 602px;
  height: 600px;
  border: 1px solid #ddd;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.15);
}

.xiaomiIframe {
  width: 600px;
  height: 600px;
  border: none;
}

.xiaomiIframeCloseIcon {
  background-image: url(https://img.alicdn.com/tfs/TB1RWQYgTnI8KJjy0FfXXcdoVXa-44-48.png);
  width: 22px;
  height: 24px;
  background-size: 100% 100%;
  cursor: pointer;
  position: absolute;
  top: -24px;
  right: 0;
}

.helper-container {
  position: fixed;
  right: 0;
  bottom: 40px;
  width: 112px;
  height: 52px;
  z-index: 998;
}

.helper-container .helper-item {
  cursor: pointer;
}

.helper-container .helper-item .helper-image {
  width: 112px;
  height: 52px;
  cursor: pointer;
}

.helper-container .helper-content {
  font-size: 14px;
  color: #191f25;
  cursor: inherit;
}

.helper-container .ding-xiaomi .xiaomiIcon {
  content: "";
  position: absolute;
  top: -5px;
  bottom: 5px;
  left: -30px;
  right: -36px;
}

.helper-container .ding-xiaomi .xiaomiIcon > img {
  display: none;
}

.helper-container .xiaomiIframeOpenWrap.mini,
.helper-container .xiaomiIframeOpenWrap.mini .xiaomiIframe {
  height: 520px;
}

.helper-container .helper-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.helper-container .helper-video .helper-video-content {
  position: fixed;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  z-index: 1;
}

.helper-container .helper-video .helper-video-control {
  z-index: 2;
}

.helper-container .helper-video .mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.5;
  background: #000;
}

.wf-loading {
  position: absolute;
  text-align: center;
  padding: 34px !important;
  background: rgba(17, 31, 44, 0.4);
  overflow: hidden;
  top: 38%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 5px;
  color: #fff;
  z-index: 999;
}

.wf-loading .ani-loading {
  background: url("//img.alicdn.com/tfs/TB1OayYguL2gK0jSZFmXXc7iXXa-128-128.svg")
    no-repeat;
  background-size: contain;
  height: 44px;
  width: 44px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  -webkit-animation: spining 1.2s infinite linear;
  animation: spining 1.2s infinite linear;
}

.wf-loading .text {
  vertical-align: middle;
}

.fd-nav-container {
  display: inline-block;
  position: relative;
}

.fd-nav-container .ghost-bar {
  position: absolute;
  width: 150px;
  height: 100%;
  left: 0;
  background: #1583f2;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fd-nav-container .ghost-bar:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 6px;
  border-color: transparent transparent #f6f6f6;
}

.fd-nav-item {
  position: relative;
  cursor: pointer;
  display: inline-block;
  line-height: 60px;
  width: 150px;
  text-align: center;
  white-space: nowrap;
}

.fd-nav-item .order-num {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-right: 6px;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fd-nav-item.active .order-num {
  color: #1583f2;
  background: #fff;
}

.ant-drawer {
  position: fixed;
  top: 0;
  width: 0;
  z-index: 1000;
}

.ant-drawer,
.ant-drawer > * {
  transition: transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);
}

.ant-drawer-content-wrapper {
  position: fixed;
}

.ant-drawer .ant-drawer-content {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s linear;
}

.ant-drawer-left,
.ant-drawer-right {
  width: 0;
  height: 100%;
}

.ant-drawer-left .ant-drawer-content-wrapper,
.ant-drawer-right .ant-drawer-content-wrapper {
  height: 100%;
}

.ant-drawer-left.ant-drawer-open,
.ant-drawer-right.ant-drawer-open {
  width: 100%;
}

.ant-drawer-left.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
}

.ant-drawer-right .ant-drawer-content-wrapper {
  right: 0;
}

.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}

.ant-drawer-bottom .ant-drawer-content,
.ant-drawer-bottom .ant-drawer-content-wrapper,
.ant-drawer-top .ant-drawer-content,
.ant-drawer-top .ant-drawer-content-wrapper {
  width: 100%;
}

.ant-drawer-top.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-drawer-bottom .ant-drawer-content-wrapper {
  bottom: 0;
}

.ant-drawer-bottom.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-drawer.ant-drawer-open .ant-drawer-content {
  opacity: 1;
}

.ant-drawer.ant-drawer-open .ant-drawer-mask {
  opacity: 0.3;
  height: 100%;
  animation: antdDrawerFadeIn 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  transition: none;
}

.ant-drawer-title {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.ant-drawer-content {
  position: relative;
  background-color: #fff;
  border: 0;
  background-clip: padding-box;
  z-index: 1;
}

.ant-drawer-close {
  cursor: pointer;
  border: 0;
  background: transparent;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  transition: color 0.3s;
  color: rgba(0, 0, 0, 0.45);
  outline: 0;
  padding: 0;
}

.ant-drawer-close-x {
  display: block;
  font-style: normal;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  width: 56px;
  height: 56px;
  line-height: 56px;
  font-size: 16px;
}

.ant-drawer-close-x:before {
  content: "\E633";
  display: block;
  font-family: anticon !important;
}

.ant-drawer-close:focus,
.ant-drawer-close:hover {
  color: #444;
  text-decoration: none;
}

.ant-drawer-header {
  padding: 16px 24px;
  border-radius: 4px 4px 0 0;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  border-bottom: 1px solid #e8e8e8;
}

.ant-drawer-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

.ant-drawer-mask {
  position: fixed;
  width: 100%;
  height: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.65);
  filter: alpha(opacity=50);
  transition: opacity 0.3s linear, height 0s ease 0.3s;
}

.ant-drawer-open,
.ant-drawer-open > * {
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}

.ant-drawer-open-content {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

@keyframes antdDrawerFadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 0.3;
  }
}

.ant-table-wrapper {
  zoom: 1;
}

.ant-table-wrapper:after,
.ant-table-wrapper:before {
  content: "";
  display: table;
}

.ant-table-wrapper:after {
  clear: both;
}

.ant-table {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  clear: both;
}

.ant-table-body {
  transition: opacity 0.3s;
}

.ant-table-empty .ant-table-body {
  overflow: auto !important;
}

.ant-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  border-radius: 4px 4px 0 0;
}

.ant-table-thead > tr > th {
  background: #fafafa;
  transition: background 0.3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
}

.ant-table-thead > tr > th[colspan] {
  text-align: center;
}

.ant-table-thead > tr > th .ant-table-filter-icon,
.ant-table-thead > tr > th .anticon-filter {
  position: relative;
  margin-left: 8px;
  font-size: 14px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
  width: 14px;
  font-weight: 400;
  vertical-align: text-bottom;
}

.ant-table-thead > tr > th .ant-table-filter-icon:hover,
.ant-table-thead > tr > th .anticon-filter:hover {
  color: rgba(0, 0, 0, 0.65);
}

.ant-table-thead > tr > th .ant-table-column-sorter + .anticon-filter {
  margin-left: 4px;
}

.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
  color: #1890ff;
}

.ant-table-thead > tr > th.ant-table-column-has-filters {
  overflow: hidden;
}

.ant-table-thead > tr:first-child > th:first-child {
  border-top-left-radius: 4px;
}

.ant-table-thead > tr:first-child > th:last-child {
  border-top-right-radius: 4px;
}

.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s;
}

.ant-table-tbody > tr,
.ant-table-thead > tr {
  transition: all 0.3s;
}

.ant-table-tbody > tr.ant-table-row-hover > td,
.ant-table-tbody > tr:hover > td,
.ant-table-thead > tr.ant-table-row-hover > td,
.ant-table-thead > tr:hover > td {
  background: #e6f7ff;
}

.ant-table-thead > tr:hover {
  background: none;
}

.ant-table-footer {
  padding: 16px;
  background: #fafafa;
  border-radius: 0 0 4px 4px;
  position: relative;
  border-top: 1px solid #e8e8e8;
}

.ant-table-footer:before {
  content: "";
  height: 1px;
  background: #fafafa;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
}

.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e8e8e8;
}

.ant-table-title {
  padding: 16px 0;
  position: relative;
  top: 1px;
  border-radius: 4px 4px 0 0;
}

.ant-table.ant-table-bordered .ant-table-title {
  border: 1px solid #e8e8e8;
  padding-left: 16px;
  padding-right: 16px;
}

.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}

.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered
  .ant-table-title
  + .ant-table-content
  .ant-table-thead
  > tr:first-child
  > th,
.ant-table-bordered .ant-table-title + .ant-table-content table,
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}

.ant-table-tbody > tr.ant-table-row-selected td {
  background: #fafafa;
}

.ant-table-thead > tr > th.ant-table-column-sort {
  background: #f5f5f5;
}

.ant-table-tbody > tr > td,
.ant-table-thead > tr > th {
  padding: 16px;
  word-break: break-word;
  -ms-word-break: break-all;
}

.ant-table-thead > tr > th.ant-table-selection-column-custom {
  padding-left: 16px;
  padding-right: 0;
}

.ant-table-tbody > tr > td.ant-table-selection-column,
.ant-table-thead > tr > th.ant-table-selection-column {
  text-align: center;
  min-width: 62px;
  width: 62px;
}

.ant-table-tbody > tr > td.ant-table-selection-column .ant-radio-wrapper,
.ant-table-thead > tr > th.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}

.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  text-align: center;
  min-width: 50px;
  width: 50px;
}

.ant-table-header {
  background: #fafafa;
  overflow: hidden;
}

.ant-table-header table {
  border-radius: 4px 4px 0 0;
}

.ant-table-loading {
  position: relative;
}

.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}

.ant-table-loading .ant-table-spin-holder {
  height: 20px;
  line-height: 20px;
  left: 50%;
  top: 50%;
  margin-left: -30px;
  position: absolute;
}

.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}

.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}

.ant-table-column-sorter {
  position: relative;
  margin-left: 8px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  text-align: center;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
}

.ant-table-column-sorter-down,
.ant-table-column-sorter-up {
  display: block;
  width: 14px;
  height: 6px;
  line-height: 6px;
  cursor: pointer;
  position: relative;
}

.ant-table-column-sorter-down:hover .anticon,
.ant-table-column-sorter-up:hover .anticon {
  color: #69c0ff;
}

.ant-table-column-sorter-down.on .anticon-caret-down,
.ant-table-column-sorter-down.on .anticon-caret-up,
.ant-table-column-sorter-up.on .anticon-caret-down,
.ant-table-column-sorter-up.on .anticon-caret-up {
  color: #1890ff;
}

.ant-table-column-sorter-down:after,
.ant-table-column-sorter-up:after {
  position: absolute;
  content: "";
  height: 30px;
  width: 14px;
  left: 0;
}

.ant-table-column-sorter-up:after {
  bottom: 0;
}

.ant-table-column-sorter-down:after {
  top: 0;
}

.ant-table-column-sorter .anticon-caret-down,
.ant-table-column-sorter .anticon-caret-up {
  display: inline-block;
  font-size: 12px;
  font-size: 8px\9;
  transform: scale(0.66666667) rotate(0deg);
  line-height: 4px;
  height: 4px;
  transition: all 0.3s;
  position: relative;
  display: block;
}

:root .ant-table-column-sorter .anticon-caret-down,
:root .ant-table-column-sorter .anticon-caret-up {
  font-size: 12px;
}

.ant-table-column-sorter-down {
  margin-top: 1.5px;
}

.ant-table-column-sorter .anticon-caret-up {
  margin-top: 0.5px;
}

.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table,
.ant-table-bordered .ant-table-header > table {
  border: 1px solid #e8e8e8;
  border-right: 0;
  border-bottom: 0;
}

.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}

.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}

.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {
  border: 0;
}

.ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #e8e8e8;
}

.ant-table-bordered .ant-table-tbody > tr > td,
.ant-table-bordered .ant-table-thead > tr > th {
  border-right: 1px solid #e8e8e8;
}

.ant-table-placeholder {
  position: relative;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  z-index: 1;
}

.ant-table-placeholder .anticon {
  margin-right: 4px;
}

.ant-table-pagination.ant-pagination {
  margin: 16px 0;
  float: right;
}

.ant-table-filter-dropdown {
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-table-filter-dropdown .ant-dropdown-menu {
  border: 0;
  box-shadow: none;
  border-radius: 4px 4px 0 0;
}

.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {
  max-height: 400px;
  overflow-x: hidden;
}

.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding-right: 0;
}

.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-table-filter-dropdown
  .ant-dropdown-menu
  .ant-dropdown-submenu-contain-selected
  .ant-dropdown-menu-submenu-title:after {
  color: #1890ff;
  font-weight: 700;
  text-shadow: 0 0 2px #bae7ff;
}

.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}

.ant-table-filter-dropdown
  > .ant-dropdown-menu
  > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown
  > .ant-dropdown-menu
  > .ant-dropdown-menu-submenu:last-child
  .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}

.ant-table-filter-dropdown-btns {
  overflow: hidden;
  padding: 7px 8px;
  border-top: 1px solid #e8e8e8;
}

.ant-table-filter-dropdown-link {
  color: #1890ff;
}

.ant-table-filter-dropdown-link:hover {
  color: #40a9ff;
}

.ant-table-filter-dropdown-link:active {
  color: #096dd9;
}

.ant-table-filter-dropdown-link.confirm {
  float: left;
}

.ant-table-filter-dropdown-link.clear {
  float: right;
}

.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}

.ant-table-selection .anticon-down {
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
}

.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-table-selection-menu .ant-action-down {
  color: rgba(0, 0, 0, 0.45);
}

.ant-table-selection-down {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  line-height: 1;
}

.ant-table-selection-down:hover .anticon-down {
  color: #666;
}

.ant-table-row-expand-icon {
  cursor: pointer;
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #e8e8e8;
  user-select: none;
  background: #fff;
}

.ant-table-row-expanded:after {
  content: "-";
}

.ant-table-row-collapsed:after {
  content: "+";
}

.ant-table-row-spaced {
  visibility: hidden;
}

.ant-table-row-spaced:after {
  content: ".";
}

.ant-table-row[class*="ant-table-row-level-0"]
  .ant-table-selection-column
  > span {
  display: inline-block;
}

tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}

.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}

.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}

.ant-table-scroll table {
  width: auto;
  min-width: 100%;
}

.ant-table-body-inner {
  height: 100%;
}

.ant-table-fixed-header
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body {
  position: relative;
  background: #fff;
}

.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}

.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: scroll;
  padding-bottom: 20px;
  margin-bottom: -20px;
}

.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border-radius: 0;
}

.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}

.ant-table-fixed-header
  .ant-table-fixed-left
  .ant-table-body-outer
  .ant-table-fixed,
.ant-table-fixed-header
  .ant-table-fixed-right
  .ant-table-body-outer
  .ant-table-fixed {
  border-radius: 0;
}

.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);
}

.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}

.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}

.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}

.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 4px 0 0 0;
}

.ant-table-fixed-left .ant-table-thead > tr > th:last-child {
  border-top-right-radius: 0;
}

.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);
}

.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 4px 0 0;
}

.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}

.ant-table-fixed-right .ant-table-thead > tr > th:first-child {
  border-top-left-radius: 0;
}

.ant-table.ant-table-scroll-position-left .ant-table-fixed-left,
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}

.ant-table-middle
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-middle > .ant-table-footer,
.ant-table-middle > .ant-table-title {
  padding: 12px 8px;
}

.ant-table-small {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.ant-table-small > .ant-table-footer,
.ant-table-small > .ant-table-title {
  padding: 8px;
}

.ant-table-small > .ant-table-title {
  border-bottom: 1px solid #e8e8e8;
  top: 0;
}

.ant-table-small > .ant-table-content > .ant-table-body > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table,
.ant-table-small > .ant-table-content > .ant-table-header > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table {
  border: 0;
  padding: 0 8px;
}

.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-tbody
  > tr
  > td,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th {
  padding: 8px;
}

.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-left
  > .ant-table-header
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-header
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table {
  padding: 0;
}

.ant-table-small > .ant-table-content .ant-table-header {
  background: #fff;
}

.ant-table-small > .ant-table-content .ant-table-placeholder,
.ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 0;
}

.ant-table-small.ant-table-bordered {
  border-right: 0;
}

.ant-table-small.ant-table-bordered .ant-table-title {
  border: 0;
  border-bottom: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

.ant-table-small.ant-table-bordered .ant-table-content {
  border-right: 1px solid #e8e8e8;
}

.ant-table-small.ant-table-bordered .ant-table-footer {
  border: 0;
  border-top: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

.ant-table-small.ant-table-bordered .ant-table-footer:before {
  display: none;
}

.ant-table-small.ant-table-bordered .ant-table-placeholder {
  border-left: 0;
  border-bottom: 0;
}

.ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child,
.ant-table-small.ant-table-bordered .ant-table-thead > tr > th:last-child {
  border-right: none;
}

.ant-table-small.ant-table-bordered
  .ant-table-fixed-left
  .ant-table-tbody
  > tr
  > td:last-child,
.ant-table-small.ant-table-bordered
  .ant-table-fixed-left
  .ant-table-thead
  > tr
  > th:last-child,
.ant-table-small.ant-table-bordered .ant-table-fixed-right {
  border-right: 1px solid #e8e8e8;
}

.ant-radio-group {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
  line-height: unset;
}

.ant-radio-wrapper {
  margin: 0;
  margin-right: 8px;
}

.ant-radio,
.ant-radio-wrapper {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  padding: 0;
  list-style: none;
  display: inline-block;
  position: relative;
  white-space: nowrap;
  cursor: pointer;
}

.ant-radio {
  margin: 0;
  outline: none;
  line-height: 1;
  vertical-align: sub;
}

.ant-radio-focused .ant-radio-inner,
.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
.ant-radio:hover .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #1890ff;
  content: "";
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}

.ant-radio-wrapper:hover .ant-radio:after,
.ant-radio:hover:after {
  visibility: visible;
}

.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  transition: all 0.3s;
}

.ant-radio-inner:after {
  position: absolute;
  width: 8px;
  height: 8px;
  left: 3px;
  top: 3px;
  border-radius: 8px;
  display: table;
  border-top: 0;
  border-left: 0;
  content: " ";
  background-color: #1890ff;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-radio-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #1890ff;
}

.ant-radio-checked .ant-radio-inner:after {
  transform: scale(0.875);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-radio-disabled .ant-radio-inner {
  border-color: #d9d9d9 !important;
  background-color: #f5f5f5;
}

.ant-radio-disabled .ant-radio-inner:after {
  background-color: #ccc;
}

.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}

.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

span.ant-radio + * {
  padding-left: 8px;
  padding-right: 8px;
}

.ant-radio-button-wrapper {
  margin: 0;
  height: 32px;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.65);
  display: inline-block;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-left: 0;
  border-top-width: 1.02px;
  background: #fff;
  padding: 0 15px;
  position: relative;
}

.ant-radio-button-wrapper a {
  color: rgba(0, 0, 0, 0.65);
}

.ant-radio-button-wrapper > .ant-radio-button {
  margin-left: 0;
  display: block;
  width: 0;
  height: 0;
}

.ant-radio-group-large .ant-radio-button-wrapper {
  height: 40px;
  line-height: 38px;
  font-size: 16px;
}

.ant-radio-group-small .ant-radio-button-wrapper {
  height: 24px;
  line-height: 22px;
  padding: 0 7px;
}

.ant-radio-button-wrapper:not(:first-child):before {
  content: "";
  display: block;
  top: 0;
  left: -1px;
  width: 1px;
  height: 100%;
  position: absolute;
  background-color: #d9d9d9;
}

.ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px;
  border-left: 1px solid #d9d9d9;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0;
}

.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 4px;
}

.ant-radio-button-wrapper-focused,
.ant-radio-button-wrapper:hover {
  color: #1890ff;
  position: relative;
}

.ant-radio-button-wrapper .ant-radio-inner,
.ant-radio-button-wrapper input[type="checkbox"],
.ant-radio-button-wrapper input[type="radio"] {
  opacity: 0;
  width: 0;
  height: 0;
}

.ant-radio-button-wrapper-checked {
  background: #fff;
  border-color: #1890ff;
  color: #1890ff;
  box-shadow: -1px 0 0 0 #1890ff;
  z-index: 1;
}

.ant-radio-button-wrapper-checked:before {
  background-color: #1890ff !important;
  opacity: 0.1;
}

.ant-radio-button-wrapper-checked:first-child {
  border-color: #1890ff;
  box-shadow: none !important;
}

.ant-radio-button-wrapper-checked:hover {
  border-color: #40a9ff;
  box-shadow: -1px 0 0 0 #40a9ff;
  color: #40a9ff;
}

.ant-radio-button-wrapper-checked:active {
  border-color: #096dd9;
  box-shadow: -1px 0 0 0 #096dd9;
  color: #096dd9;
}

.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: #1890ff;
  border-color: #1890ff;
  color: #fff;
}

.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(
    .ant-radio-button-wrapper-disabled
  ):hover {
  border-color: #40a9ff;
  background: #40a9ff;
  color: #fff;
}

.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(
    .ant-radio-button-wrapper-disabled
  ):active {
  border-color: #096dd9;
  background: #096dd9;
  color: #fff;
}

.ant-radio-button-wrapper-disabled {
  cursor: not-allowed;
}

.ant-radio-button-wrapper-disabled,
.ant-radio-button-wrapper-disabled:first-child,
.ant-radio-button-wrapper-disabled:hover {
  border-color: #d9d9d9;
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
}

.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}

.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: #fff;
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}

@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}

@supports (-moz-appearance: meterbar) and
  (background-blend-mode: difference, normal) {
  .ant-radio {
    vertical-align: text-bottom;
  }
}

.ant-dropdown {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  left: -9999px;
  top: -9999px;
  z-index: 1050;
  display: block;
}

.ant-dropdown-wrap {
  position: relative;
}

.ant-dropdown-wrap .ant-btn > .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
}

:root .ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 12px;
}

.ant-dropdown-wrap .anticon-down:before {
  transition: transform 0.2s;
}

.ant-dropdown-wrap-open .anticon-down:before {
  transform: rotate(180deg);
}

.ant-dropdown-hidden,
.ant-dropdown-menu-hidden {
  display: none;
}

.ant-dropdown-menu {
  outline: none;
  position: relative;
  list-style-type: none;
  padding: 4px 0;
  margin: 0;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background-clip: padding-box;
}

.ant-dropdown-menu-item-group-title {
  color: rgba(0, 0, 0, 0.45);
  padding: 5px 12px;
  transition: all 0.3s;
}

.ant-dropdown-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
}

.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
  padding: 5px 12px;
  margin: 0;
  clear: both;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
  line-height: 22px;
}

.ant-dropdown-menu-item > .anticon:first-child,
.ant-dropdown-menu-submenu-title > .anticon:first-child {
  min-width: 12px;
  margin-right: 8px;
}

.ant-dropdown-menu-item > a,
.ant-dropdown-menu-submenu-title > a {
  color: rgba(0, 0, 0, 0.65);
  display: block;
  padding: 5px 12px;
  margin: -5px -12px;
  transition: all 0.3s;
}

.ant-dropdown-menu-item > a:focus,
.ant-dropdown-menu-submenu-title > a:focus {
  text-decoration: none;
}

.ant-dropdown-menu-item-selected,
.ant-dropdown-menu-item-selected > a,
.ant-dropdown-menu-submenu-title-selected,
.ant-dropdown-menu-submenu-title-selected > a {
  color: #1890ff;
  background-color: #e6f7ff;
}

.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background-color: #e6f7ff;
}

.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-dropdown-menu-item-divider,
.ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  overflow: hidden;
  background-color: #e8e8e8;
  line-height: 0;
  margin: 4px 0;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow {
  position: absolute;
  right: 8px;
}

.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {
  font-family: anticon !important;
  font-style: normal;
  content: "\E61F";
  color: rgba(0, 0, 0, 0.45);
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
}

:root .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after,
:root .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {
  font-size: 12px;
}

.ant-dropdown-menu-submenu-title {
  padding-right: 26px;
}

.ant-dropdown-menu-submenu-vertical {
  position: relative;
}

.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  top: 0;
  left: 100%;
  position: absolute;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}

.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled
  .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled
  .ant-dropdown-menu-submenu-title
  .ant-dropdown-menu-submenu-arrow:after {
  color: rgba(0, 0, 0, 0.25);
}

.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}

.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}

.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}

.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}

.ant-dropdown-link .anticon-down,
.ant-dropdown-trigger .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
}

:root .ant-dropdown-link .anticon-down,
:root .ant-dropdown-trigger .anticon-down {
  font-size: 12px;
}

.ant-dropdown-link .anticon-ellipsis,
.ant-dropdown-trigger .anticon-ellipsis {
  text-shadow: 0 0 currentColor;
}

.ant-dropdown-button {
  white-space: nowrap;
}

.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {
  padding-left: 8px;
  padding-right: 8px;
}

.ant-dropdown-button .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
}

:root .ant-dropdown-button .anticon-down {
  font-size: 12px;
}

.ant-dropdown-menu-dark,
.ant-dropdown-menu-dark .ant-dropdown-menu {
  background: #001529;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item,
.ant-dropdown-menu-dark
  .ant-dropdown-menu-item
  .ant-dropdown-menu-submenu-arrow:after,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a,
.ant-dropdown-menu-dark
  .ant-dropdown-menu-item
  > a
  .ant-dropdown-menu-submenu-arrow:after,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-dark
  .ant-dropdown-menu-submenu-title
  .ant-dropdown-menu-submenu-arrow:after {
  color: hsla(0, 0%, 100%, 0.65);
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover {
  color: #fff;
  background: transparent;
}

.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  background: #1890ff;
  color: #fff;
}

.ant-spin {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  color: #1890ff;
  vertical-align: middle;
  text-align: center;
  opacity: 0;
  position: absolute;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  display: none;
}

.ant-spin-spinning {
  opacity: 1;
  position: static;
  display: inline-block;
}

.ant-spin-nested-loading {
  position: relative;
}

.ant-spin-nested-loading > div > .ant-spin {
  display: block;
  position: absolute;
  height: 100%;
  max-height: 360px;
  width: 100%;
  z-index: 4;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
}

.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}

.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 2px;
}

.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}

.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 11px;
}

.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}

.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
  zoom: 1;
}

.ant-spin-container:after,
.ant-spin-container:before {
  content: "";
  display: table;
}

.ant-spin-container:after {
  clear: both;
}

.ant-spin-blur {
  pointer-events: none;
  user-select: none;
  overflow: hidden;
  opacity: 0.5;
  -webkit-filter: blur(0.5px);
  filter: blur(0.5px);
  filter: progid\:DXImageTransform\.Microsoft\.Blur(
      PixelRadius\=1,
      MakeShadow\=false
    );
}

.ant-spin-blur:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  opacity: 0.3;
  transition: all 0.3s;
  z-index: 10;
}

.ant-spin-tip {
  color: rgba(0, 0, 0, 0.45);
}

.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.ant-spin-dot i {
  width: 9px;
  height: 9px;
  border-radius: 100%;
  background-color: #1890ff;
  transform: scale(0.75);
  display: block;
  position: absolute;
  opacity: 0.3;
  animation: antSpinMove 1s infinite linear alternate;
  transform-origin: 50% 50%;
}

.ant-spin-dot i:first-child {
  left: 0;
  top: 0;
}

.ant-spin-dot i:nth-child(2) {
  right: 0;
  top: 0;
  animation-delay: 0.4s;
}

.ant-spin-dot i:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}

.ant-spin-dot i:nth-child(4) {
  left: 0;
  bottom: 0;
  animation-delay: 1.2s;
}

.ant-spin-dot-spin {
  transform: rotate(45deg);
  animation: antRotate 1.2s infinite linear;
}

.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}

.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}

.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}

@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}

@keyframes antRotate {
  to {
    transform: rotate(405deg);
  }
}

.ant-pagination {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
}

.ant-pagination,
.ant-pagination ol,
.ant-pagination ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-pagination:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}

.ant-pagination-item,
.ant-pagination-total-text {
  display: inline-block;
  vertical-align: middle;
  height: 32px;
  line-height: 30px;
  margin-right: 8px;
}

.ant-pagination-item {
  cursor: pointer;
  border-radius: 4px;
  user-select: none;
  min-width: 32px;
  text-align: center;
  list-style: none;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  font-family: Arial;
  outline: 0;
}

.ant-pagination-item a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.65);
  transition: none;
  margin: 0 6px;
}

.ant-pagination-item:focus,
.ant-pagination-item:hover {
  transition: all 0.3s;
  border-color: #1890ff;
}

.ant-pagination-item:focus a,
.ant-pagination-item:hover a {
  color: #1890ff;
}

.ant-pagination-item-active {
  border-color: #1890ff;
  font-weight: 500;
}

.ant-pagination-item-active a {
  color: #1890ff;
}

.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  border-color: #40a9ff;
}

.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  color: #40a9ff;
}

.ant-pagination-jump-next,
.ant-pagination-jump-prev {
  outline: 0;
}

.ant-pagination-jump-next:after,
.ant-pagination-jump-prev:after {
  content: "\2022\2022\2022";
  display: block;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}

.ant-pagination-jump-next:focus:after,
.ant-pagination-jump-next:hover:after,
.ant-pagination-jump-prev:focus:after,
.ant-pagination-jump-prev:hover:after {
  color: #1890ff;
  display: inline-block;
  font-size: 12px;
  font-size: 8px\9;
  transform: scale(0.66666667) rotate(0deg);
  letter-spacing: -1px;
  font-family: anticon;
}

:root .ant-pagination-jump-next:focus:after,
:root .ant-pagination-jump-next:hover:after,
:root .ant-pagination-jump-prev:focus:after,
:root .ant-pagination-jump-prev:hover:after {
  font-size: 12px;
}

.ant-pagination-jump-prev:focus:after,
.ant-pagination-jump-prev:hover:after {
  content: "\E620\E620";
}

.ant-pagination-jump-next:focus:after,
.ant-pagination-jump-next:hover:after {
  content: "\E61F\E61F";
}

.ant-pagination-jump-next,
.ant-pagination-jump-prev,
.ant-pagination-prev {
  margin-right: 8px;
}

.ant-pagination-jump-next,
.ant-pagination-jump-prev,
.ant-pagination-next,
.ant-pagination-prev {
  font-family: Arial;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  list-style: none;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  transition: all 0.3s;
  display: inline-block;
  vertical-align: middle;
}

.ant-pagination-next,
.ant-pagination-prev {
  outline: 0;
}

.ant-pagination-next a,
.ant-pagination-prev a {
  color: rgba(0, 0, 0, 0.65);
  user-select: none;
}

.ant-pagination-next:hover a,
.ant-pagination-prev:hover a {
  border-color: #40a9ff;
}

.ant-pagination-next .ant-pagination-item-link,
.ant-pagination-prev .ant-pagination-item-link {
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  outline: none;
  display: block;
  transition: all 0.3s;
}

.ant-pagination-next .ant-pagination-item-link:after,
.ant-pagination-prev .ant-pagination-item-link:after {
  font-size: 12px;
  display: block;
  height: 30px;
  font-family: anticon;
  text-align: center;
  font-weight: 500;
}

.ant-pagination-next:focus .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link,
.ant-pagination-prev:focus .ant-pagination-item-link,
.ant-pagination-prev:hover .ant-pagination-item-link {
  border-color: #1890ff;
  color: #1890ff;
}

.ant-pagination-prev .ant-pagination-item-link:after {
  content: "\E620";
  display: block;
}

.ant-pagination-next .ant-pagination-item-link:after {
  content: "\E61F";
  display: block;
}

.ant-pagination-disabled,
.ant-pagination-disabled:focus,
.ant-pagination-disabled:hover {
  cursor: not-allowed;
}

.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-disabled:focus .ant-pagination-item-link,
.ant-pagination-disabled:focus a,
.ant-pagination-disabled:hover .ant-pagination-item-link,
.ant-pagination-disabled:hover a,
.ant-pagination-disabled a {
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-pagination-slash {
  margin: 0 10px 0 5px;
}

.ant-pagination-options {
  display: inline-block;
  vertical-align: middle;
  margin-left: 16px;
}

.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  margin-right: 8px;
}

.ant-pagination-options-quick-jumper {
  display: inline-block;
  vertical-align: top;
  height: 32px;
  line-height: 32px;
}

.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  padding: 4px 11px;
  width: 100%;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  margin: 0 8px;
  width: 50px;
}

.ant-pagination-options-quick-jumper input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}

.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  color: #bfbfbf;
}

.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {
  color: #bfbfbf;
}

.ant-pagination-options-quick-jumper input:focus,
.ant-pagination-options-quick-jumper input:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.ant-pagination-options-quick-jumper input:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-pagination-options-quick-jumper input-disabled {
  background-color: #f5f5f5;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}

.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #e6d8d8;
  border-right-width: 1px !important;
}

textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  min-height: 32px;
}

.ant-pagination-options-quick-jumper input-lg {
  padding: 6px 11px;
  height: 40px;
  font-size: 16px;
}

.ant-pagination-options-quick-jumper input-sm {
  padding: 1px 7px;
  height: 24px;
}

.ant-pagination-simple .ant-pagination-next,
.ant-pagination-simple .ant-pagination-prev {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link,
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link {
  border: 0;
  height: 24px;
}

.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link:after,
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  margin-right: 8px;
  height: 24px;
}

.ant-pagination-simple .ant-pagination-simple-pager input {
  margin-right: 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  outline: none;
  padding: 0 6px;
  height: 100%;
  text-align: center;
  transition: border-color 0.3s;
}

.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #1890ff;
}

.ant-pagination.mini .ant-pagination-simple-pager,
.ant-pagination.mini .ant-pagination-total-text {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.mini .ant-pagination-item {
  margin: 0;
  min-width: 24px;
  height: 24px;
  line-height: 22px;
}

.ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}

.ant-pagination.mini .ant-pagination-next,
.ant-pagination.mini .ant-pagination-prev {
  margin: 0;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
}

.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link,
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link {
  border-color: transparent;
  background: transparent;
}

.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link:after,
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.mini .ant-pagination-jump-next,
.ant-pagination.mini .ant-pagination-jump-prev {
  height: 24px;
  line-height: 24px;
  margin-right: 0;
}

.ant-pagination.mini .ant-pagination-options {
  margin-left: 2px;
}

.ant-pagination.mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}

.ant-pagination.mini .ant-pagination-options-quick-jumper input {
  padding: 1px 7px;
  height: 24px;
  width: 44px;
}

@media only screen and (max-width: 992px) {
  .ant-pagination-item-after-jump-prev,
  .ant-pagination-item-before-jump-next {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  .ant-pagination-options {
    display: none;
  }
}

.ant-select {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  outline: 0;
}

.ant-select,
.ant-select ol,
.ant-select ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-select > ul > li > a {
  padding: 0;
  background-color: #fff;
}

.ant-select-arrow {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  line-height: 1;
  margin-top: -6px;
  transform-origin: 50% 50%;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
}

.ant-select-arrow:before {
  display: block;
  font-family: anticon !important;
}

.ant-select-arrow * {
  display: none;
}

.ant-select-arrow:before {
  content: "\E61D";
  transition: transform 0.3s;
}

.ant-select-selection {
  outline: none;
  user-select: none;
  box-sizing: border-box;
  display: block;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-select-selection:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border-color: #40a9ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px !important;
}

.ant-select-selection__clear {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  opacity: 0;
  position: absolute;
  right: 11px;
  z-index: 1;
  background: #fff;
  top: 50%;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  width: 12px;
  height: 12px;
  margin-top: -6px;
  line-height: 12px;
  cursor: pointer;
  transition: color 0.3s ease, opacity 0.15s ease;
}

.ant-select-selection__clear:before {
  display: block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\E62E";
}

.ant-select-selection__clear:hover {
  color: rgba(0, 0, 0, 0.45);
}

.ant-select-selection:hover .ant-select-selection__clear {
  opacity: 1;
}

.ant-select-selection-selected-value {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding-right: 20px;
}

.ant-select-no-arrow .ant-select-selection-selected-value {
  padding-right: 0;
}

.ant-select-disabled {
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-disabled .ant-select-selection {
  background: #f5f5f5;
  cursor: not-allowed;
}

.ant-select-disabled .ant-select-selection:active,
.ant-select-disabled .ant-select-selection:focus,
.ant-select-disabled .ant-select-selection:hover {
  border-color: #d9d9d9;
  box-shadow: none;
}

.ant-select-disabled .ant-select-selection__clear {
  display: none;
  visibility: hidden;
  pointer-events: none;
}

.ant-select-disabled
  .ant-select-selection--multiple
  .ant-select-selection__choice {
  background: #f5f5f5;
  color: #aaa;
  padding-right: 10px;
}

.ant-select-disabled
  .ant-select-selection--multiple
  .ant-select-selection__choice__remove {
  display: none;
}

.ant-select-selection--single {
  height: 32px;
  position: relative;
  cursor: pointer;
}

.ant-select-selection__rendered {
  display: block;
  margin-left: 11px;
  margin-right: 11px;
  position: relative;
  line-height: 30px;
}

.ant-select-selection__rendered:after {
  content: ".";
  visibility: hidden;
  pointer-events: none;
  display: inline-block;
  width: 0;
}

.ant-select-lg {
  font-size: 16px;
}

.ant-select-lg .ant-select-selection--single {
  height: 40px;
}

.ant-select-lg .ant-select-selection__rendered {
  line-height: 38px;
}

.ant-select-lg .ant-select-selection--multiple {
  min-height: 40px;
}

.ant-select-lg
  .ant-select-selection--multiple
  .ant-select-selection__rendered
  li {
  height: 32px;
  line-height: 32px;
}

.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear {
  top: 20px;
}

.ant-select-sm .ant-select-selection--single {
  height: 24px;
}

.ant-select-sm .ant-select-selection__rendered {
  line-height: 22px;
  margin: 0 7px;
}

.ant-select-sm .ant-select-selection--multiple {
  min-height: 24px;
}

.ant-select-sm
  .ant-select-selection--multiple
  .ant-select-selection__rendered
  li {
  height: 16px;
  line-height: 14px;
}

.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear {
  top: 12px;
}

.ant-select-sm .ant-select-arrow,
.ant-select-sm .ant-select-selection__clear {
  right: 8px;
}

.ant-select-disabled .ant-select-selection__choice__remove {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
}

.ant-select-disabled .ant-select-selection__choice__remove:hover {
  color: rgba(0, 0, 0, 0.25);
}

.ant-select-search__field__wrap {
  display: inline-block;
  position: relative;
}

.ant-select-search__field__placeholder,
.ant-select-selection__placeholder {
  position: absolute;
  top: 50%;
  left: 0;
  right: 9px;
  color: #bfbfbf;
  line-height: 20px;
  height: 20px;
  max-width: 100%;
  margin-top: -10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.ant-select-search__field__placeholder {
  left: 12px;
}

.ant-select-search__field__mirror {
  position: absolute;
  top: -9999px;
  left: -9999px;
  white-space: pre;
  pointer-events: none;
}

.ant-select-search--inline {
  position: absolute;
  height: 100%;
  width: 100%;
}

.ant-select-search--inline .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}

.ant-select-search--inline .ant-select-search__field {
  border-width: 0;
  font-size: 100%;
  height: 100%;
  width: 100%;
  background: transparent;
  outline: 0;
  border-radius: 4px;
  line-height: 1;
}

.ant-select-search--inline > i {
  float: right;
}

.ant-select-selection--multiple {
  min-height: 32px;
  cursor: text;
  padding-bottom: 3px;
  zoom: 1;
}

.ant-select-selection--multiple:after,
.ant-select-selection--multiple:before {
  content: "";
  display: table;
}

.ant-select-selection--multiple:after {
  clear: both;
}

.ant-select-selection--multiple .ant-select-search--inline {
  float: left;
  position: static;
  width: auto;
  padding: 0;
  max-width: 100%;
}

.ant-select-selection--multiple
  .ant-select-search--inline
  .ant-select-search__field {
  max-width: 100%;
  width: 0.75em;
}

.ant-select-selection--multiple .ant-select-selection__rendered {
  margin-left: 5px;
  margin-bottom: -3px;
  height: auto;
}

.ant-select-selection--multiple .ant-select-selection__placeholder {
  margin-left: 6px;
}

.ant-select-selection--multiple .ant-select-selection__rendered > ul > li,
.ant-select-selection--multiple > ul > li {
  margin-top: 3px;
  height: 24px;
  line-height: 22px;
}

.ant-select-selection--multiple .ant-select-selection__choice {
  color: rgba(0, 0, 0, 0.65);
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  cursor: default;
  float: left;
  margin-right: 4px;
  max-width: 99%;
  position: relative;
  overflow: hidden;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 0 20px 0 10px;
}

.ant-select-selection--multiple .ant-select-selection__choice__disabled {
  padding: 0 10px;
}

.ant-select-selection--multiple .ant-select-selection__choice__content {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.45);
  line-height: inherit;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
  position: absolute;
  right: 4px;
}

.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  display: block;
  font-family: anticon !important;
}

:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 12px;
}

.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {
  color: #404040;
}

.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  content: "\E633";
}

.ant-select-selection--multiple .ant-select-selection__clear {
  top: 16px;
}

.ant-select-allow-clear
  .ant-select-selection--single
  .ant-select-selection-selected-value {
  padding-right: 16px;
}

.ant-select-allow-clear
  .ant-select-selection--multiple
  .ant-select-selection__rendered {
  margin-right: 20px;
}

.ant-select-open .ant-select-arrow:before {
  transform: rotate(180deg);
}

.ant-select-open .ant-select-selection {
  border-color: #40a9ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px !important;
}

.ant-select-combobox .ant-select-arrow {
  display: none;
}

.ant-select-combobox .ant-select-search--inline {
  height: 100%;
  width: 100%;
  float: none;
}

.ant-select-combobox .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}

.ant-select-combobox .ant-select-search__field {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: none;
}

.ant-select-combobox.ant-select-allow-clear
  .ant-select-selection:hover
  .ant-select-selection__rendered {
  margin-right: 20px;
}

.ant-select-dropdown {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  box-sizing: border-box;
  z-index: 1050;
  left: -9999px;
  top: -9999px;
  position: absolute;
  outline: none;
  font-size: 14px;
}

.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft,
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}

.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft,
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}

.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}

.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}

.ant-select-dropdown-hidden {
  display: none;
}

.ant-select-dropdown-menu {
  outline: none;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  max-height: 250px;
  overflow: auto;
}

.ant-select-dropdown-menu-item-group-list {
  margin: 0;
  padding: 0;
}

.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {
  padding-left: 20px;
}

.ant-select-dropdown-menu-item-group-title {
  color: rgba(0, 0, 0, 0.45);
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
}

.ant-select-dropdown-menu-item-group-list
  .ant-select-dropdown-menu-item:first-child:not(:last-child),
.ant-select-dropdown-menu-item-group:not(:last-child)
  .ant-select-dropdown-menu-item-group-list
  .ant-select-dropdown-menu-item:last-child {
  border-radius: 0;
}

.ant-select-dropdown-menu-item {
  position: relative;
  display: block;
  padding: 5px 12px;
  line-height: 22px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.3s ease;
}

.ant-select-dropdown-menu-item:hover {
  background-color: #e6f7ff;
}

.ant-select-dropdown-menu-item:first-child {
  border-radius: 4px 4px 0 0;
}

.ant-select-dropdown-menu-item:last-child {
  border-radius: 0 0 4px 4px;
}

.ant-select-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}

.ant-select-dropdown-menu-item-selected,
.ant-select-dropdown-menu-item-selected:hover {
  background-color: #fafafa;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}

.ant-select-dropdown-menu-item-active {
  background-color: #e6f7ff;
}

.ant-select-dropdown-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  overflow: hidden;
  background-color: #e8e8e8;
  line-height: 0;
}

.ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item:after {
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\E632";
  color: transparent;
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
  transition: all 0.2s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  font-weight: 700;
  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;
}

:root
  .ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item:after {
  font-size: 12px;
}

.ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item:hover:after {
  color: #ddd;
}

.ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item-disabled:after {
  display: none;
}

.ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item-selected:after,
.ant-select-dropdown.ant-select-dropdown--multiple
  .ant-select-dropdown-menu-item-selected:hover:after {
  color: #1890ff;
  display: inline-block;
}

.ant-select-dropdown-container-open .ant-select-dropdown,
.ant-select-dropdown-open .ant-select-dropdown {
  display: block;
}

.ant-input {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-variant: tabular-nums;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: inline-block;
  padding: 4px 11px;
  width: 100%;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
}

.ant-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}

.ant-input:-ms-input-placeholder {
  color: #bfbfbf;
}

.ant-input::-webkit-input-placeholder {
  color: #bfbfbf;
}

.ant-input:focus,
.ant-input:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.ant-input:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-input-disabled {
  background-color: #f5f5f5;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}

.ant-input-disabled:hover {
  border-color: #e6d8d8;
  border-right-width: 1px !important;
}

textarea.ant-input {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  min-height: 32px;
}

.ant-input-lg {
  padding: 6px 11px;
  height: 40px;
  font-size: 16px;
}

.ant-input-sm {
  padding: 1px 7px;
  height: 24px;
}

.ant-input-group {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: table;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.ant-input-group[class*="col-"] {
  float: none;
  padding-left: 0;
  padding-right: 0;
}

.ant-input-group > [class*="col-"] {
  padding-right: 8px;
}

.ant-input-group > [class*="col-"]:last-child {
  padding-right: 0;
}

.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group > .ant-input {
  display: table-cell;
}

.ant-input-group-addon:not(:first-child):not(:last-child),
.ant-input-group-wrap:not(:first-child):not(:last-child),
.ant-input-group > .ant-input:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-group-wrap > * {
  display: block !important;
}

.ant-input-group .ant-input {
  float: left;
  width: 100%;
  margin-bottom: 0;
}

.ant-input-group .ant-input:focus,
.ant-input-group .ant-input:hover {
  z-index: 1;
  border-right-width: 1px;
}

.ant-input-group-addon {
  padding: 0 11px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;
  transition: all 0.3s;
}

.ant-input-group-addon .ant-select {
  margin: -5px -11px;
}

.ant-input-group-addon .ant-select .ant-select-selection {
  background-color: inherit;
  margin: -1px;
  border: 1px solid transparent;
  box-shadow: none;
}

.ant-input-group-addon .ant-select-focused .ant-select-selection,
.ant-input-group-addon .ant-select-open .ant-select-selection {
  color: #1890ff;
}

.ant-input-group-addon > i:only-child:after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.ant-input-group-addon:first-child,
.ant-input-group-addon:first-child .ant-select .ant-select-selection,
.ant-input-group > .ant-input:first-child,
.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.ant-input-group-addon:first-child {
  border-right: 0;
}

.ant-input-group-addon:last-child {
  border-left: 0;
}

.ant-input-group-addon:last-child,
.ant-input-group-addon:last-child .ant-select .ant-select-selection,
.ant-input-group > .ant-input:last-child,
.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.ant-input-group-lg .ant-input,
.ant-input-group-lg > .ant-input-group-addon {
  padding: 6px 11px;
  height: 40px;
  font-size: 16px;
}

.ant-input-group-sm .ant-input,
.ant-input-group-sm > .ant-input-group-addon {
  padding: 1px 7px;
  height: 24px;
}

.ant-input-group-lg .ant-select-selection--single {
  height: 40px;
}

.ant-input-group-sm .ant-select-selection--single {
  height: 24px;
}

.ant-input-group .ant-input-affix-wrapper {
  display: table-cell;
  width: 100%;
  float: left;
}

.ant-input-group.ant-input-group-compact {
  display: block;
  zoom: 1;
}

.ant-input-group.ant-input-group-compact:after,
.ant-input-group.ant-input-group-compact:before {
  content: "";
  display: table;
}

.ant-input-group.ant-input-group-compact:after {
  clear: both;
}

.ant-input-group.ant-input-group-compact > * {
  border-radius: 0;
  border-right-width: 0;
  vertical-align: top;
  float: none;
  display: inline-block;
}

.ant-input-group.ant-input-group-compact .ant-input {
  float: none;
}

.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-mention-wrapper
  .ant-mention-editor,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,
.ant-input-group.ant-input-group-compact
  > .ant-time-picker
  .ant-time-picker-input {
  border-radius: 0;
  border-right-width: 0;
}

.ant-input-group.ant-input-group-compact
  > .ant-calendar-picker:first-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-cascader-picker:first-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-mention-wrapper:first-child
  .ant-mention-editor,
.ant-input-group.ant-input-group-compact
  > .ant-select-auto-complete:first-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-select:first-child
  > .ant-select-selection,
.ant-input-group.ant-input-group-compact
  > .ant-time-picker:first-child
  .ant-time-picker-input,
.ant-input-group.ant-input-group-compact > :first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.ant-input-group.ant-input-group-compact
  > .ant-calendar-picker:last-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-cascader-picker:last-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-mention-wrapper:last-child
  .ant-mention-editor,
.ant-input-group.ant-input-group-compact
  > .ant-select-auto-complete:last-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-select:last-child
  > .ant-select-selection,
.ant-input-group.ant-input-group-compact
  > .ant-time-picker:last-child
  .ant-time-picker-input,
.ant-input-group.ant-input-group-compact > :last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right-width: 1px;
}

.ant-input-group-wrapper {
  display: inline-block;
  vertical-align: top;
  width: 100%;
}

.ant-input-affix-wrapper {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: inline-block;
  width: 100%;
}

.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.ant-input-affix-wrapper .ant-input {
  position: static;
}

.ant-input-affix-wrapper .ant-input-prefix,
.ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;
  color: rgba(0, 0, 0, 0.65);
}

.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 1.5;
}

.ant-input-affix-wrapper .ant-input-prefix {
  left: 12px;
}

.ant-input-affix-wrapper .ant-input-suffix {
  right: 12px;
}

.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 30px;
}

.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 30px;
}

.ant-input-affix-wrapper .ant-input {
  min-height: 100%;
}

.ant-input-search-icon {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.3s;
}

.ant-input-search-icon:hover {
  color: #333;
}

.ant-input-search:not(.ant-input-search-small) > .ant-input-suffix {
  right: 12px;
}

.ant-input-search > .ant-input-suffix > .ant-input-search-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-input-search
  > .ant-input-suffix
  > .ant-input-search-button
  > .anticon-search {
  font-size: 16px;
}

.ant-input-search.ant-input-search-enter-button > .ant-input {
  padding-right: 46px;
}

.ant-input-search.ant-input-search-enter-button > .ant-input-suffix {
  right: 0;
}

.ant-divider {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #e8e8e8;
}

.ant-divider,
.ant-divider-vertical {
  margin: 0 8px;
  display: inline-block;
  height: 0.9em;
  width: 1px;
  vertical-align: middle;
  position: relative;
  top: -0.06em;
}

.ant-divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  clear: both;
}

.ant-divider-horizontal.ant-divider-with-text,
.ant-divider-horizontal.ant-divider-with-text-left,
.ant-divider-horizontal.ant-divider-with-text-right {
  display: table;
  white-space: nowrap;
  text-align: center;
  background: transparent;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  margin: 16px 0;
}

.ant-divider-horizontal.ant-divider-with-text-left:after,
.ant-divider-horizontal.ant-divider-with-text-left:before,
.ant-divider-horizontal.ant-divider-with-text-right:after,
.ant-divider-horizontal.ant-divider-with-text-right:before,
.ant-divider-horizontal.ant-divider-with-text:after,
.ant-divider-horizontal.ant-divider-with-text:before {
  content: "";
  display: table-cell;
  position: relative;
  top: 50%;
  width: 50%;
  border-top: 1px solid #e8e8e8;
  transform: translateY(50%);
}

.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text,
.ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text {
  display: inline-block;
  padding: 0 10px;
}

.ant-divider-horizontal.ant-divider-with-text-left:before {
  top: 50%;
  width: 5%;
}

.ant-divider-horizontal.ant-divider-with-text-left:after,
.ant-divider-horizontal.ant-divider-with-text-right:before {
  top: 50%;
  width: 95%;
}

.ant-divider-horizontal.ant-divider-with-text-right:after {
  top: 50%;
  width: 5%;
}

.ant-divider-inner-text {
  display: inline-block;
  padding: 0 24px;
}

.ant-divider-dashed {
  background: none;
  border-top: 1px dashed #e8e8e8;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed,
.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed {
  border-top: 0;
}

.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed:after,
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed:before,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed:after,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed:before,
.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:after,
.ant-divider-horizontal.ant-divider-with-text.ant-divider-dashed:before {
  border-style: dashed none none;
}

.data-manage-modal .ant-modal-content {
  height: calc(100vh - 44px);
}

.data-manage-modal .ant-table-header tr th {
  width: 200px;
  max-width: 200px;
  padding: 12px 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.data-manage-modal .ant-table-header tr .ant-table-selection-column {
  width: 42px;
  min-width: 0;
  padding: 12px 0;
}

.data-manage-modal .ant-table-body tr td {
  width: 200px;
  max-width: 200px;
  padding: 12px 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.data-manage-modal .ant-table-body tr .ant-table-selection-column {
  width: 42px;
  min-width: 0;
  padding: 12px 0;
}

.data-manage-modal-hd {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.data-manage-modal-hd .space-flex1 {
  flex: 1;
}

.data-manage-modal-hd .toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.data-manage-modal-hd .toolbar-btn svg {
  width: 16px;
  height: 16px;
  fill: rgba(25, 31, 37, 0.56);
}

.data-manage-modal-hd .toolbar-btn > img {
  width: 14px;
  height: 14px;
}

.data-manage-modal-hd .toolbar-btn > span {
  margin-left: 6px;
  font-size: 14px;
  color: #191f25;
}

.data-manage-modal-hd .ant-input-search {
  width: 240px;
  height: 32px;
}

.data-manage-modal-hd .ant-input {
  width: 240px !important;
  border-radius: 4px !important;
}

.data-manage-drawer {
  width: 0 !important;
}

.data-manage-drawer .ant-drawer-content-wrapper {
  height: calc(100vh - 45px);
  margin: 20px;
}

.data-manage-drawer .ant-drawer-content-wrapper .ant-drawer-content {
  border-radius: 4px;
}

.data-manage-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.data-manage-detail-hd {
  margin-bottom: 8px;
}

.data-manage-detail-hd > span {
  margin-left: 2px;
  font-size: 12px;
  color: rgba(13, 0, 19, 0.72);
}

.data-manage-detail-hd > span:nth-child(2) {
  color: rgba(13, 0, 19, 0.56);
}

.data-manage-detail-item {
  padding: 12px 0;
  border-bottom: 1px solid #f8f8f8;
}

.data-manage-detail-item .label {
  font-size: 13px;
  color: rgba(25, 31, 37, 0.56);
  letter-spacing: -0.08px;
  line-height: 18px;
}

.data-manage-detail-item .value {
  margin-top: 4px;
  font-size: 17px;
  color: #191f25;
  letter-spacing: -0.41px;
  line-height: 22px;
}

.photo-field-data img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.table-field-data {
  display: flex;
  flex-direction: column;
}

.table-field-data .row-hd {
  display: flex;
}

.table-field-data .row-hd > div {
  width: 64px;
}

.table-field-data .row {
  display: flex;
}

.table-field-data .row > div {
  width: 64px;
  font-size: 12px;
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body,
html {
  font-size: 14px;
}

body {
  font-family: Microsoft Yahei, Lucida Grande, Lucida Sans Unicode, Helvetica,
    Arial, Verdana, sans-serif;
  line-height: 1.6;
  background-color: #fff;
  position: static !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

html.onpc body {
  font-family: \\51AC\9752\9ED1\4F53\7B80\4F53\4E2D\6587, Tahoma,
    Hiragino Sans GB, Microsoft YaHei, \\5FAE\8F6F\96C5\9ED1, STHeiti,
    WenQuanYi Micro Hei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
}

ol,
ul {
  list-style-type: none;
}

b,
strong {
  font-weight: 700;
}

img {
  border: 0;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
  -webkit-appearance: none;
}

button,
input {
  line-height: normal;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

input[disabled] {
  background: none;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

table,
td,
th {
  border: 0;
}

td,
th {
  padding: 0;
  vertical-align: top;
}

th {
  font-weight: 700;
  text-align: left;
}

thead th {
  white-space: nowrap;
}

a {
  text-decoration: none;
  cursor: pointer;
  color: #3296fa;
}

a:active,
a:hover {
  outline: 0;
  color: #3296fa;
}

small {
  font-size: 80%;
}

#App .ant-alert .anticon-cross {
  line-height: 22px;
}

#App .ant-form-item-label {
  overflow: visible;
  white-space: normal;
}

#App .ant-form-item-required:before {
  position: absolute;
  left: -10px;
  top: 50%;
  margin-top: -7px;
}

#App .ant-form-item-label .ant-form-explain {
  margin-left: 10px;
  font-size: 12px;
}

#App .ant-tabs .ant-tabs-tab-next,
#App .ant-tabs .ant-tabs-tab-prev {
  display: none;
}

#App .ant-tabs .ant-tabs-nav-container-scrolling {
  padding-left: 0;
  padding-right: 0;
}

#App .ant-tabs .ant-tabs-nav,
#App .ant-tabs .ant-tabs-nav > div {
  display: flex;
  width: 100%;
  font-size: 0;
}

#App .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  position: relative;
  flex: 1;
  font-size: 14px;
  margin-right: 0;
  width: 104px;
  height: auto;
  text-align: center;
  overflow: hidden;
  padding: 12px 5px;
}

#App .ant-table-wrapper .ant-table-tbody td {
  vertical-align: middle;
}

.guide-area {
  pointer-events: none;
  display: block;
  width: 41px;
  height: 41px;
  border-radius: 50%;
  background: rgba(50, 150, 250, 0.2);
}

.guide-container {
  position: relative;
}

.guide-tooltip.ant-tooltip {
  z-index: 999;
}

.guide-tooltip.ant-tooltip .version-tip-container {
  overflow: hidden;
}

.guide-tooltip.ant-tooltip .version-tip-container .version-tip-btn {
  float: right;
  margin: 10px;
}

.guide-tooltip.ant-tooltip .ant-tooltip-inner {
  font-family: PingFangSC-Regular;
  background: #3296fa;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  padding: 8px;
}

.guide-tooltip.ant-tooltip.adjust .ant-tooltip-arrow,
.guide-tooltip.ant-tooltip.adjust .ant-tooltip-content {
  margin-top: 12px;
}

.guide-tooltip.ant-tooltip.ant-tooltip-placement-bottom .ant-tooltip-arrow,
.guide-tooltip.ant-tooltip.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.guide-tooltip.ant-tooltip.ant-tooltip-placement-bottomRight
  .ant-tooltip-arrow {
  border-bottom-color: #3296fa;
}

.guide-tooltip.ant-tooltip.ant-tooltip-placement-top .ant-tooltip-arrow,
.guide-tooltip.ant-tooltip.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  border-top-color: #3296fa;
}

.guide-tooltip.ant-tooltip.ant-tooltip-placement-right .ant-tooltip-arrow {
  border-right-color: #3296fa;
}

body,
html {
  font-size: 12px !important;
  color: #191f25 !important;
  background: #f6f6f6 !important;
}

.wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
}

.xiaomi {
  z-index: 998 !important;
}

@font-face {
  font-family: IconFont;
  src: url("//at.alicdn.com/t/font_135284_ph2thxxbzgf.eot");
  src: url("//at.alicdn.com/t/font_135284_ph2thxxbzgf.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_135284_ph2thxxbzgf.woff") format("woff"),
    url("//at.alicdn.com/t/font_135284_ph2thxxbzgf.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_135284_ph2thxxbzgf.svg#IconFont") format("svg");
}

.iconfont {
  font-family: IconFont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.fd-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 997;
  width: 100%;
  height: 60px;
  font-size: 14px;
  color: #fff;
  background: #3296fa;
  display: flex;
  align-items: center;
}

.fd-nav > * {
  flex: 1;
  width: 100%;
}

.fd-nav .fd-nav-left {
  display: -webkit-box;
  display: flex;
  align-items: center;
}

.fd-nav .fd-nav-center {
  flex: none;
  width: 600px;
  text-align: center;
}

.fd-nav .fd-nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
}

.fd-nav .fd-nav-right-data {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.fd-nav .fd-nav-right-data svg {
  width: 14px;
  height: 14px;
  fill: #fff;
}

.fd-nav .fd-nav-right-data > img {
  width: 14px;
  height: 14px;
}

.fd-nav .fd-nav-right-data > span {
  margin-left: 4px;
  font-size: 14px;
  letter-spacing: -0.22px;
}

.fd-nav .fd-nav-back {
  display: inline-block;
  width: 60px;
  height: 60px;
  font-size: 22px;
  border-right: 1px solid #1583f2;
  text-align: center;
  cursor: pointer;
}

.fd-nav .fd-nav-back:hover {
  background: #5af;
}

.fd-nav .fd-nav-back:active {
  background: #1583f2;
}

.fd-nav .fd-nav-back .anticon {
  line-height: 60px;
}

.fd-nav .fd-nav-title {
  width: 0;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 15px;
}

.fd-nav a {
  color: #fff;
  margin-left: 12px;
}

.fd-nav .button-publish {
  min-width: 80px;
  margin-left: 4px;
  margin-right: 15px;
  color: #3296fa;
  border-color: #fff;
}

.fd-nav .button-publish.ant-btn:focus,
.fd-nav .button-publish.ant-btn:hover {
  color: #3296fa;
  border-color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);
}

.fd-nav .button-publish.ant-btn:active {
  color: #3296fa;
  background: #d6eaff;
  box-shadow: none;
}

.fd-nav .button-publish .ant-btn.disabled,
.fd-nav .button-publish .ant-btn[disabled] {
  min-width: 80px;
  border-color: #96c9fe;
  background: #96c9fe;
  pointer-events: none;
  color: #3296fa;
}

.fd-nav .button-preview {
  min-width: 80px;
  margin-left: 16px;
  margin-right: 4px;
  color: #fff;
  border-color: #fff;
  background: transparent;
}

.fd-nav .button-preview.ant-btn:focus,
.fd-nav .button-preview.ant-btn:hover {
  color: #fff;
  border-color: #fff;
  background: #59acfc;
}

.fd-nav .button-preview.ant-btn.disabled,
.fd-nav .button-preview.ant-btn[disabled] {
  opacity: 0.7;
  color: #3296fa;
  pointer-events: none;
}

.fd-nav .button-preview.ant-btn:active {
  color: #fff;
  border-color: #fff;
  background: #2186ef;
}

.fd-nav-content {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 30px;
}

.fd-panel {
  margin: 16px 0 25px;
  border-radius: 8px;
  padding: 20px 30px;
  background: #fff;
}

.fd-container-sm {
  width: 600px;
  margin: 16px auto;
}

.success-modal .ant-modal-body {
  text-align: left;
}

.success-modal-title {
  position: relative;
  padding-left: 38px;
  margin: 6px 0;
  font-size: 20px;
  color: #191f25;
  line-height: 32px;
}

.success-modal-content {
  margin-top: 26px;
  position: relative;
  padding-left: 140px;
}

.success-modal-icon {
  position: absolute;
  top: 5px;
  left: 0;
  font-size: 22px;
  color: #52c41a;
}

.success-modal-qrcode {
  position: absolute;
  top: 0;
  left: 3px;
}

.success-modal-qrlink .anticon {
  font-size: 14px;
}

.success-modal-textarea {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 120px;
}

.success-modal-desc {
  position: relative;
  padding-left: 20px;
  font-size: 16px;
  line-height: 22px;
  margin: 3px 0;
}

.success-modal-desc i {
  position: absolute;
  left: 0;
  top: 4px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  line-height: 14px;
  color: #fff;
  background: #191f25;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.success-modal-desc-tip {
  font-size: 12px;
  color: #191f25;
  opacity: 0.4;
}

.preview-modal-content {
  text-align: center;
}

.preview-modal-content svg {
  margin: 15px auto;
}

.preview-modal-content p {
  font-size: 20px;
  color: #191f25;
  margin: 0 0 15px;
  line-height: 1.4;
}

.error-modal .anticon-close-circle {
  color: #f5222d !important;
}

.error-modal-desc {
  font-size: 13px;
  color: rgba(25, 31, 37, 0.56);
  line-height: 22px;
  margin-bottom: 14px;
}

.error-modal-list {
  height: 200px;
  overflow-y: auto;
  margin-right: -25px;
  padding-right: 25px;
}

.error-modal-item {
  padding: 10px 20px;
  line-height: 21px;
  background: #f6f6f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border-radius: 4px;
}

.error-modal-item-label {
  flex: none;
  font-size: 15px;
  color: rgba(25, 31, 37, 0.56);
  padding-right: 10px;
}

.error-modal-item-content {
  text-align: right;
  flex: 1;
  font-size: 13px;
  color: #191f25;
}

.btn-switch {
  cursor: pointer;
  position: fixed;
  top: 86px;
  left: 40px;
  z-index: 100;
  height: 44px;
  line-height: 44px;
  border-radius: 20px;
  padding: 0 16px;
  font-size: 16px;
  color: #fff;
  background: #3f9af4;
  letter-spacing: 1px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.btn-switch .btn-switch-icon {
  width: 14px;
  height: 14px;
  background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1303 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path d="M1252.838233 407.733734H51.978606a51.851071 51.851071 0 0 1-44.962418-24.668822 48.499835 48.499835 0 0 1 13.032585-63.859667L434.019529 11.077697a51.478711 51.478711 0 0 1 70.934499 9.30899 48.499835 48.499835 0 0 1-9.495169 69.072701l-295.094962 219.692149h1051.357258c26.34444 0 49.151464 19.176518 51.478711 44.776238a48.499835 48.499835 0 0 1-13.032585 37.701407 51.199441 51.199441 0 0 1-37.235958 16.104552zM838.960566 1023.988829a50.454722 50.454722 0 0 1-47.941295-33.512361 48.592924 48.592924 0 0 1 17.221631-54.923038l295.094962-219.692148H51.792426a50.733992 50.733992 0 0 1-51.478711-44.776239 48.499835 48.499835 0 0 1 13.032585-37.794497 51.199441 51.199441 0 0 1 37.329048-16.011462h1200.859627a51.757981 51.757981 0 0 1 44.962418 24.668822 48.499835 48.499835 0 0 1-13.125675 63.859667l-413.877666 308.127548A51.199441 51.199441 0 0 1 838.960566 1023.988829z" fill="#fff"></path></svg>');
  background-size: 100%;
  background-repeat: none;
  margin-right: 6px;
}

.btn-switch.new {
  color: rgba(25, 31, 37, 0.56);
  background: #fff;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
}

.btn-switch.new .btn-switch-icon {
  background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1303 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path d="M1252.838233 407.733734H51.978606a51.851071 51.851071 0 0 1-44.962418-24.668822 48.499835 48.499835 0 0 1 13.032585-63.859667L434.019529 11.077697a51.478711 51.478711 0 0 1 70.934499 9.30899 48.499835 48.499835 0 0 1-9.495169 69.072701l-295.094962 219.692149h1051.357258c26.34444 0 49.151464 19.176518 51.478711 44.776238a48.499835 48.499835 0 0 1-13.032585 37.701407 51.199441 51.199441 0 0 1-37.235958 16.104552zM838.960566 1023.988829a50.454722 50.454722 0 0 1-47.941295-33.512361 48.592924 48.592924 0 0 1 17.221631-54.923038l295.094962-219.692148H51.792426a50.733992 50.733992 0 0 1-51.478711-44.776239 48.499835 48.499835 0 0 1 13.032585-37.794497 51.199441 51.199441 0 0 1 37.329048-16.011462h1200.859627a51.757981 51.757981 0 0 1 44.962418 24.668822 48.499835 48.499835 0 0 1-13.125675 63.859667l-413.877666 308.127548A51.199441 51.199441 0 0 1 838.960566 1023.988829z" fill="#7E8184"></path></svg>');
}

.ant-form {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-form legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: inherit;
  color: rgba(0, 0, 0, 0.45);
  border: 0;
  border-bottom: 1px solid #d9d9d9;
}

.ant-form label {
  font-size: 14px;
}

.ant-form input[type="search"] {
  box-sizing: border-box;
}

.ant-form input[type="checkbox"],
.ant-form input[type="radio"] {
  line-height: normal;
}

.ant-form input[type="file"] {
  display: block;
}

.ant-form input[type="range"] {
  display: block;
  width: 100%;
}

.ant-form select[multiple],
.ant-form select[size] {
  height: auto;
}

.ant-form input[type="checkbox"]:focus,
.ant-form input[type="file"]:focus,
.ant-form input[type="radio"]:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.ant-form output {
  display: block;
  padding-top: 15px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
}

.ant-form-item-required:before {
  display: inline-block;
  margin-right: 4px;
  content: "*";
  font-family: SimSun;
  line-height: 1;
  font-size: 14px;
  color: #f5222d;
}

.ant-form-hide-required-mark .ant-form-item-required:before {
  display: none;
}

.ant-checkbox-inline.disabled,
.ant-checkbox-vertical.disabled,
.ant-checkbox.disabled label,
.ant-radio-inline.disabled,
.ant-radio-vertical.disabled,
.ant-radio.disabled label,
input[type="checkbox"].disabled,
input[type="checkbox"][disabled],
input[type="radio"].disabled,
input[type="radio"][disabled] {
  cursor: not-allowed;
}

.ant-form-item {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: 24px;
  vertical-align: top;
}

.ant-form-item label {
  position: relative;
}

.ant-form-item label > .anticon {
  vertical-align: top;
  font-size: 14px;
}

.ant-form-item-control > .ant-form-item:last-child,
.ant-form-item [class^="ant-col-"] > .ant-form-item:only-child {
  margin-bottom: -24px;
}

.ant-form-item-control {
  line-height: 39.9999px;
  position: relative;
  zoom: 1;
}

.ant-form-item-control:after,
.ant-form-item-control:before {
  content: "";
  display: table;
}

.ant-form-item-control:after {
  clear: both;
}

.ant-form-item-children {
  position: relative;
}

.ant-form-item-with-help {
  margin-bottom: 5px;
}

.ant-form-item-label {
  text-align: right;
  vertical-align: middle;
  line-height: 39.9999px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.ant-form-item-label label {
  color: rgba(0, 0, 0, 0.85);
}

.ant-form-item-label label:after {
  content: ":";
  margin: 0 8px 0 2px;
  position: relative;
  top: -0.5px;
}

.ant-form-item .ant-switch {
  margin: 2px 0 4px;
}

.ant-form-item-no-colon .ant-form-item-label label:after {
  content: " ";
}

.ant-form-explain,
.ant-form-extra {
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.5;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  margin-top: -2px;
  clear: both;
}

.ant-form-extra {
  padding-top: 4px;
}

.ant-form-text {
  display: inline-block;
  padding-right: 8px;
}

.ant-form-split {
  display: block;
  text-align: center;
}

form .has-feedback .ant-input {
  padding-right: 24px;
}

form .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,
form
  .has-feedback
  :not(.ant-input-group-addon)
  > .ant-select
  .ant-select-selection__clear,
form .has-feedback > .ant-select .ant-select-arrow,
form .has-feedback > .ant-select .ant-select-selection__clear {
  right: 28px;
}

form
  .has-feedback
  :not(.ant-input-group-addon)
  > .ant-select
  .ant-select-selection-selected-value,
form .has-feedback > .ant-select .ant-select-selection-selected-value {
  padding-right: 42px;
}

form .has-feedback .ant-cascader-picker-arrow {
  margin-right: 17px;
}

form .has-feedback .ant-calendar-picker-clear,
form .has-feedback .ant-calendar-picker-icon,
form .has-feedback .ant-cascader-picker-clear,
form
  .has-feedback
  .ant-input-search:not(.ant-input-search-enter-button)
  .ant-input-suffix,
form .has-feedback .ant-time-picker-clear,
form .has-feedback .ant-time-picker-icon {
  right: 28px;
}

form textarea.ant-input {
  height: auto;
}

form .ant-upload {
  background: transparent;
}

form input[type="checkbox"],
form input[type="radio"] {
  width: 14px;
  height: 14px;
}

form .ant-checkbox-inline,
form .ant-radio-inline {
  display: inline-block;
  vertical-align: middle;
  font-weight: 400;
  cursor: pointer;
  margin-left: 8px;
}

form .ant-checkbox-inline:first-child,
form .ant-radio-inline:first-child {
  margin-left: 0;
}

form .ant-checkbox-vertical,
form .ant-radio-vertical {
  display: block;
}

form .ant-checkbox-vertical + .ant-checkbox-vertical,
form .ant-radio-vertical + .ant-radio-vertical {
  margin-left: 0;
}

form .ant-input-number + .ant-form-text {
  margin-left: 8px;
}

form .ant-input-number-handler-wrap {
  z-index: 2;
}

form .ant-cascader-picker,
form .ant-select {
  width: 100%;
}

form .ant-input-group .ant-cascader-picker,
form .ant-input-group .ant-select {
  width: auto;
}

form .ant-input-group-wrapper,
form :not(.ant-input-group-wrapper) > .ant-input-group {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

.ant-input-group-wrap .ant-select-selection {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.ant-input-group-wrap .ant-select-selection:hover {
  border-color: #d9d9d9;
}

.ant-input-group-wrap .ant-select-selection--single {
  margin-left: -1px;
  height: 40px;
  background-color: #eee;
}

.ant-input-group-wrap
  .ant-select-selection--single
  .ant-select-selection__rendered {
  padding-left: 8px;
  padding-right: 25px;
  line-height: 30px;
}

.ant-input-group-wrap .ant-select-open .ant-select-selection {
  border-color: #d9d9d9;
  box-shadow: none;
}

.ant-col-24.ant-form-item-label,
.ant-col-xl-24.ant-form-item-label,
.ant-form-vertical .ant-form-item-label {
  padding: 0 0 8px;
  margin: 0;
  display: block;
  text-align: left;
  line-height: 1.5;
}

.ant-col-24.ant-form-item-label label:after,
.ant-col-xl-24.ant-form-item-label label:after,
.ant-form-vertical .ant-form-item-label label:after {
  display: none;
}

.ant-form-vertical .ant-form-item {
  padding-bottom: 8px;
}

.ant-form-vertical .ant-form-item-control {
  line-height: 1.5;
}

.ant-form-vertical .ant-form-explain,
.ant-form-vertical .ant-form-extra {
  margin-top: 2px;
  margin-bottom: -4px;
}

@media (max-width: 575px) {
  .ant-form-item-control-wrapper,
  .ant-form-item-label {
    display: block;
    width: 100%;
  }
  .ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-form-item-label label:after {
    display: none;
  }
  .ant-col-xs-24.ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-col-xs-24.ant-form-item-label label:after {
    display: none;
  }
}

@media (max-width: 767px) {
  .ant-col-sm-24.ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-col-sm-24.ant-form-item-label label:after {
    display: none;
  }
}

@media (max-width: 991px) {
  .ant-col-md-24.ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-col-md-24.ant-form-item-label label:after {
    display: none;
  }
}

@media (max-width: 1199px) {
  .ant-col-lg-24.ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-col-lg-24.ant-form-item-label label:after {
    display: none;
  }
}

@media (max-width: 1599px) {
  .ant-col-xl-24.ant-form-item-label {
    padding: 0 0 8px;
    margin: 0;
    display: block;
    text-align: left;
    line-height: 1.5;
  }
  .ant-col-xl-24.ant-form-item-label label:after {
    display: none;
  }
}

.ant-form-inline .ant-form-item {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 0;
}

.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 24px;
}

.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper,
.ant-form-inline .ant-form-item > .ant-form-item-label {
  display: inline-block;
  vertical-align: middle;
}

.ant-form-inline .ant-form-text,
.ant-form-inline .has-feedback {
  display: inline-block;
}

.ant-form-inline .ant-form-explain {
  position: absolute;
}

.has-error.has-feedback .ant-form-item-children:after,
.has-success.has-feedback .ant-form-item-children:after,
.has-warning.has-feedback .ant-form-item-children:after,
.is-validating.has-feedback .ant-form-item-children:after {
  position: absolute;
  top: 50%;
  right: 0;
  visibility: visible;
  pointer-events: none;
  width: 32px;
  height: 20px;
  line-height: 20px;
  margin-top: -10px;
  text-align: center;
  font-size: 14px;
  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "";
  z-index: 1;
}

.has-success.has-feedback .ant-form-item-children:after {
  animation-name: diffZoomIn1 !important;
  content: "\E630";
  color: #52c41a;
}

.has-warning .ant-form-explain,
.has-warning .ant-form-split {
  color: #faad14;
}

.has-warning .ant-input,
.has-warning .ant-input:hover {
  border-color: #faad14;
}

.has-warning .ant-input:focus {
  border-color: #ffc53d;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px !important;
}

.has-warning .ant-input:not([disabled]):hover {
  border-color: #faad14;
}

.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {
  border-color: #ffc53d;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px !important;
}

.has-warning .ant-input-prefix {
  color: #faad14;
}

.has-warning .ant-input-group-addon {
  color: #faad14;
  border-color: #faad14;
  background-color: #fff;
}

.has-warning .has-feedback {
  color: #faad14;
}

.has-warning.has-feedback .ant-form-item-children:after {
  content: "\E62C";
  color: #faad14;
  animation-name: diffZoomIn3 !important;
}

.has-warning .ant-select-selection {
  border-color: #faad14;
}

.has-warning .ant-select-focused .ant-select-selection,
.has-warning .ant-select-open .ant-select-selection {
  border-color: #ffc53d;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px !important;
}

.has-warning .ant-calendar-picker-icon:after,
.has-warning .ant-cascader-picker-arrow,
.has-warning .ant-picker-icon:after,
.has-warning .ant-select-arrow,
.has-warning .ant-time-picker-icon:after {
  color: #faad14;
}

.has-warning .ant-input-number,
.has-warning .ant-time-picker-input {
  border-color: #faad14;
}

.has-warning .ant-input-number-focused,
.has-warning .ant-input-number:focus,
.has-warning .ant-time-picker-input-focused,
.has-warning .ant-time-picker-input:focus {
  border-color: #ffc53d;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px !important;
}

.has-warning .ant-input-number:not([disabled]):hover,
.has-warning .ant-time-picker-input:not([disabled]):hover {
  border-color: #faad14;
}

.has-warning .ant-cascader-picker:focus .ant-cascader-input {
  border-color: #ffc53d;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  border-right-width: 1px !important;
}

.has-error .ant-form-explain,
.has-error .ant-form-split {
  color: #f5222d;
}

.has-error .ant-input,
.has-error .ant-input:hover {
  border-color: #f5222d;
}

.has-error .ant-input:focus {
  border-color: #ff4d4f;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px !important;
}

.has-error .ant-input:not([disabled]):hover {
  border-color: #f5222d;
}

.has-error .ant-calendar-picker-open .ant-calendar-picker-input {
  border-color: #ff4d4f;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px !important;
}

.has-error .ant-input-prefix {
  color: #f5222d;
}

.has-error .ant-input-group-addon {
  color: #f5222d;
  border-color: #f5222d;
  background-color: #fff;
}

.has-error .has-feedback {
  color: #f5222d;
}

.has-error.has-feedback .ant-form-item-children:after {
  content: "\E62E";
  color: #f5222d;
  animation-name: diffZoomIn2 !important;
}

.has-error .ant-select-selection {
  border-color: #f5222d;
}

.has-error .ant-select-focused .ant-select-selection,
.has-error .ant-select-open .ant-select-selection {
  border-color: #ff4d4f;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px !important;
}

.has-error .ant-select.ant-select-auto-complete .ant-input:focus {
  border-color: #f5222d;
}

.has-error .ant-input-group-addon .ant-select-selection {
  border-color: transparent;
  box-shadow: none;
}

.has-error .ant-calendar-picker-icon:after,
.has-error .ant-cascader-picker-arrow,
.has-error .ant-picker-icon:after,
.has-error .ant-select-arrow,
.has-error .ant-time-picker-icon:after {
  color: #f5222d;
}

.has-error .ant-input-number,
.has-error .ant-time-picker-input {
  border-color: #f5222d;
}

.has-error .ant-input-number-focused,
.has-error .ant-input-number:focus,
.has-error .ant-time-picker-input-focused,
.has-error .ant-time-picker-input:focus {
  border-color: #ff4d4f;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px !important;
}

.has-error .ant-input-number:not([disabled]):hover,
.has-error .ant-mention-wrapper .ant-mention-editor,
.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover,
.has-error .ant-time-picker-input:not([disabled]):hover {
  border-color: #f5222d;
}

.has-error .ant-cascader-picker:focus .ant-cascader-input,
.has-error
  .ant-mention-wrapper.ant-mention-active:not([disabled])
  .ant-mention-editor,
.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {
  border-color: #ff4d4f;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
  border-right-width: 1px !important;
}

.is-validating.has-feedback .ant-form-item-children:after {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
  content: "\E64D";
  color: #1890ff;
}

.ant-advanced-search-form .ant-form-item {
  margin-bottom: 24px;
}

.ant-advanced-search-form .ant-form-item-with-help {
  margin-bottom: 5px;
}

.show-help-appear,
.show-help-enter,
.show-help-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.show-help-appear.show-help-appear-active,
.show-help-enter.show-help-enter-active {
  animation-name: antShowHelpIn;
  animation-play-state: running;
}

.show-help-leave.show-help-leave-active {
  animation-name: antShowHelpOut;
  animation-play-state: running;
  pointer-events: none;
}

.show-help-appear,
.show-help-enter {
  opacity: 0;
}

.show-help-appear,
.show-help-enter,
.show-help-leave {
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}

@keyframes antShowHelpIn {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes antShowHelpOut {
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
}

@keyframes diffZoomIn1 {
  0% {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes diffZoomIn2 {
  0% {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes diffZoomIn3 {
  0% {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.ant-row {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  height: auto;
  zoom: 1;
  display: block;
  box-sizing: border-box;
}

.ant-row:after,
.ant-row:before {
  content: "";
  display: table;
}

.ant-row:after {
  clear: both;
}

.ant-row-flex {
  display: flex;
  flex-flow: row wrap;
}

.ant-row-flex:after,
.ant-row-flex:before {
  display: flex;
}

.ant-row-flex-start {
  justify-content: flex-start;
}

.ant-row-flex-center {
  justify-content: center;
}

.ant-row-flex-end {
  justify-content: flex-end;
}

.ant-row-flex-space-between {
  justify-content: space-between;
}

.ant-row-flex-space-around {
  justify-content: space-around;
}

.ant-row-flex-top {
  align-items: flex-start;
}

.ant-row-flex-middle {
  align-items: center;
}

.ant-row-flex-bottom {
  align-items: flex-end;
}

.ant-col {
  position: relative;
  display: block;
}

.ant-col-1,
.ant-col-2,
.ant-col-3,
.ant-col-4,
.ant-col-5,
.ant-col-6,
.ant-col-7,
.ant-col-8,
.ant-col-9,
.ant-col-10,
.ant-col-11,
.ant-col-12,
.ant-col-13,
.ant-col-14,
.ant-col-15,
.ant-col-16,
.ant-col-17,
.ant-col-18,
.ant-col-19,
.ant-col-20,
.ant-col-21,
.ant-col-22,
.ant-col-23,
.ant-col-24,
.ant-col-lg-1,
.ant-col-lg-2,
.ant-col-lg-3,
.ant-col-lg-4,
.ant-col-lg-5,
.ant-col-lg-6,
.ant-col-lg-7,
.ant-col-lg-8,
.ant-col-lg-9,
.ant-col-lg-10,
.ant-col-lg-11,
.ant-col-lg-12,
.ant-col-lg-13,
.ant-col-lg-14,
.ant-col-lg-15,
.ant-col-lg-16,
.ant-col-lg-17,
.ant-col-lg-18,
.ant-col-lg-19,
.ant-col-lg-20,
.ant-col-lg-21,
.ant-col-lg-22,
.ant-col-lg-23,
.ant-col-lg-24,
.ant-col-md-1,
.ant-col-md-2,
.ant-col-md-3,
.ant-col-md-4,
.ant-col-md-5,
.ant-col-md-6,
.ant-col-md-7,
.ant-col-md-8,
.ant-col-md-9,
.ant-col-md-10,
.ant-col-md-11,
.ant-col-md-12,
.ant-col-md-13,
.ant-col-md-14,
.ant-col-md-15,
.ant-col-md-16,
.ant-col-md-17,
.ant-col-md-18,
.ant-col-md-19,
.ant-col-md-20,
.ant-col-md-21,
.ant-col-md-22,
.ant-col-md-23,
.ant-col-md-24,
.ant-col-sm-1,
.ant-col-sm-2,
.ant-col-sm-3,
.ant-col-sm-4,
.ant-col-sm-5,
.ant-col-sm-6,
.ant-col-sm-7,
.ant-col-sm-8,
.ant-col-sm-9,
.ant-col-sm-10,
.ant-col-sm-11,
.ant-col-sm-12,
.ant-col-sm-13,
.ant-col-sm-14,
.ant-col-sm-15,
.ant-col-sm-16,
.ant-col-sm-17,
.ant-col-sm-18,
.ant-col-sm-19,
.ant-col-sm-20,
.ant-col-sm-21,
.ant-col-sm-22,
.ant-col-sm-23,
.ant-col-sm-24,
.ant-col-xs-1,
.ant-col-xs-2,
.ant-col-xs-3,
.ant-col-xs-4,
.ant-col-xs-5,
.ant-col-xs-6,
.ant-col-xs-7,
.ant-col-xs-8,
.ant-col-xs-9,
.ant-col-xs-10,
.ant-col-xs-11,
.ant-col-xs-12,
.ant-col-xs-13,
.ant-col-xs-14,
.ant-col-xs-15,
.ant-col-xs-16,
.ant-col-xs-17,
.ant-col-xs-18,
.ant-col-xs-19,
.ant-col-xs-20,
.ant-col-xs-21,
.ant-col-xs-22,
.ant-col-xs-23,
.ant-col-xs-24 {
  position: relative;
  min-height: 1px;
  padding-left: 0;
  padding-right: 0;
}

.ant-col-1,
.ant-col-2,
.ant-col-3,
.ant-col-4,
.ant-col-5,
.ant-col-6,
.ant-col-7,
.ant-col-8,
.ant-col-9,
.ant-col-10,
.ant-col-11,
.ant-col-12,
.ant-col-13,
.ant-col-14,
.ant-col-15,
.ant-col-16,
.ant-col-17,
.ant-col-18,
.ant-col-19,
.ant-col-20,
.ant-col-21,
.ant-col-22,
.ant-col-23,
.ant-col-24 {
  float: left;
  flex: 0 0 auto;
}

.ant-col-24 {
  display: block;
  box-sizing: border-box;
  width: 100%;
}

.ant-col-push-24 {
  left: 100%;
}

.ant-col-pull-24 {
  right: 100%;
}

.ant-col-offset-24 {
  margin-left: 100%;
}

.ant-col-order-24 {
  order: 24;
}

.ant-col-23 {
  display: block;
  box-sizing: border-box;
  width: 95.83333333%;
}

.ant-col-push-23 {
  left: 95.83333333%;
}

.ant-col-pull-23 {
  right: 95.83333333%;
}

.ant-col-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-order-23 {
  order: 23;
}

.ant-col-22 {
  display: block;
  box-sizing: border-box;
  width: 91.66666667%;
}

.ant-col-push-22 {
  left: 91.66666667%;
}

.ant-col-pull-22 {
  right: 91.66666667%;
}

.ant-col-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-order-22 {
  order: 22;
}

.ant-col-21 {
  display: block;
  box-sizing: border-box;
  width: 87.5%;
}

.ant-col-push-21 {
  left: 87.5%;
}

.ant-col-pull-21 {
  right: 87.5%;
}

.ant-col-offset-21 {
  margin-left: 87.5%;
}

.ant-col-order-21 {
  order: 21;
}

.ant-col-20 {
  display: block;
  box-sizing: border-box;
  width: 83.33333333%;
}

.ant-col-push-20 {
  left: 83.33333333%;
}

.ant-col-pull-20 {
  right: 83.33333333%;
}

.ant-col-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-order-20 {
  order: 20;
}

.ant-col-19 {
  display: block;
  box-sizing: border-box;
  width: 79.16666667%;
}

.ant-col-push-19 {
  left: 79.16666667%;
}

.ant-col-pull-19 {
  right: 79.16666667%;
}

.ant-col-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-order-19 {
  order: 19;
}

.ant-col-18 {
  display: block;
  box-sizing: border-box;
  width: 75%;
}

.ant-col-push-18 {
  left: 75%;
}

.ant-col-pull-18 {
  right: 75%;
}

.ant-col-offset-18 {
  margin-left: 75%;
}

.ant-col-order-18 {
  order: 18;
}

.ant-col-17 {
  display: block;
  box-sizing: border-box;
  width: 70.83333333%;
}

.ant-col-push-17 {
  left: 70.83333333%;
}

.ant-col-pull-17 {
  right: 70.83333333%;
}

.ant-col-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-order-17 {
  order: 17;
}

.ant-col-16 {
  display: block;
  box-sizing: border-box;
  width: 66.66666667%;
}

.ant-col-push-16 {
  left: 66.66666667%;
}

.ant-col-pull-16 {
  right: 66.66666667%;
}

.ant-col-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-order-16 {
  order: 16;
}

.ant-col-15 {
  display: block;
  box-sizing: border-box;
  width: 62.5%;
}

.ant-col-push-15 {
  left: 62.5%;
}

.ant-col-pull-15 {
  right: 62.5%;
}

.ant-col-offset-15 {
  margin-left: 62.5%;
}

.ant-col-order-15 {
  order: 15;
}

.ant-col-14 {
  display: block;
  box-sizing: border-box;
  width: 58.33333333%;
}

.ant-col-push-14 {
  left: 58.33333333%;
}

.ant-col-pull-14 {
  right: 58.33333333%;
}

.ant-col-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-order-14 {
  order: 14;
}

.ant-col-13 {
  display: block;
  box-sizing: border-box;
  width: 54.16666667%;
}

.ant-col-push-13 {
  left: 54.16666667%;
}

.ant-col-pull-13 {
  right: 54.16666667%;
}

.ant-col-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-order-13 {
  order: 13;
}

.ant-col-12 {
  display: block;
  box-sizing: border-box;
  width: 50%;
}

.ant-col-push-12 {
  left: 50%;
}

.ant-col-pull-12 {
  right: 50%;
}

.ant-col-offset-12 {
  margin-left: 50%;
}

.ant-col-order-12 {
  order: 12;
}

.ant-col-11 {
  display: block;
  box-sizing: border-box;
  width: 45.83333333%;
}

.ant-col-push-11 {
  left: 45.83333333%;
}

.ant-col-pull-11 {
  right: 45.83333333%;
}

.ant-col-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-order-11 {
  order: 11;
}

.ant-col-10 {
  display: block;
  box-sizing: border-box;
  width: 41.66666667%;
}

.ant-col-push-10 {
  left: 41.66666667%;
}

.ant-col-pull-10 {
  right: 41.66666667%;
}

.ant-col-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-order-10 {
  order: 10;
}

.ant-col-9 {
  display: block;
  box-sizing: border-box;
  width: 37.5%;
}

.ant-col-push-9 {
  left: 37.5%;
}

.ant-col-pull-9 {
  right: 37.5%;
}

.ant-col-offset-9 {
  margin-left: 37.5%;
}

.ant-col-order-9 {
  order: 9;
}

.ant-col-8 {
  display: block;
  box-sizing: border-box;
  width: 33.33333333%;
}

.ant-col-push-8 {
  left: 33.33333333%;
}

.ant-col-pull-8 {
  right: 33.33333333%;
}

.ant-col-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-order-8 {
  order: 8;
}

.ant-col-7 {
  display: block;
  box-sizing: border-box;
  width: 29.16666667%;
}

.ant-col-push-7 {
  left: 29.16666667%;
}

.ant-col-pull-7 {
  right: 29.16666667%;
}

.ant-col-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-order-7 {
  order: 7;
}

.ant-col-6 {
  display: block;
  box-sizing: border-box;
  width: 25%;
}

.ant-col-push-6 {
  left: 25%;
}

.ant-col-pull-6 {
  right: 25%;
}

.ant-col-offset-6 {
  margin-left: 25%;
}

.ant-col-order-6 {
  order: 6;
}

.ant-col-5 {
  display: block;
  box-sizing: border-box;
  width: 20.83333333%;
}

.ant-col-push-5 {
  left: 20.83333333%;
}

.ant-col-pull-5 {
  right: 20.83333333%;
}

.ant-col-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-order-5 {
  order: 5;
}

.ant-col-4 {
  display: block;
  box-sizing: border-box;
  width: 16.66666667%;
}

.ant-col-push-4 {
  left: 16.66666667%;
}

.ant-col-pull-4 {
  right: 16.66666667%;
}

.ant-col-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-order-4 {
  order: 4;
}

.ant-col-3 {
  display: block;
  box-sizing: border-box;
  width: 12.5%;
}

.ant-col-push-3 {
  left: 12.5%;
}

.ant-col-pull-3 {
  right: 12.5%;
}

.ant-col-offset-3 {
  margin-left: 12.5%;
}

.ant-col-order-3 {
  order: 3;
}

.ant-col-2 {
  display: block;
  box-sizing: border-box;
  width: 8.33333333%;
}

.ant-col-push-2 {
  left: 8.33333333%;
}

.ant-col-pull-2 {
  right: 8.33333333%;
}

.ant-col-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-order-2 {
  order: 2;
}

.ant-col-1 {
  display: block;
  box-sizing: border-box;
  width: 4.16666667%;
}

.ant-col-push-1 {
  left: 4.16666667%;
}

.ant-col-pull-1 {
  right: 4.16666667%;
}

.ant-col-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-order-1 {
  order: 1;
}

.ant-col-0 {
  display: none;
}

.ant-col-offset-0 {
  margin-left: 0;
}

.ant-col-order-0 {
  order: 0;
}

.ant-col-xs-1,
.ant-col-xs-2,
.ant-col-xs-3,
.ant-col-xs-4,
.ant-col-xs-5,
.ant-col-xs-6,
.ant-col-xs-7,
.ant-col-xs-8,
.ant-col-xs-9,
.ant-col-xs-10,
.ant-col-xs-11,
.ant-col-xs-12,
.ant-col-xs-13,
.ant-col-xs-14,
.ant-col-xs-15,
.ant-col-xs-16,
.ant-col-xs-17,
.ant-col-xs-18,
.ant-col-xs-19,
.ant-col-xs-20,
.ant-col-xs-21,
.ant-col-xs-22,
.ant-col-xs-23,
.ant-col-xs-24 {
  float: left;
  flex: 0 0 auto;
}

.ant-col-xs-24 {
  display: block;
  box-sizing: border-box;
  width: 100%;
}

.ant-col-xs-push-24 {
  left: 100%;
}

.ant-col-xs-pull-24 {
  right: 100%;
}

.ant-col-xs-offset-24 {
  margin-left: 100%;
}

.ant-col-xs-order-24 {
  order: 24;
}

.ant-col-xs-23 {
  display: block;
  box-sizing: border-box;
  width: 95.83333333%;
}

.ant-col-xs-push-23 {
  left: 95.83333333%;
}

.ant-col-xs-pull-23 {
  right: 95.83333333%;
}

.ant-col-xs-offset-23 {
  margin-left: 95.83333333%;
}

.ant-col-xs-order-23 {
  order: 23;
}

.ant-col-xs-22 {
  display: block;
  box-sizing: border-box;
  width: 91.66666667%;
}

.ant-col-xs-push-22 {
  left: 91.66666667%;
}

.ant-col-xs-pull-22 {
  right: 91.66666667%;
}

.ant-col-xs-offset-22 {
  margin-left: 91.66666667%;
}

.ant-col-xs-order-22 {
  order: 22;
}

.ant-col-xs-21 {
  display: block;
  box-sizing: border-box;
  width: 87.5%;
}

.ant-col-xs-push-21 {
  left: 87.5%;
}

.ant-col-xs-pull-21 {
  right: 87.5%;
}

.ant-col-xs-offset-21 {
  margin-left: 87.5%;
}

.ant-col-xs-order-21 {
  order: 21;
}

.ant-col-xs-20 {
  display: block;
  box-sizing: border-box;
  width: 83.33333333%;
}

.ant-col-xs-push-20 {
  left: 83.33333333%;
}

.ant-col-xs-pull-20 {
  right: 83.33333333%;
}

.ant-col-xs-offset-20 {
  margin-left: 83.33333333%;
}

.ant-col-xs-order-20 {
  order: 20;
}

.ant-col-xs-19 {
  display: block;
  box-sizing: border-box;
  width: 79.16666667%;
}

.ant-col-xs-push-19 {
  left: 79.16666667%;
}

.ant-col-xs-pull-19 {
  right: 79.16666667%;
}

.ant-col-xs-offset-19 {
  margin-left: 79.16666667%;
}

.ant-col-xs-order-19 {
  order: 19;
}

.ant-col-xs-18 {
  display: block;
  box-sizing: border-box;
  width: 75%;
}

.ant-col-xs-push-18 {
  left: 75%;
}

.ant-col-xs-pull-18 {
  right: 75%;
}

.ant-col-xs-offset-18 {
  margin-left: 75%;
}

.ant-col-xs-order-18 {
  order: 18;
}

.ant-col-xs-17 {
  display: block;
  box-sizing: border-box;
  width: 70.83333333%;
}

.ant-col-xs-push-17 {
  left: 70.83333333%;
}

.ant-col-xs-pull-17 {
  right: 70.83333333%;
}

.ant-col-xs-offset-17 {
  margin-left: 70.83333333%;
}

.ant-col-xs-order-17 {
  order: 17;
}

.ant-col-xs-16 {
  display: block;
  box-sizing: border-box;
  width: 66.66666667%;
}

.ant-col-xs-push-16 {
  left: 66.66666667%;
}

.ant-col-xs-pull-16 {
  right: 66.66666667%;
}

.ant-col-xs-offset-16 {
  margin-left: 66.66666667%;
}

.ant-col-xs-order-16 {
  order: 16;
}

.ant-col-xs-15 {
  display: block;
  box-sizing: border-box;
  width: 62.5%;
}

.ant-col-xs-push-15 {
  left: 62.5%;
}

.ant-col-xs-pull-15 {
  right: 62.5%;
}

.ant-col-xs-offset-15 {
  margin-left: 62.5%;
}

.ant-col-xs-order-15 {
  order: 15;
}

.ant-col-xs-14 {
  display: block;
  box-sizing: border-box;
  width: 58.33333333%;
}

.ant-col-xs-push-14 {
  left: 58.33333333%;
}

.ant-col-xs-pull-14 {
  right: 58.33333333%;
}

.ant-col-xs-offset-14 {
  margin-left: 58.33333333%;
}

.ant-col-xs-order-14 {
  order: 14;
}

.ant-col-xs-13 {
  display: block;
  box-sizing: border-box;
  width: 54.16666667%;
}

.ant-col-xs-push-13 {
  left: 54.16666667%;
}

.ant-col-xs-pull-13 {
  right: 54.16666667%;
}

.ant-col-xs-offset-13 {
  margin-left: 54.16666667%;
}

.ant-col-xs-order-13 {
  order: 13;
}

.ant-col-xs-12 {
  display: block;
  box-sizing: border-box;
  width: 50%;
}

.ant-col-xs-push-12 {
  left: 50%;
}

.ant-col-xs-pull-12 {
  right: 50%;
}

.ant-col-xs-offset-12 {
  margin-left: 50%;
}

.ant-col-xs-order-12 {
  order: 12;
}

.ant-col-xs-11 {
  display: block;
  box-sizing: border-box;
  width: 45.83333333%;
}

.ant-col-xs-push-11 {
  left: 45.83333333%;
}

.ant-col-xs-pull-11 {
  right: 45.83333333%;
}

.ant-col-xs-offset-11 {
  margin-left: 45.83333333%;
}

.ant-col-xs-order-11 {
  order: 11;
}

.ant-col-xs-10 {
  display: block;
  box-sizing: border-box;
  width: 41.66666667%;
}

.ant-col-xs-push-10 {
  left: 41.66666667%;
}

.ant-col-xs-pull-10 {
  right: 41.66666667%;
}

.ant-col-xs-offset-10 {
  margin-left: 41.66666667%;
}

.ant-col-xs-order-10 {
  order: 10;
}

.ant-col-xs-9 {
  display: block;
  box-sizing: border-box;
  width: 37.5%;
}

.ant-col-xs-push-9 {
  left: 37.5%;
}

.ant-col-xs-pull-9 {
  right: 37.5%;
}

.ant-col-xs-offset-9 {
  margin-left: 37.5%;
}

.ant-col-xs-order-9 {
  order: 9;
}

.ant-col-xs-8 {
  display: block;
  box-sizing: border-box;
  width: 33.33333333%;
}

.ant-col-xs-push-8 {
  left: 33.33333333%;
}

.ant-col-xs-pull-8 {
  right: 33.33333333%;
}

.ant-col-xs-offset-8 {
  margin-left: 33.33333333%;
}

.ant-col-xs-order-8 {
  order: 8;
}

.ant-col-xs-7 {
  display: block;
  box-sizing: border-box;
  width: 29.16666667%;
}

.ant-col-xs-push-7 {
  left: 29.16666667%;
}

.ant-col-xs-pull-7 {
  right: 29.16666667%;
}

.ant-col-xs-offset-7 {
  margin-left: 29.16666667%;
}

.ant-col-xs-order-7 {
  order: 7;
}

.ant-col-xs-6 {
  display: block;
  box-sizing: border-box;
  width: 25%;
}

.ant-col-xs-push-6 {
  left: 25%;
}

.ant-col-xs-pull-6 {
  right: 25%;
}

.ant-col-xs-offset-6 {
  margin-left: 25%;
}

.ant-col-xs-order-6 {
  order: 6;
}

.ant-col-xs-5 {
  display: block;
  box-sizing: border-box;
  width: 20.83333333%;
}

.ant-col-xs-push-5 {
  left: 20.83333333%;
}

.ant-col-xs-pull-5 {
  right: 20.83333333%;
}

.ant-col-xs-offset-5 {
  margin-left: 20.83333333%;
}

.ant-col-xs-order-5 {
  order: 5;
}

.ant-col-xs-4 {
  display: block;
  box-sizing: border-box;
  width: 16.66666667%;
}

.ant-col-xs-push-4 {
  left: 16.66666667%;
}

.ant-col-xs-pull-4 {
  right: 16.66666667%;
}

.ant-col-xs-offset-4 {
  margin-left: 16.66666667%;
}

.ant-col-xs-order-4 {
  order: 4;
}

.ant-col-xs-3 {
  display: block;
  box-sizing: border-box;
  width: 12.5%;
}

.ant-col-xs-push-3 {
  left: 12.5%;
}

.ant-col-xs-pull-3 {
  right: 12.5%;
}

.ant-col-xs-offset-3 {
  margin-left: 12.5%;
}

.ant-col-xs-order-3 {
  order: 3;
}

.ant-col-xs-2 {
  display: block;
  box-sizing: border-box;
  width: 8.33333333%;
}

.ant-col-xs-push-2 {
  left: 8.33333333%;
}

.ant-col-xs-pull-2 {
  right: 8.33333333%;
}

.ant-col-xs-offset-2 {
  margin-left: 8.33333333%;
}

.ant-col-xs-order-2 {
  order: 2;
}

.ant-col-xs-1 {
  display: block;
  box-sizing: border-box;
  width: 4.16666667%;
}

.ant-col-xs-push-1 {
  left: 4.16666667%;
}

.ant-col-xs-pull-1 {
  right: 4.16666667%;
}

.ant-col-xs-offset-1 {
  margin-left: 4.16666667%;
}

.ant-col-xs-order-1 {
  order: 1;
}

.ant-col-xs-0 {
  display: none;
}

.ant-col-push-0 {
  left: auto;
}

.ant-col-pull-0 {
  right: auto;
}

.ant-col-xs-push-0 {
  left: auto;
}

.ant-col-xs-pull-0 {
  right: auto;
}

.ant-col-xs-offset-0 {
  margin-left: 0;
}

.ant-col-xs-order-0 {
  order: 0;
}

@media (min-width: 576px) {
  .ant-col-sm-1,
  .ant-col-sm-2,
  .ant-col-sm-3,
  .ant-col-sm-4,
  .ant-col-sm-5,
  .ant-col-sm-6,
  .ant-col-sm-7,
  .ant-col-sm-8,
  .ant-col-sm-9,
  .ant-col-sm-10,
  .ant-col-sm-11,
  .ant-col-sm-12,
  .ant-col-sm-13,
  .ant-col-sm-14,
  .ant-col-sm-15,
  .ant-col-sm-16,
  .ant-col-sm-17,
  .ant-col-sm-18,
  .ant-col-sm-19,
  .ant-col-sm-20,
  .ant-col-sm-21,
  .ant-col-sm-22,
  .ant-col-sm-23,
  .ant-col-sm-24 {
    float: left;
    flex: 0 0 auto;
  }
  .ant-col-sm-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-sm-push-24 {
    left: 100%;
  }
  .ant-col-sm-pull-24 {
    right: 100%;
  }
  .ant-col-sm-offset-24 {
    margin-left: 100%;
  }
  .ant-col-sm-order-24 {
    order: 24;
  }
  .ant-col-sm-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-sm-push-23 {
    left: 95.83333333%;
  }
  .ant-col-sm-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-sm-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-sm-order-23 {
    order: 23;
  }
  .ant-col-sm-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-sm-push-22 {
    left: 91.66666667%;
  }
  .ant-col-sm-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-sm-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-sm-order-22 {
    order: 22;
  }
  .ant-col-sm-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-sm-push-21 {
    left: 87.5%;
  }
  .ant-col-sm-pull-21 {
    right: 87.5%;
  }
  .ant-col-sm-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-sm-order-21 {
    order: 21;
  }
  .ant-col-sm-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-sm-push-20 {
    left: 83.33333333%;
  }
  .ant-col-sm-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-sm-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-sm-order-20 {
    order: 20;
  }
  .ant-col-sm-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-sm-push-19 {
    left: 79.16666667%;
  }
  .ant-col-sm-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-sm-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-sm-order-19 {
    order: 19;
  }
  .ant-col-sm-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-sm-push-18 {
    left: 75%;
  }
  .ant-col-sm-pull-18 {
    right: 75%;
  }
  .ant-col-sm-offset-18 {
    margin-left: 75%;
  }
  .ant-col-sm-order-18 {
    order: 18;
  }
  .ant-col-sm-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-sm-push-17 {
    left: 70.83333333%;
  }
  .ant-col-sm-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-sm-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-sm-order-17 {
    order: 17;
  }
  .ant-col-sm-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-sm-push-16 {
    left: 66.66666667%;
  }
  .ant-col-sm-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-sm-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-sm-order-16 {
    order: 16;
  }
  .ant-col-sm-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-sm-push-15 {
    left: 62.5%;
  }
  .ant-col-sm-pull-15 {
    right: 62.5%;
  }
  .ant-col-sm-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-sm-order-15 {
    order: 15;
  }
  .ant-col-sm-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-sm-push-14 {
    left: 58.33333333%;
  }
  .ant-col-sm-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-sm-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-sm-order-14 {
    order: 14;
  }
  .ant-col-sm-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-sm-push-13 {
    left: 54.16666667%;
  }
  .ant-col-sm-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-sm-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-sm-order-13 {
    order: 13;
  }
  .ant-col-sm-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-sm-push-12 {
    left: 50%;
  }
  .ant-col-sm-pull-12 {
    right: 50%;
  }
  .ant-col-sm-offset-12 {
    margin-left: 50%;
  }
  .ant-col-sm-order-12 {
    order: 12;
  }
  .ant-col-sm-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-sm-push-11 {
    left: 45.83333333%;
  }
  .ant-col-sm-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-sm-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-sm-order-11 {
    order: 11;
  }
  .ant-col-sm-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-sm-push-10 {
    left: 41.66666667%;
  }
  .ant-col-sm-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-sm-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-sm-order-10 {
    order: 10;
  }
  .ant-col-sm-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-sm-push-9 {
    left: 37.5%;
  }
  .ant-col-sm-pull-9 {
    right: 37.5%;
  }
  .ant-col-sm-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-sm-order-9 {
    order: 9;
  }
  .ant-col-sm-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-sm-push-8 {
    left: 33.33333333%;
  }
  .ant-col-sm-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-sm-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-sm-order-8 {
    order: 8;
  }
  .ant-col-sm-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-sm-push-7 {
    left: 29.16666667%;
  }
  .ant-col-sm-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-sm-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-sm-order-7 {
    order: 7;
  }
  .ant-col-sm-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-sm-push-6 {
    left: 25%;
  }
  .ant-col-sm-pull-6 {
    right: 25%;
  }
  .ant-col-sm-offset-6 {
    margin-left: 25%;
  }
  .ant-col-sm-order-6 {
    order: 6;
  }
  .ant-col-sm-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-sm-push-5 {
    left: 20.83333333%;
  }
  .ant-col-sm-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-sm-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-sm-order-5 {
    order: 5;
  }
  .ant-col-sm-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-sm-push-4 {
    left: 16.66666667%;
  }
  .ant-col-sm-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-sm-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-sm-order-4 {
    order: 4;
  }
  .ant-col-sm-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-sm-push-3 {
    left: 12.5%;
  }
  .ant-col-sm-pull-3 {
    right: 12.5%;
  }
  .ant-col-sm-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-sm-order-3 {
    order: 3;
  }
  .ant-col-sm-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-sm-push-2 {
    left: 8.33333333%;
  }
  .ant-col-sm-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-sm-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-sm-order-2 {
    order: 2;
  }
  .ant-col-sm-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-sm-push-1 {
    left: 4.16666667%;
  }
  .ant-col-sm-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-sm-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-sm-order-1 {
    order: 1;
  }
  .ant-col-sm-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-sm-push-0 {
    left: auto;
  }
  .ant-col-sm-pull-0 {
    right: auto;
  }
  .ant-col-sm-offset-0 {
    margin-left: 0;
  }
  .ant-col-sm-order-0 {
    order: 0;
  }
}

@media (min-width: 768px) {
  .ant-col-md-1,
  .ant-col-md-2,
  .ant-col-md-3,
  .ant-col-md-4,
  .ant-col-md-5,
  .ant-col-md-6,
  .ant-col-md-7,
  .ant-col-md-8,
  .ant-col-md-9,
  .ant-col-md-10,
  .ant-col-md-11,
  .ant-col-md-12,
  .ant-col-md-13,
  .ant-col-md-14,
  .ant-col-md-15,
  .ant-col-md-16,
  .ant-col-md-17,
  .ant-col-md-18,
  .ant-col-md-19,
  .ant-col-md-20,
  .ant-col-md-21,
  .ant-col-md-22,
  .ant-col-md-23,
  .ant-col-md-24 {
    float: left;
    flex: 0 0 auto;
  }
  .ant-col-md-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-md-push-24 {
    left: 100%;
  }
  .ant-col-md-pull-24 {
    right: 100%;
  }
  .ant-col-md-offset-24 {
    margin-left: 100%;
  }
  .ant-col-md-order-24 {
    order: 24;
  }
  .ant-col-md-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-md-push-23 {
    left: 95.83333333%;
  }
  .ant-col-md-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-md-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-md-order-23 {
    order: 23;
  }
  .ant-col-md-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-md-push-22 {
    left: 91.66666667%;
  }
  .ant-col-md-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-md-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-md-order-22 {
    order: 22;
  }
  .ant-col-md-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-md-push-21 {
    left: 87.5%;
  }
  .ant-col-md-pull-21 {
    right: 87.5%;
  }
  .ant-col-md-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-md-order-21 {
    order: 21;
  }
  .ant-col-md-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-md-push-20 {
    left: 83.33333333%;
  }
  .ant-col-md-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-md-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-md-order-20 {
    order: 20;
  }
  .ant-col-md-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-md-push-19 {
    left: 79.16666667%;
  }
  .ant-col-md-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-md-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-md-order-19 {
    order: 19;
  }
  .ant-col-md-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-md-push-18 {
    left: 75%;
  }
  .ant-col-md-pull-18 {
    right: 75%;
  }
  .ant-col-md-offset-18 {
    margin-left: 75%;
  }
  .ant-col-md-order-18 {
    order: 18;
  }
  .ant-col-md-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-md-push-17 {
    left: 70.83333333%;
  }
  .ant-col-md-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-md-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-md-order-17 {
    order: 17;
  }
  .ant-col-md-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-md-push-16 {
    left: 66.66666667%;
  }
  .ant-col-md-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-md-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-md-order-16 {
    order: 16;
  }
  .ant-col-md-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-md-push-15 {
    left: 62.5%;
  }
  .ant-col-md-pull-15 {
    right: 62.5%;
  }
  .ant-col-md-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-md-order-15 {
    order: 15;
  }
  .ant-col-md-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-md-push-14 {
    left: 58.33333333%;
  }
  .ant-col-md-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-md-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-md-order-14 {
    order: 14;
  }
  .ant-col-md-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-md-push-13 {
    left: 54.16666667%;
  }
  .ant-col-md-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-md-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-md-order-13 {
    order: 13;
  }
  .ant-col-md-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-md-push-12 {
    left: 50%;
  }
  .ant-col-md-pull-12 {
    right: 50%;
  }
  .ant-col-md-offset-12 {
    margin-left: 50%;
  }
  .ant-col-md-order-12 {
    order: 12;
  }
  .ant-col-md-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-md-push-11 {
    left: 45.83333333%;
  }
  .ant-col-md-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-md-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-md-order-11 {
    order: 11;
  }
  .ant-col-md-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-md-push-10 {
    left: 41.66666667%;
  }
  .ant-col-md-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-md-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-md-order-10 {
    order: 10;
  }
  .ant-col-md-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-md-push-9 {
    left: 37.5%;
  }
  .ant-col-md-pull-9 {
    right: 37.5%;
  }
  .ant-col-md-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-md-order-9 {
    order: 9;
  }
  .ant-col-md-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-md-push-8 {
    left: 33.33333333%;
  }
  .ant-col-md-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-md-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-md-order-8 {
    order: 8;
  }
  .ant-col-md-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-md-push-7 {
    left: 29.16666667%;
  }
  .ant-col-md-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-md-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-md-order-7 {
    order: 7;
  }
  .ant-col-md-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-md-push-6 {
    left: 25%;
  }
  .ant-col-md-pull-6 {
    right: 25%;
  }
  .ant-col-md-offset-6 {
    margin-left: 25%;
  }
  .ant-col-md-order-6 {
    order: 6;
  }
  .ant-col-md-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-md-push-5 {
    left: 20.83333333%;
  }
  .ant-col-md-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-md-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-md-order-5 {
    order: 5;
  }
  .ant-col-md-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-md-push-4 {
    left: 16.66666667%;
  }
  .ant-col-md-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-md-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-md-order-4 {
    order: 4;
  }
  .ant-col-md-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-md-push-3 {
    left: 12.5%;
  }
  .ant-col-md-pull-3 {
    right: 12.5%;
  }
  .ant-col-md-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-md-order-3 {
    order: 3;
  }
  .ant-col-md-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-md-push-2 {
    left: 8.33333333%;
  }
  .ant-col-md-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-md-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-md-order-2 {
    order: 2;
  }
  .ant-col-md-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-md-push-1 {
    left: 4.16666667%;
  }
  .ant-col-md-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-md-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-md-order-1 {
    order: 1;
  }
  .ant-col-md-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-md-push-0 {
    left: auto;
  }
  .ant-col-md-pull-0 {
    right: auto;
  }
  .ant-col-md-offset-0 {
    margin-left: 0;
  }
  .ant-col-md-order-0 {
    order: 0;
  }
}

@media (min-width: 992px) {
  .ant-col-lg-1,
  .ant-col-lg-2,
  .ant-col-lg-3,
  .ant-col-lg-4,
  .ant-col-lg-5,
  .ant-col-lg-6,
  .ant-col-lg-7,
  .ant-col-lg-8,
  .ant-col-lg-9,
  .ant-col-lg-10,
  .ant-col-lg-11,
  .ant-col-lg-12,
  .ant-col-lg-13,
  .ant-col-lg-14,
  .ant-col-lg-15,
  .ant-col-lg-16,
  .ant-col-lg-17,
  .ant-col-lg-18,
  .ant-col-lg-19,
  .ant-col-lg-20,
  .ant-col-lg-21,
  .ant-col-lg-22,
  .ant-col-lg-23,
  .ant-col-lg-24 {
    float: left;
    flex: 0 0 auto;
  }
  .ant-col-lg-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-lg-push-24 {
    left: 100%;
  }
  .ant-col-lg-pull-24 {
    right: 100%;
  }
  .ant-col-lg-offset-24 {
    margin-left: 100%;
  }
  .ant-col-lg-order-24 {
    order: 24;
  }
  .ant-col-lg-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-lg-push-23 {
    left: 95.83333333%;
  }
  .ant-col-lg-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-lg-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-lg-order-23 {
    order: 23;
  }
  .ant-col-lg-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-lg-push-22 {
    left: 91.66666667%;
  }
  .ant-col-lg-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-lg-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-lg-order-22 {
    order: 22;
  }
  .ant-col-lg-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-lg-push-21 {
    left: 87.5%;
  }
  .ant-col-lg-pull-21 {
    right: 87.5%;
  }
  .ant-col-lg-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-lg-order-21 {
    order: 21;
  }
  .ant-col-lg-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-lg-push-20 {
    left: 83.33333333%;
  }
  .ant-col-lg-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-lg-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-lg-order-20 {
    order: 20;
  }
  .ant-col-lg-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-lg-push-19 {
    left: 79.16666667%;
  }
  .ant-col-lg-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-lg-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-lg-order-19 {
    order: 19;
  }
  .ant-col-lg-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-lg-push-18 {
    left: 75%;
  }
  .ant-col-lg-pull-18 {
    right: 75%;
  }
  .ant-col-lg-offset-18 {
    margin-left: 75%;
  }
  .ant-col-lg-order-18 {
    order: 18;
  }
  .ant-col-lg-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-lg-push-17 {
    left: 70.83333333%;
  }
  .ant-col-lg-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-lg-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-lg-order-17 {
    order: 17;
  }
  .ant-col-lg-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-lg-push-16 {
    left: 66.66666667%;
  }
  .ant-col-lg-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-lg-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-lg-order-16 {
    order: 16;
  }
  .ant-col-lg-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-lg-push-15 {
    left: 62.5%;
  }
  .ant-col-lg-pull-15 {
    right: 62.5%;
  }
  .ant-col-lg-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-lg-order-15 {
    order: 15;
  }
  .ant-col-lg-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-lg-push-14 {
    left: 58.33333333%;
  }
  .ant-col-lg-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-lg-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-lg-order-14 {
    order: 14;
  }
  .ant-col-lg-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-lg-push-13 {
    left: 54.16666667%;
  }
  .ant-col-lg-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-lg-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-lg-order-13 {
    order: 13;
  }
  .ant-col-lg-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-lg-push-12 {
    left: 50%;
  }
  .ant-col-lg-pull-12 {
    right: 50%;
  }
  .ant-col-lg-offset-12 {
    margin-left: 50%;
  }
  .ant-col-lg-order-12 {
    order: 12;
  }
  .ant-col-lg-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-lg-push-11 {
    left: 45.83333333%;
  }
  .ant-col-lg-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-lg-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-lg-order-11 {
    order: 11;
  }
  .ant-col-lg-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-lg-push-10 {
    left: 41.66666667%;
  }
  .ant-col-lg-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-lg-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-lg-order-10 {
    order: 10;
  }
  .ant-col-lg-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-lg-push-9 {
    left: 37.5%;
  }
  .ant-col-lg-pull-9 {
    right: 37.5%;
  }
  .ant-col-lg-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-lg-order-9 {
    order: 9;
  }
  .ant-col-lg-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-lg-push-8 {
    left: 33.33333333%;
  }
  .ant-col-lg-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-lg-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-lg-order-8 {
    order: 8;
  }
  .ant-col-lg-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-lg-push-7 {
    left: 29.16666667%;
  }
  .ant-col-lg-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-lg-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-lg-order-7 {
    order: 7;
  }
  .ant-col-lg-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-lg-push-6 {
    left: 25%;
  }
  .ant-col-lg-pull-6 {
    right: 25%;
  }
  .ant-col-lg-offset-6 {
    margin-left: 25%;
  }
  .ant-col-lg-order-6 {
    order: 6;
  }
  .ant-col-lg-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-lg-push-5 {
    left: 20.83333333%;
  }
  .ant-col-lg-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-lg-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-lg-order-5 {
    order: 5;
  }
  .ant-col-lg-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-lg-push-4 {
    left: 16.66666667%;
  }
  .ant-col-lg-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-lg-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-lg-order-4 {
    order: 4;
  }
  .ant-col-lg-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-lg-push-3 {
    left: 12.5%;
  }
  .ant-col-lg-pull-3 {
    right: 12.5%;
  }
  .ant-col-lg-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-lg-order-3 {
    order: 3;
  }
  .ant-col-lg-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-lg-push-2 {
    left: 8.33333333%;
  }
  .ant-col-lg-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-lg-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-lg-order-2 {
    order: 2;
  }
  .ant-col-lg-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-lg-push-1 {
    left: 4.16666667%;
  }
  .ant-col-lg-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-lg-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-lg-order-1 {
    order: 1;
  }
  .ant-col-lg-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-lg-push-0 {
    left: auto;
  }
  .ant-col-lg-pull-0 {
    right: auto;
  }
  .ant-col-lg-offset-0 {
    margin-left: 0;
  }
  .ant-col-lg-order-0 {
    order: 0;
  }
}

@media (min-width: 1200px) {
  .ant-col-xl-1,
  .ant-col-xl-2,
  .ant-col-xl-3,
  .ant-col-xl-4,
  .ant-col-xl-5,
  .ant-col-xl-6,
  .ant-col-xl-7,
  .ant-col-xl-8,
  .ant-col-xl-9,
  .ant-col-xl-10,
  .ant-col-xl-11,
  .ant-col-xl-12,
  .ant-col-xl-13,
  .ant-col-xl-14,
  .ant-col-xl-15,
  .ant-col-xl-16,
  .ant-col-xl-17,
  .ant-col-xl-18,
  .ant-col-xl-19,
  .ant-col-xl-20,
  .ant-col-xl-21,
  .ant-col-xl-22,
  .ant-col-xl-23,
  .ant-col-xl-24 {
    float: left;
    flex: 0 0 auto;
  }
  .ant-col-xl-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-xl-push-24 {
    left: 100%;
  }
  .ant-col-xl-pull-24 {
    right: 100%;
  }
  .ant-col-xl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xl-order-24 {
    order: 24;
  }
  .ant-col-xl-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-xl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xl-order-23 {
    order: 23;
  }
  .ant-col-xl-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-xl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xl-order-22 {
    order: 22;
  }
  .ant-col-xl-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-xl-push-21 {
    left: 87.5%;
  }
  .ant-col-xl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xl-order-21 {
    order: 21;
  }
  .ant-col-xl-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-xl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xl-order-20 {
    order: 20;
  }
  .ant-col-xl-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-xl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xl-order-19 {
    order: 19;
  }
  .ant-col-xl-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-xl-push-18 {
    left: 75%;
  }
  .ant-col-xl-pull-18 {
    right: 75%;
  }
  .ant-col-xl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xl-order-18 {
    order: 18;
  }
  .ant-col-xl-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-xl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xl-order-17 {
    order: 17;
  }
  .ant-col-xl-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-xl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xl-order-16 {
    order: 16;
  }
  .ant-col-xl-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-xl-push-15 {
    left: 62.5%;
  }
  .ant-col-xl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xl-order-15 {
    order: 15;
  }
  .ant-col-xl-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-xl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xl-order-14 {
    order: 14;
  }
  .ant-col-xl-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-xl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xl-order-13 {
    order: 13;
  }
  .ant-col-xl-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-xl-push-12 {
    left: 50%;
  }
  .ant-col-xl-pull-12 {
    right: 50%;
  }
  .ant-col-xl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xl-order-12 {
    order: 12;
  }
  .ant-col-xl-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-xl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xl-order-11 {
    order: 11;
  }
  .ant-col-xl-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-xl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xl-order-10 {
    order: 10;
  }
  .ant-col-xl-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-xl-push-9 {
    left: 37.5%;
  }
  .ant-col-xl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xl-order-9 {
    order: 9;
  }
  .ant-col-xl-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-xl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xl-order-8 {
    order: 8;
  }
  .ant-col-xl-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-xl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xl-order-7 {
    order: 7;
  }
  .ant-col-xl-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-xl-push-6 {
    left: 25%;
  }
  .ant-col-xl-pull-6 {
    right: 25%;
  }
  .ant-col-xl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xl-order-6 {
    order: 6;
  }
  .ant-col-xl-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-xl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xl-order-5 {
    order: 5;
  }
  .ant-col-xl-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-xl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xl-order-4 {
    order: 4;
  }
  .ant-col-xl-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-xl-push-3 {
    left: 12.5%;
  }
  .ant-col-xl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xl-order-3 {
    order: 3;
  }
  .ant-col-xl-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-xl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xl-order-2 {
    order: 2;
  }
  .ant-col-xl-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-xl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xl-order-1 {
    order: 1;
  }
  .ant-col-xl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xl-push-0 {
    left: auto;
  }
  .ant-col-xl-pull-0 {
    right: auto;
  }
  .ant-col-xl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xl-order-0 {
    order: 0;
  }
}

@media (min-width: 1600px) {
  .ant-col-xxl-1,
  .ant-col-xxl-2,
  .ant-col-xxl-3,
  .ant-col-xxl-4,
  .ant-col-xxl-5,
  .ant-col-xxl-6,
  .ant-col-xxl-7,
  .ant-col-xxl-8,
  .ant-col-xxl-9,
  .ant-col-xxl-10,
  .ant-col-xxl-11,
  .ant-col-xxl-12,
  .ant-col-xxl-13,
  .ant-col-xxl-14,
  .ant-col-xxl-15,
  .ant-col-xxl-16,
  .ant-col-xxl-17,
  .ant-col-xxl-18,
  .ant-col-xxl-19,
  .ant-col-xxl-20,
  .ant-col-xxl-21,
  .ant-col-xxl-22,
  .ant-col-xxl-23,
  .ant-col-xxl-24 {
    float: left;
    flex: 0 0 auto;
  }
  .ant-col-xxl-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-xxl-push-24 {
    left: 100%;
  }
  .ant-col-xxl-pull-24 {
    right: 100%;
  }
  .ant-col-xxl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xxl-order-24 {
    order: 24;
  }
  .ant-col-xxl-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-xxl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xxl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xxl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xxl-order-23 {
    order: 23;
  }
  .ant-col-xxl-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-xxl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xxl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xxl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xxl-order-22 {
    order: 22;
  }
  .ant-col-xxl-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-xxl-push-21 {
    left: 87.5%;
  }
  .ant-col-xxl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xxl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xxl-order-21 {
    order: 21;
  }
  .ant-col-xxl-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-xxl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xxl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xxl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xxl-order-20 {
    order: 20;
  }
  .ant-col-xxl-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-xxl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xxl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xxl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xxl-order-19 {
    order: 19;
  }
  .ant-col-xxl-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-xxl-push-18 {
    left: 75%;
  }
  .ant-col-xxl-pull-18 {
    right: 75%;
  }
  .ant-col-xxl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xxl-order-18 {
    order: 18;
  }
  .ant-col-xxl-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-xxl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xxl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xxl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xxl-order-17 {
    order: 17;
  }
  .ant-col-xxl-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-xxl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xxl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xxl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xxl-order-16 {
    order: 16;
  }
  .ant-col-xxl-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-xxl-push-15 {
    left: 62.5%;
  }
  .ant-col-xxl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xxl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xxl-order-15 {
    order: 15;
  }
  .ant-col-xxl-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-xxl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xxl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xxl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xxl-order-14 {
    order: 14;
  }
  .ant-col-xxl-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-xxl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xxl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xxl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xxl-order-13 {
    order: 13;
  }
  .ant-col-xxl-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-xxl-push-12 {
    left: 50%;
  }
  .ant-col-xxl-pull-12 {
    right: 50%;
  }
  .ant-col-xxl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xxl-order-12 {
    order: 12;
  }
  .ant-col-xxl-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-xxl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xxl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xxl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xxl-order-11 {
    order: 11;
  }
  .ant-col-xxl-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-xxl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xxl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xxl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xxl-order-10 {
    order: 10;
  }
  .ant-col-xxl-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-xxl-push-9 {
    left: 37.5%;
  }
  .ant-col-xxl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xxl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xxl-order-9 {
    order: 9;
  }
  .ant-col-xxl-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-xxl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xxl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xxl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xxl-order-8 {
    order: 8;
  }
  .ant-col-xxl-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-xxl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xxl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xxl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xxl-order-7 {
    order: 7;
  }
  .ant-col-xxl-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-xxl-push-6 {
    left: 25%;
  }
  .ant-col-xxl-pull-6 {
    right: 25%;
  }
  .ant-col-xxl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xxl-order-6 {
    order: 6;
  }
  .ant-col-xxl-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-xxl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xxl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xxl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xxl-order-5 {
    order: 5;
  }
  .ant-col-xxl-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-xxl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xxl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xxl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xxl-order-4 {
    order: 4;
  }
  .ant-col-xxl-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-xxl-push-3 {
    left: 12.5%;
  }
  .ant-col-xxl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xxl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xxl-order-3 {
    order: 3;
  }
  .ant-col-xxl-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-xxl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xxl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xxl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xxl-order-2 {
    order: 2;
  }
  .ant-col-xxl-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-xxl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xxl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xxl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xxl-order-1 {
    order: 1;
  }
  .ant-col-xxl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xxl-push-0 {
    left: auto;
  }
  .ant-col-xxl-pull-0 {
    right: auto;
  }
  .ant-col-xxl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xxl-order-0 {
    order: 0;
  }
}

.adminSelectModal .ant-modal-body {
  padding: 0;
}

.adminSelectPanel {
  position: relative;
  height: 400px;
}

.adminSelectPanel .contentWrap,
.adminSelectPanel .topBar {
  padding: 0 30px;
}

.adminSelectPanel .topBar {
  font-size: 14px;
  font-weight: 700;
  padding-top: 10px;
  height: 60px;
}

.adminSelectPanel .contentWrap,
.adminSelectPanel .leftPanel,
.adminSelectPanel .rightPanel {
  position: absolute;
}

.adminSelectPanel .leftPanel,
.adminSelectPanel .rightPanel {
  top: 0;
  bottom: 0;
  width: 50%;
}

.adminSelectPanel .leftPanel {
  left: 0;
}

.adminSelectPanel .rightPanel {
  right: 0;
  border-left: 1px solid #e9e9e9;
}

.adminSelectPanel .contentWrap {
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.adminSelectList {
  font-size: 14px;
  color: #323232;
}

.adminSelectItem {
  display: flex;
  align-items: center;
  margin: 16px 0;
  cursor: pointer;
}

.adminSelectItem > span {
  flex: 1;
}

.adminSelectItem .itemAvatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.adminSelectItem .itemName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.72;
}

.adminSelectItem.result .itemName {
  opacity: 1;
}

.adminSelectItem .itemCheck,
.adminSelectItem .itemRemove {
  flex: none;
  width: 20px;
}

.adminSelectItem .itemRemove {
  cursor: pointer;
  display: inline-block;
  width: 40px;
  height: 20px;
  background: url(//gw.alicdn.com/tfs/TB19sr_e1uSBuNjy1XcXXcYjFXa-46-46.png) 50%
    no-repeat;
  background-size: 12px;
}

.itemSearch {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.itemSearch .itemSearchIcon {
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: inline-block;
  width: 30px;
  height: 20px;
  background: url(//gw.alicdn.com/tfs/TB1Nag0e7yWBuNjy0FpXXassXXa-32-32.png) 50%
    no-repeat;
  background-size: 14px;
}

.itemSearch input.itemSearchInput {
  width: 100%;
  font-size: 13px;
  border: none;
  outline: none;
  line-height: 24px;
  padding-left: 30px !important;
  padding-top: 4px;
  padding-bottom: 4px;
  background: #f5f6f7;
  border-radius: 4px;
}

.icon-select.disabled {
  pointer-events: none;
  opacity: 0.42;
}

.icon-select-btn {
  margin-top: 10px;
}

.icon-select-content {
  overflow: hidden;
}

.icon-select-item {
  width: 40px;
  height: 40px;
  display: block;
  margin: 5px;
  float: left;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  overflow: hidden;
  position: relative;
}

.icon-select-item img {
  max-width: 100%;
  max-height: 100%;
  background: #fff;
  border-radius: 5px;
}

.icon-select-item .icon {
  position: absolute;
  display: block;
  border-radius: 50%;
  bottom: 1px;
  right: 1px;
  color: #fff;
  width: 13px;
  height: 13px;
  font-size: 13px;
  text-align: center;
}

.icon-select-modal .icon-select-item {
  opacity: 0.5;
}

.icon-select-modal .icon-select-item.selected {
  opacity: 1;
}

.readonly-input {
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.base-settings-form .ant-form-item {
  padding-bottom: 0;
}

.ant-popover {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  cursor: auto;
  user-select: text;
  white-space: normal;
  font-weight: 400;
  text-align: left;
}

.ant-popover:after {
  content: "";
  position: absolute;
  background: hsla(0, 0%, 100%, 0.01);
}

.ant-popover-hidden {
  display: none;
}

.ant-popover-placement-top,
.ant-popover-placement-topLeft,
.ant-popover-placement-topRight {
  padding-bottom: 10px;
}

.ant-popover-placement-right,
.ant-popover-placement-rightBottom,
.ant-popover-placement-rightTop {
  padding-left: 10px;
}

.ant-popover-placement-bottom,
.ant-popover-placement-bottomLeft,
.ant-popover-placement-bottomRight {
  padding-top: 10px;
}

.ant-popover-placement-left,
.ant-popover-placement-leftBottom,
.ant-popover-placement-leftTop {
  padding-right: 10px;
}

.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.ant-popover-title {
  min-width: 177px;
  margin: 0;
  padding: 5px 16px 4px;
  min-height: 32px;
  border-bottom: 1px solid #e8e8e8;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

.ant-popover-inner-content {
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.65);
}

.ant-popover-message {
  padding: 4px 0 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.ant-popover-message > .anticon {
  color: #faad14;
  line-height: 1.6;
  position: absolute;
}

.ant-popover-message-title {
  padding-left: 22px;
}

.ant-popover-buttons {
  text-align: right;
  margin-bottom: 4px;
}

.ant-popover-buttons button {
  margin-left: 8px;
}

.ant-popover-arrow {
  background: #fff;
  width: 8.48528137px;
  height: 8.48528137px;
  transform: rotate(45deg);
  position: absolute;
  display: block;
  border-color: transparent;
  border-style: solid;
}

.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {
  bottom: 5.5px;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
}

.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {
  left: 6px;
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
}

.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {
  bottom: 12px;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  top: 6px;
  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {
  left: 16px;
}

.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  right: 16px;
}

.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {
  right: 6px;
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
}

.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {
  top: 12px;
}

.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {
  bottom: 12px;
}

.substitute-label-wrap {
  display: inline-block;
}

.substitute-label-wrap span {
  padding-right: 0;
}

.cc-config-tip .cc-config-tip-text {
  color: #576a95;
  cursor: pointer;
}

.cc-config-tip-img {
  width: 480px;
  height: 403px;
}

.d-link {
  cursor: pointer;
}

.d-link,
.edit-print {
  color: #576a95;
}

.settings-handsign-switch {
  margin-top: 10px;
  border-radius: 4px;
}

.handSignNewTipArea {
  position: absolute;
  left: 0;
  width: 16px;
  height: 20px;
  z-index: 10;
  pointer-events: none;
}

.print-auth-dialog .print-auth-title {
  font-size: 18px;
  color: #2a2a2a;
  text-align: center;
  margin: 22px auto 0;
}

.print-auth-dialog .print-auth-demo {
  width: 452px;
  height: 296px;
  background-image: url("//img.alicdn.com/tfs/TB18sLubUD1gK0jSZFGXXbd3FXa-904-592.png");
  background-repeat: no-repeat;
  background-size: contain;
  margin: 16px auto 0;
}

.print-auth-dialog .print-auth-tips {
  text-align: center;
  font-size: 14px;
  color: #000;
  margin: 6px auto 0;
}

.print-auth-dialog .print-auth-qr {
  height: 162px;
  width: 162px;
  margin: 5px auto -40px;
  position: relative;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgba(73, 159, 249, 0.5);
  padding: 12px;
}

.print-auth-dialog .print-auth-qr .print-auth-qr-img {
  background-image: url("//img.alicdn.com/tfs/TB1HnnXd7Y2gK0jSZFgXXc5OFXa-256-256.png");
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 100%;
}

.print-auth-dialog .print-auth-copyright {
  height: 90px;
  margin: 0 -24px -24px;
  border-radius: 0 0 4px 4px;
  color: #fff;
  font-size: 18px;
  background-color: #3195fa;
  text-align: center;
  padding-top: 48px;
}

.wf-formcanvas {
  position: absolute;
  left: 50%;
  margin-left: -245px;
  width: 490px;
  height: 670px;
  background: url("//img.alicdn.com/tfs/TB1vgDmBntYBeNjy1XdXXXXyVXa-980-1340.png")
    no-repeat top;
  background-size: 100% 100%;
}

.wf-formcanvas-inner {
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  width: 292px;
  height: 480px;
  left: 50%;
  margin-left: -146px;
  top: 73px;
  max-height: 480px;
  background: #f6f6f6;
}

.wf-formcanvas-body {
  overflow: hidden;
  padding-bottom: 30px;
}

.empty.wf-formcanvas-inner {
  background: #fff;
}

.empty .wf-formcanvas-body {
  background: url("//img.alicdn.com/tfs/TB1tizSCrGYBuNjy0FoXXciBFXa-478-192.png")
    no-repeat 50%;
  background-size: 239px 96px;
  position: relative;
  min-height: 300px;
}

.empty .wf-formcanvas-body .empty-bg-text {
  text-align: center;
  position: absolute;
  bottom: 70px;
  left: 0;
  right: 0;
  color: #999;
  pointer-events: none;
}

.wf-component {
  margin: 15px 0;
  overflow: hidden;
  position: relative;
}

.wf-main .wf-remove {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  line-height: 1;
  color: #eee;
  display: none;
  cursor: pointer;
  z-index: 10;
  background: #38adff;
  padding: 3px;
}

.wf-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  border: 1px dashed transparent;
}

.wf-overlay.wf-drag {
  cursor: move;
}

.supportTouch .wf-component.active .wf-remove {
  display: block;
}

.wf-remove:hover {
  color: #fff;
}

html:not(.wf-cursor-move) .wf-component.hover > .wf-remove {
  display: block;
}

html:not(.wf-cursor-move) .wf-component.hover > .wf-overlay {
  border-color: #38adff;
}

html:not(.wf-cursor-move) .wf-component.active > .wf-overlay {
  border: 1px solid #38adff;
}

.wf-component.areaactive > .wf-overlay {
  border: 1px solid #ff4500;
}

.wf-component.draging {
  pointer-events: none;
  -webkit-filter: blur(1px);
  filter: blur(1px);
}

.wf-component.draging > .wf-overlay {
  border: 1px dashed #666;
  background: #ccc;
  opacity: 0.8;
}

.wf-component .left-corner-mark {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 0;
  height: 0;
  border-top: 16px solid #3296fa;
  border-right: 16px solid transparent;
  z-index: 10;
  opacity: 1 !important;
}

.wf-component.is-linked {
  opacity: 0.6;
  z-index: 10;
}

.wf-widgetspanel {
  left: 0;
}

.wf-widgetspanel .wf-panel-body {
  margin: 30px -15px 0 0;
  overflow: auto;
}

.wf-widgetsitem label {
  cursor: move;
}

.wf-widgetsitem.disabled label {
  cursor: not-allowed;
}

.wf-panel .wf-widgetsitem {
  margin: 0 0 10px 9px;
  float: left;
}

.wf-widgetsitem {
  width: 148px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: left;
  padding-left: 15px;
  cursor: move;
  color: #191f25;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.wf-widgetsitem.disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.wf-widgetsitem:hover {
  background: hsla(0, 0%, 100%, 0.2);
}

.widgeticon {
  display: inline-block;
  height: 20px;
  width: 20px;
}

.wf-widgetsitem .widgeticon {
  position: absolute;
  right: 7px;
  top: 50%;
  margin-top: -10px;
}

.wf-widgetsitem.hasDesc {
  height: 50px;
}

.wf-widgetsitem.hasDesc label {
  margin-top: 7px;
  line-height: 18px;
  display: block;
}

.wf-widgetsitem.hasDesc .desc {
  display: block;
  line-height: 18px;
  color: rgba(25, 31, 37, 0.4);
}

.new-tip-dot {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #ef5242;
}

.itemNewTooltip {
  max-width: 300px !important;
}

.itemNewPopover {
  width: 256px;
}

.itemNewPopoverTitle {
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 18px;
  color: #242a33;
}

.itemNewPopoverBtns {
  margin-top: 20px;
  margin-bottom: 5px;
  text-align: right;
}

.itemNewPopoverBtns .ant-btn + .ant-btn {
  margin-left: 6px;
}

.widget-item-title {
  clear: both;
  padding: 0 10px 8px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #191f25;
}

.space10 {
  padding-top: 10px;
}

.ant-collapse {
  margin-top: -12px !important;
}

.ant-collapse * {
  user-select: none;
}

.ant-collapse .ant-collapse-item {
  padding-right: 20px;
  border: 0 !important;
}

.ant-collapse .ant-collapse-item .ant-collapse-header {
  padding: 12px 0 12px 24px !important;
}

.ant-collapse .ant-collapse-item .ant-collapse-header > i {
  display: none !important;
}

.ant-collapse .ant-collapse-item .ant-collapse-content {
  margin-top: -8px;
}

.ant-collapse
  .ant-collapse-item
  .ant-collapse-content
  > .ant-collapse-content-box {
  padding: 0;
}

.widget-header-node {
  display: flex;
  align-items: center;
}

.widget-header-node > i:first-child {
  display: none;
}

.widget-header-node > img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
}

.widget-header-node > span {
  flex: 1;
  margin-left: 8px;
  font-size: 16px;
  color: #191f25;
}

.widget-header-node > i:last-child {
  font-weight: 700;
  color: rgba(25, 31, 37, 0.4);
  transition: transform 0.24s, -webkit-transform 0.24s;
}

.widget-header-node svg {
  width: 14px;
  height: 14px;
  transition: transform 0.24s, -webkit-transform 0.24s;
}

.widget-item-advance-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.widget-item-advance-wrap svg {
  width: 24px;
  height: 24px;
  margin-bottom: 18px;
  fill: rgba(25, 31, 37, 0.4);
}

.widget-item-advance {
  display: flex;
  align-items: center;
  width: 250px;
  height: 30px;
  margin-left: 0 !important;
  padding-left: 10px;
  border: 1px solid rgba(25, 31, 37, 0.12);
  border-radius: 4px;
}

.widget-item-advance > img {
  width: 14px;
  height: 14px;
  border-radius: 3px;
}

.widget-item-advance > div {
  margin-left: 7px;
  font-size: 12px;
  color: #191f25;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.panel-advance .ant-tabs-bar {
  position: fixed;
  z-index: 999;
  background: #fff;
}

.panel-advance .ant-tabs-content {
  padding-top: 68px;
}

.wf-settings-pane {
  padding: 20px 16px;
}

.wf-icon {
  width: 25px;
  height: 25px;
  margin-left: 8px;
  margin-right: 8px;
}

.wf-icon-item {
  display: inline-block;
  text-align: center;
  position: relative;
}

.wf-icon-item .tabitem {
  display: none;
  width: 250px;
  height: 28px;
  line-height: 28px;
  font-size: 11px;
  text-align: left;
  border-radius: 2px;
  color: #fff;
  position: absolute;
  left: 10px;
  top: -32px;
}

.wf-icon-item .tabitem.current {
  background: rgba(0, 0, 0, 0.5);
}

.wf-icon-item .tabitem.current:after {
  content: "";
  display: block;
  overflow: hidden;
  position: absolute;
  height: 0;
  width: 0;
  border: 4px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.5);
  bottom: -8px;
  margin-left: -4px;
  left: 20px;
}

.wf-setting-duration-label {
  padding-left: 18px;
}

.wf-setting-suite-duration-label {
  padding-left: 0;
  margin-top: 20px;
}

.wf-push-app {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}

.wf-icon-group {
  position: relative;
  top: 20px;
}

.wf-app-push {
  position: absolute;
  top: 10px;
}

.wf-icon-name {
  color: #fff;
  font-size: 12px;
  position: relative;
  top: -7px;
}

.wf-pushinfo {
  font-size: 14px;
  margin-left: 4px;
}

.wf-item-group {
  padding-left: 18px;
}

.wf-setting-push-radio {
  margin-left: 10px;
}

.wf-tips {
  width: 15px;
  height: 15px;
  margin-left: 4px;
  position: relative;
  top: 3px;
}

.wf-input-tips {
  color: #f4f4f4;
  font-size: 12px;
}

.wf-settingpanel {
  right: 0;
}

.wf-settingpanel select {
  color: #000;
  margin-left: 12px;
  width: 100px;
  line-height: 30px;
  height: 30px;
}

.wf-settingpanel .textarea,
.wf-settingpanel input[type="text"],
.wf-settingpanel textarea {
  background: hsla(0, 0%, 100%, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 6px 10px;
  width: 100%;
  outline: none;
  font-size: 12px;
  min-height: 29px;
}

.wf-settingpanel .textarea:focus,
.wf-settingpanel input[type="text"]:focus,
.wf-settingpanel textarea:focus {
  border-color: #3f9af9;
  background: transparent;
}

.wf-settingpanel ::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}

.wf-settingpanel .wf-form {
  overflow-y: auto;
  padding-bottom: 20px;
}

.wf-settingpanel .ant-tabs .ant-tabs-bar {
  width: 350px;
}

.wf-settingpanel .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  width: 175px;
}

.wf-setting-hrm ul li {
  margin: 6px 0;
}

.wf-settingpanel .wf-setter-field .fieldname {
  line-height: 1.6;
}

.wf-settingpanel .wf-setter-field .require-tip {
  color: #3296fa;
}

.wf-settingpanel .wf-setter-field .fieldinfo {
  color: rgba(25, 31, 37, 0.4);
}

.wf-settingpanel .wf-setter-field .fieldtips {
  font-size: 12px;
  margin-top: 6px;
}

.wf-settingpanel .wf-setter-field .fieldicon {
  cursor: pointer;
  float: right;
  margin-right: 1px;
}

.wf-settingpanel .wf-setter-field .wf-conditionwarn {
  font-size: 12px;
  line-height: 16px;
}

.wf-settingpanel .wf-setter-field .wf-conditionwarn .icon-error {
  color: #ff8415;
  vertical-align: baseline;
}

.wf-settingpanel .wf-setter-field.wf-setting-dateformat input[type="radio"],
.wf-settingpanel .wf-setter-field[class*="wf-setting-"] input[type="checkbox"],
.wf-settingpanel .wf-setter-field[class*="wf-setting-"] input[type="radio"] {
  margin-right: 5px;
  margin-left: 2px;
  vertical-align: middle;
}

.wf-settingpanel .wf-setter-field.wf-setting-push {
  margin-top: 24px;
  margin-left: 5px;
}

.wf-settingpanel .wf-setter-field.wf-setting-push input[type="radio"] {
  margin-right: 5px;
  margin-left: 2px;
  vertical-align: middle;
}

.wf-settingpanel
  .wf-setter-field.wf-setting-daterangelabel
  .fieldblock:not(:last-child) {
  margin-bottom: 30px;
}

.wf-settingpanel .wf-setter-field.wf-setting-options input[type="text"] {
  width: 120px;
}

.wf-settingpanel .wf-setter-field .action {
  margin-left: 5px;
  display: inline-block;
  opacity: 0.8;
  text-align: center;
}

.wf-settingpanel .wf-setter-field .action .icon {
  background: #3296fa;
  border-radius: 50%;
  color: #fff;
  padding: 3px 2px 3px 3px;
  font-size: 12px;
}

.wf-settingpanel .wf-setter-field .action:hover {
  opacity: 0.9;
}

.wf-settingpanel .wf-setter-field .limitadd .action-add,
.wf-settingpanel .wf-setter-field .limitdel .action-del {
  opacity: 0.2;
  pointer-events: none;
}

.wf-settingpanel .wf-setter-field.wf-setting-content textarea {
  min-height: 7.5em;
}

.pushAttendSetting .wf-icon-item {
  margin-right: 16px;
}

.pushAttendSetting .wf-icon-item .wf-icon-item-img {
  display: block;
  margin-top: 10px;
  width: 164px;
  height: 88px;
}

.pushAttendSetting .fieldname {
  font-size: 16px;
  line-height: 18px;
}

.pushAttendSetting .wf-item-group {
  padding-left: 0;
}

.pushAttendSetting .wf-icon-group {
  top: 0;
}

.attendDesc {
  line-height: 20px;
  margin-top: 35px;
  display: block;
}

.select-unit {
  padding-top: 10px;
}

.alitrip-label {
  margin-top: 10px;
  line-height: 24px;
  font-size: 12px;
}

.alitrip-select-unit {
  padding-top: 10px;
  font-size: 12px;
}

.setting-reimburseLabel {
  display: flex;
  flex-direction: row;
}

.setting-reimburseLabel-right {
  margin-left: 12px;
  flex: 4;
}

.reimburseHref-label {
  float: right;
  margin-right: 80px;
}

.exceedApply-label {
  margin-left: 12px;
}

.exceedApplyHref-label {
  float: right;
  margin-right: 10px;
}

.formSaveModal .ant-modal-body,
.wf-popup-content .wf-form.wf-formsettings {
  height: 400px;
  overflow: auto;
}

.setting-alitrip-project {
  display: flex;
  flex-direction: row;
}

.setting-alitrip-project .setting-alitrip-project-left {
  width: 32%;
}

.setting-alitrip-project .setting-alitrip-project-right {
  width: 68%;
}

.wf-sidepanel-head {
  background: #fff;
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.09);
  line-height: 46px;
  height: 46px;
  font-size: 14px;
  color: #191f25;
  padding: 0 16px;
  font-weight: 700;
}

.wf-sidepanel-head .desc {
  font-weight: 400;
  float: right;
  font-size: 12px;
  color: rgba(25, 31, 37, 0.4);
}

.wf-settingpanel {
  right: -100%;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.wf-settingpanel.open {
  right: 0;
}

.ant-alert {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  padding: 8px 15px 8px 37px;
  border-radius: 4px;
}

.ant-alert.ant-alert-no-icon {
  padding: 8px 15px;
}

.ant-alert-icon {
  top: 12.5px;
  left: 16px;
  position: absolute;
}

.ant-alert-description {
  font-size: 14px;
  line-height: 22px;
  display: none;
}

.ant-alert-success {
  border: 1px solid #b7eb8f;
  background-color: #f6ffed;
}

.ant-alert-success .ant-alert-icon {
  color: #52c41a;
}

.ant-alert-info {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
}

.ant-alert-info .ant-alert-icon {
  color: #1890ff;
}

.ant-alert-warning {
  border: 1px solid #ffe58f;
  background-color: #fffbe6;
}

.ant-alert-warning .ant-alert-icon {
  color: #faad14;
}

.ant-alert-error {
  border: 1px solid #ffa39e;
  background-color: #fff1f0;
}

.ant-alert-error .ant-alert-icon {
  color: #f5222d;
}

.ant-alert-close-icon {
  font-size: 12px;
  position: absolute;
  right: 16px;
  top: 8px;
  line-height: 22px;
  overflow: hidden;
  cursor: pointer;
}

.ant-alert-close-icon .anticon-cross {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.ant-alert-close-icon .anticon-cross:hover {
  color: #404040;
}

.ant-alert-close-text {
  position: absolute;
  right: 16px;
}

.ant-alert-with-description {
  padding: 15px 15px 15px 64px;
  position: relative;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.5;
}

.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px;
}

.ant-alert-with-description .ant-alert-icon {
  position: absolute;
  top: 16px;
  left: 24px;
  font-size: 24px;
}

.ant-alert-with-description .ant-alert-close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  font-size: 14px;
}

.ant-alert-with-description .ant-alert-message {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
  margin-bottom: 4px;
}

.ant-alert-with-description .ant-alert-description {
  display: block;
}

.ant-alert.ant-alert-close {
  height: 0 !important;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  transform-origin: 50% 0;
}

.ant-alert-slide-up-leave {
  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: both;
}

.ant-alert-banner {
  border-radius: 0;
  border: 0;
  margin-bottom: 0;
}

@keyframes antAlertSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
}

@keyframes antAlertSlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0);
  }
}

.calculate-edit {
  cursor: pointer;
  float: right;
  color: #2db7f5;
}

.calculate-area {
  cursor: pointer;
}

.formula-alert {
  margin-bottom: 10px;
}

.formula-errormsg {
  padding: 2px 5px;
  margin-bottom: 5px;
  font-size: 12px;
  background: #ffeee7;
  border: 1px solid #feddcd;
  border-radius: 2px;
}

.formula-box {
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #eaeaea;
}

.formula-box .formula-result {
  padding-bottom: 15px;
}

.formula-box.hasError {
  border: 1px solid #f28172;
}

.formula-actions {
  text-align: right;
  font-size: 12px;
  margin-bottom: -5px;
}

.formula-actions .formula-clear,
.formula-actions .formula-del {
  display: inline-block;
  user-select: none;
  cursor: pointer;
  margin-left: 5px;
  padding: 2px 5px;
  opacity: 0.85;
}

.formula-actions .formula-clear:hover,
.formula-actions .formula-del:hover {
  opacity: 1;
}

.formula-actions .formula-del {
  width: 24px;
  color: #2db7f5;
  background: 50% no-repeat
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABOUExURUxpcY+Pj5mZmZmZmZmZmZWVlZOTk5eXl5eXl5mZmZWVlZeXl5eXl5mZmZmZmY+Pj5mZmZmZmZeXl5eXl5mZmZeXl5mZmZiYmJmZmZmZmQrB0mAAAAAZdFJOUwAQ8O/AMECAv39g0J+gzyBw4N+wr5Bfb1Bien3EAAAA8klEQVRIx+2U2xKDIAxEiQpaBbVqL/n/Hy3R6WDtplNn+lb3TWYPkk3AmEN/qu52ArpazW9zxqoI+mlgTS30t8xZCVREogaA+PFpIzG+r/q4j8O11cwF9NdKGA4A5Qc/AuJP+ZLKX0rprAqIP6TPM/ulK04BpGHhNRUvi1mHAfE3615SwzzlKeQNQFv/QqyasgEcCEjWJjWluF1uwRR6DaAtIfW6JhFvKVHGPNA61nh+2cZqfbCRaBMR5nqp0GJ9EmbHaJj7ushvgHk6/B7A9JHoMdBDwARtwuXujkYhKiBW70qjvhoBn5UU4lweb/yhH+sBhOIb4UKezGwAAAAASUVORK5CYII=");
  background-size: 100%;
}

.formula-actions .formula-clear {
  color: #f28172;
}

.formula-placeholder {
  font-size: 12px;
  color: #ccc;
}

.formula-result {
  line-height: 2;
  word-break: break-word;
}

.formula-result > * {
  line-height: 1;
  display: inline-block;
  white-space: nowrap;
}

.formula-result .formula-var {
  white-space: nowrap;
  margin: 0 2px;
  padding: 2px 4px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.65);
  background: #f5f5f5;
}

.formula-result .formula-var.invalid {
  background: #f28172;
}

.formula-result .formula-operator {
  margin: 0 1px;
}

.formula-panel {
  color: #555;
  padding: 0 30px;
  line-height: 32px;
}

.formula-panel .formula-row + .formula-row {
  margin-top: 15px;
}

.formula-panel .formula-row:after,
.formula-panel .formula-row:before {
  content: "";
  display: table;
  clear: both;
}

.formula-panel .formula-row-label {
  position: relative;
  float: left;
  width: 18%;
}

.formula-panel .formula-row-value {
  float: left;
  width: 82%;
}

.formula-panel .formula-var {
  padding: 3px 13px;
  background: #f5f5f5;
  border: 1px solid #eaeaea;
}

.formula-panel .formula-option-var {
  background: #f7f7f7;
}

.formula-panel .formula-option-var:hover {
  background: #f1f1f1;
}

.formula-panel .formula-option-operator {
  background: #fff;
}

.formula-panel .formula-option-operator:hover {
  background: #f1f1f1;
}

.formula-panel .formula-option-operator,
.formula-panel .formula-option-var {
  padding: 5px 12px;
  display: inline-block;
  cursor: pointer;
  line-height: 1;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  margin-right: 10px;
  -webkit-user-select: none;
  white-space: nowrap;
}

.formula-panel .formula-option-operator.disabled,
.formula-panel .formula-option-var.disabled {
  opacity: 0.65;
  pointer-events: none;
}

.formula-tip {
  margin-top: 10px;
  line-height: 1.6;
}

.formula-tip a {
  color: #2db7f5;
}

.holidayTable td,
.holidayTable th {
  padding: 10px;
}

.holidayTable .ant-pagination,
.holidayTable thead {
  display: none;
}

.holidayTagImg {
  width: 13px;
  position: relative;
  top: 2px;
}

.holidayTagContent {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 10px;
  width: 350px;
}

.holidayTag {
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  overflow: hidden;
  clear: both;
}

.holidayTag:last-child {
  border: none;
}

.holidayTagName {
  margin-left: 8px;
  margin-right: 10px;
  display: inline-block;
  border-right: 1px solid rgba(0, 0, 0, 0.09);
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}

.holidayTagName,
.holidayTagUnit {
  font-size: 14px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  float: left;
}

.holidayTagUnit {
  display: flex;
  align-items: center;
  justify-content: center;
  display: inline-block;
}

.holidayCategory {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 14px;
}

.holidayExplain {
  width: 16px;
  height: 16px;
  position: relative;
  margin-left: 10px;
  top: 3px;
}

.holidayLink {
  color: #38adff;
  padding-right: 55px;
  float: right;
  position: relative;
}

.holidayLink-new {
  color: #fff;
  display: block;
  background-color: red;
  padding: 3px 6px;
  border-radius: 10px;
  font-size: 12px;
  position: absolute;
  top: -14px;
  left: 20px;
}

.holidaySetting {
  height: 95px;
  margin-left: 24px;
  margin-top: 30px;
}

.holidaySettingItem {
  margin-top: 10px;
}

.holidaySettingContent {
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
  color: hsla(0, 0%, 100%, 0.5);
}

.holidaySettingItemImg {
  width: 17px;
  position: relative;
  right: 5px;
  top: 2px;
}

.overtime-content .overtime-single {
  margin: 20px 0;
}

.overtime-content .overtime-single .sub-desc {
  font-size: 14px;
  color: #aaa;
  margin-left: 16px;
}

.overtime-content .overtime-mult {
  margin: 20px 0;
  margin-bottom: 0;
}

.overtime-content .overtime-mult .sub-desc {
  margin-top: 10px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 10px;
}

.overtime-content .overtime-link {
  color: #38adff;
}

.overtime-content .overtime-mult-unit {
  margin: 0 20px 0 10px;
}

.wf-setting-overtime .attendDesc {
  margin-top: 0;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {
  height: 40px;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-ink-bar {
  visibility: hidden;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  margin: 0;
  border: 1px solid #e8e8e8;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
  background: #fafafa;
  margin-right: 2px;
  padding: 0 16px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  line-height: 38px;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
  border-color: #e8e8e8;
  color: #1890ff;
  padding-bottom: 1px;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-inactive {
  padding: 0;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.3s;
  font-size: 12px;
  margin-left: 3px;
  margin-right: -5px;
  overflow: hidden;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  height: 14px;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close:hover {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane,
.ant-tabs.ant-tabs-editable-card .ant-tabs-content > .ant-tabs-tabpane {
  transition: none !important;
}

.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs.ant-tabs-editable-card
  .ant-tabs-content
  > .ant-tabs-tabpane-inactive {
  overflow: hidden;
}

.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:hover .anticon-close {
  opacity: 1;
}

.ant-tabs-extra-content {
  line-height: 40px;
}

.ant-tabs-extra-content .ant-tabs-new-tab {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #e8e8e8;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
}

.ant-tabs-extra-content .ant-tabs-new-tab:hover {
  color: #1890ff;
  border-color: #1890ff;
}

.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {
  height: auto;
}

.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 8px;
}

.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  padding-bottom: 4px;
}

.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:last-child {
  margin-bottom: 8px;
}

.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-new-tab {
  width: 90%;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-left
  > .ant-tabs-bar
  .ant-tabs-nav-wrap {
  margin-right: 0;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {
  border-right: 0;
  border-radius: 4px 0 0 4px;
  margin-right: 1px;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-left
  > .ant-tabs-bar
  .ant-tabs-tab-active {
  margin-right: -1px;
  padding-right: 18px;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-right
  > .ant-tabs-bar
  .ant-tabs-nav-wrap {
  margin-left: 0;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-tab {
  border-left: 0;
  border-radius: 0 4px 4px 0;
  margin-left: 1px;
}

.ant-tabs-vertical.ant-tabs-card.ant-tabs-right
  > .ant-tabs-bar
  .ant-tabs-tab-active {
  margin-left: -1px;
  padding-left: 18px;
}

.ant-tabs.ant-tabs-card.ant-tabs-bottom > .ant-tabs-bar .ant-tabs-tab {
  border-bottom: 1px solid #e8e8e8;
  border-top: 0;
  border-radius: 0 0 4px 4px;
}

.ant-tabs.ant-tabs-card.ant-tabs-bottom > .ant-tabs-bar .ant-tabs-tab-active {
  color: #1890ff;
  padding-bottom: 0;
  padding-top: 1px;
}

.ant-tabs {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  overflow: hidden;
  zoom: 1;
}

.ant-tabs:after,
.ant-tabs:before {
  content: "";
  display: table;
}

.ant-tabs:after {
  clear: both;
}

.ant-tabs-ink-bar {
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: 1px;
  box-sizing: border-box;
  height: 2px;
  background-color: #1890ff;
  transform-origin: 0 0;
}

.ant-tabs-bar {
  border-bottom: 1px solid #e8e8e8;
  margin: 0 0 16px;
  outline: none;
}

.ant-tabs-bar,
.ant-tabs-nav-container {
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-nav-container {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  position: relative;
  white-space: nowrap;
  margin-bottom: -1px;
  zoom: 1;
}

.ant-tabs-nav-container:after,
.ant-tabs-nav-container:before {
  content: "";
  display: table;
}

.ant-tabs-nav-container:after {
  clear: both;
}

.ant-tabs-nav-container-scrolling {
  padding-left: 32px;
  padding-right: 32px;
}

.ant-tabs-bottom .ant-tabs-bar {
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
}

.ant-tabs-bottom .ant-tabs-ink-bar {
  bottom: auto;
  top: 1px;
}

.ant-tabs-bottom .ant-tabs-nav-container {
  margin-bottom: 0;
  margin-top: -1px;
}

.ant-tabs-tab-next,
.ant-tabs-tab-prev {
  user-select: none;
  z-index: 2;
  width: 0;
  height: 100%;
  cursor: pointer;
  border: 0;
  background-color: transparent;
  position: absolute;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  opacity: 0;
  pointer-events: none;
}

.ant-tabs-tab-next.ant-tabs-tab-arrow-show,
.ant-tabs-tab-prev.ant-tabs-tab-arrow-show {
  opacity: 1;
  width: 32px;
  height: 100%;
  pointer-events: auto;
}

.ant-tabs-tab-next:hover,
.ant-tabs-tab-prev:hover {
  color: rgba(0, 0, 0, 0.65);
}

.ant-tabs-tab-next-icon,
.ant-tabs-tab-prev-icon {
  font-style: normal;
  font-weight: 700;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  text-transform: none;
}

.ant-tabs-tab-next-icon:before,
.ant-tabs-tab-prev-icon:before {
  display: block;
  font-family: anticon !important;
  display: inline-block;
  font-size: 12px;
  font-size: 10px\9;
  transform: scale(0.83333333) rotate(0deg);
}

:root .ant-tabs-tab-next-icon:before,
:root .ant-tabs-tab-prev-icon:before {
  font-size: 12px;
}

.ant-tabs-tab-btn-disabled {
  cursor: not-allowed;
}

.ant-tabs-tab-btn-disabled,
.ant-tabs-tab-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
}

.ant-tabs-tab-next {
  right: 2px;
}

.ant-tabs-tab-next-icon:before {
  content: "\E61F";
}

.ant-tabs-tab-prev {
  left: 0;
}

.ant-tabs-tab-prev-icon:before {
  content: "\E620";
}

:root .ant-tabs-tab-prev {
  filter: none;
}

.ant-tabs-nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
}

.ant-tabs-nav-scroll {
  overflow: hidden;
  white-space: nowrap;
}

.ant-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  margin: 0;
  list-style: none;
  display: inline-block;
}

.ant-tabs-nav:after,
.ant-tabs-nav:before {
  display: table;
  content: " ";
}

.ant-tabs-nav:after {
  clear: both;
}

.ant-tabs-nav .ant-tabs-tab-disabled {
  pointer-events: none;
  cursor: default;
  color: rgba(0, 0, 0, 0.25);
}

.ant-tabs-nav .ant-tabs-tab {
  display: inline-block;
  height: 100%;
  margin: 0 32px 0 0;
  padding: 12px 16px;
  box-sizing: border-box;
  position: relative;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
  text-decoration: none;
}

.ant-tabs-nav .ant-tabs-tab:last-child {
  margin-right: 0;
}

.ant-tabs-nav .ant-tabs-tab:hover {
  color: #40a9ff;
}

.ant-tabs-nav .ant-tabs-tab:active {
  color: #096dd9;
}

.ant-tabs-nav .ant-tabs-tab .anticon {
  margin-right: 8px;
}

.ant-tabs-nav .ant-tabs-tab-active {
  color: #1890ff;
  font-weight: 500;
}

.ant-tabs-large .ant-tabs-nav-container {
  font-size: 16px;
}

.ant-tabs-large .ant-tabs-tab {
  padding: 16px;
}

.ant-tabs-small .ant-tabs-nav-container {
  font-size: 14px;
}

.ant-tabs-small .ant-tabs-tab {
  padding: 8px 16px;
}

.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content {
  width: 100%;
}

.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content > .ant-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.45s;
  opacity: 1;
}

.ant-tabs:not(.ant-tabs-vertical)
  > .ant-tabs-content
  > .ant-tabs-tabpane-inactive {
  opacity: 0;
  height: 0;
  padding: 0 !important;
  pointer-events: none;
}

.ant-tabs:not(.ant-tabs-vertical)
  > .ant-tabs-content
  > .ant-tabs-tabpane-inactive
  input {
  visibility: hidden;
}

.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content-animated {
  display: flex;
  flex-direction: row;
  will-change: margin-left;
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-vertical > .ant-tabs-bar {
  border-bottom: 0;
  height: 100%;
}

.ant-tabs-vertical > .ant-tabs-bar-tab-next,
.ant-tabs-vertical > .ant-tabs-bar-tab-prev {
  width: 32px;
  height: 0;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-vertical > .ant-tabs-bar-tab-next.ant-tabs-tab-arrow-show,
.ant-tabs-vertical > .ant-tabs-bar-tab-prev.ant-tabs-tab-arrow-show {
  width: 100%;
  height: 32px;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab {
  float: none;
  margin: 0 0 16px;
  padding: 8px 24px;
  display: block;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab:last-child {
  margin-bottom: 0;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-extra-content {
  text-align: center;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-scroll {
  width: auto;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container,
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {
  height: 100%;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container {
  margin-bottom: 0;
}

.ant-tabs-vertical
  > .ant-tabs-bar
  .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {
  padding: 32px 0;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav {
  width: 100%;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-ink-bar {
  width: 2px;
  left: auto;
  height: auto;
  top: 0;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next {
  width: 100%;
  bottom: 0;
  height: 32px;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next-icon:before {
  content: "\E61D";
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev {
  top: 0;
  width: 100%;
  height: 32px;
}

.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev-icon:before {
  content: "\E61E";
}

.ant-tabs-vertical > .ant-tabs-content {
  overflow: hidden;
  width: auto;
  margin-top: 0 !important;
}

.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar {
  float: left;
  border-right: 1px solid #e8e8e8;
  margin-right: -1px;
  margin-bottom: 0;
}

.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {
  text-align: right;
}

.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-container,
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-right: -1px;
}

.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-ink-bar {
  right: 1px;
}

.ant-tabs-vertical.ant-tabs-left > .ant-tabs-content {
  padding-left: 24px;
  border-left: 1px solid #e8e8e8;
}

.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar {
  float: right;
  border-left: 1px solid #e8e8e8;
  margin-left: -1px;
  margin-bottom: 0;
}

.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-container,
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-left: -1px;
}

.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-ink-bar {
  left: 1px;
}

.ant-tabs-vertical.ant-tabs-right > .ant-tabs-content {
  padding-right: 24px;
  border-right: 1px solid #e8e8e8;
}

.ant-tabs-bottom > .ant-tabs-bar {
  margin-bottom: 0;
  margin-top: 16px;
}

.ant-tabs-bottom .ant-tabs-ink-bar-animated,
.ant-tabs-top .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-left .ant-tabs-ink-bar-animated,
.ant-tabs-right .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-tabs-no-animation > .ant-tabs-content-animated,
.ant-tabs-vertical > .ant-tabs-content-animated,
.no-flex > .ant-tabs-content-animated {
  transform: none !important;
  margin-left: 0 !important;
}

.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs-vertical > .ant-tabs-content > .ant-tabs-tabpane-inactive,
.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive {
  display: none;
}

.wf-view {
  position: relative;
}

.wf-view .wf-componentview-adddetail {
  color: #008cee;
  text-align: center;
  padding: 15px;
  background: #f7f9ff;
  border-bottom: 1px solid hsla(240, 2%, 79%, 0.5);
  vertical-align: middle;
}

.wf-view .wf-componentview-adddetail:before {
  font-family: iconfontold;
  font-size: 16px;
  font-style: normal;
  content: "\E608";
  display: inline-block;
  margin: 0 3px 0 0;
}

.wf-view .wf-componentview-content {
  padding: 15px;
  color: #858e99;
}

.wf-view .wf-componentview-area {
  min-height: 50px;
  background: #ddeff3;
  position: relative;
}

.wf-view .wf-componentview-area .emptytip {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  padding: 0 8px;
  text-align: center;
  color: #ccc;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.wf-field {
  display: flex;
  align-items: center;
  position: relative;
  background: #fff;
  font-size: 14px;
  padding: 14px 0;
}

.wf-field > * {
  flex: 1;
  width: 100%;
}

.wf-field .icon {
  width: 26px;
  flex: none;
  font-size: 18px;
  line-height: 1;
  color: #e0e0e0;
}

.wf-field-border {
  border-bottom: 1px solid #eee;
}

.wf-field-label {
  color: rgba(25, 31, 37, 0.56);
  white-space: normal;
  word-break: break-word;
  padding: 0 10px;
  color: #222;
  flex: none;
  width: 120px;
}

.wf-field-placeholder {
  text-align: right;
  color: rgba(25, 31, 37, 0.4);
  padding-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wf-group > .wf-component + .wf-component,
.wf-group > .wf-field + .wf-field {
  border-top: 1px solid rgba(25, 31, 37, 0.08);
}

.wf-group,
.wf-group > .wf-component {
  margin: 0;
  padding: 0;
}

.wf-group > .wf-component.wf-component-textnote {
  background: #f6f6f6;
}

.wf-table-row-title {
  display: block;
  padding: 14px 10px;
  color: rgba(25, 31, 37, 0.56);
  background: #fff;
  border-bottom: 1px solid rgba(25, 31, 37, 0.08);
}

.empty .wf-group {
  border-width: 0;
}

.wf-componentview-stats {
  padding: 3px 10px;
}

.wf-componentview-stats .wf-componentview-statitem {
  color: #858e99;
  font-size: 14px;
  text-align: left;
  line-height: 20px;
  margin: 2px 0;
}

.wf-formdes {
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  width: 100%;
  padding-left: 15px;
  color: #333;
  background-color: #fcf7d7;
  padding: 0 5px;
}

.wf-formdes-setting {
  color: #5dbbf7;
  margin-left: 10px;
  display: inline-block;
  position: absolute;
  z-index: 999;
}

.wf-componentview-tip-icon {
  border: 0;
  width: 30px;
  position: relative;
  float: right;
  top: -6px;
}

.wf-component-textnote {
  padding: 0;
  margin: 0;
}

.textnote-content {
  line-height: 1.4;
}

.wf-component-calculatefield .cnformat,
.wf-component-moneyfield .cnformat {
  color: rgba(25, 31, 37, 0.4);
  font-size: 13px;
  padding: 5px 15px;
}

.wf-component-ddbizsuite .wf-componentview-content {
  padding: 0;
}

.wf-component-ddbizsuite .wf-component-textnote .wf-componentview {
  padding-left: 15px;
}

.wf-component-ddbizsuite
  .wf-component-textnote
  .wf-componentview
  .textnote-content {
  padding: 10px 10px 10px 0;
}

.recipient-usetips .extra {
  color: rgba(25, 31, 37, 0.4);
}

.recipient-usetips .recipient-usetips__icon {
  margin-top: 13px;
  width: 100%;
}

.recipient-usetips .recipient-usetips__icon-tip {
  display: flex;
  margin-top: 18px;
  justify-content: space-around;
  font-size: 12px;
  line-height: 17px;
  color: rgba(38, 38, 38, 0.3);
}

@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(1.6);
    opacity: 0;
  }
}

.ant-select-tree-checkbox {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: middle;
  top: -0.09em;
}

.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner {
  border-color: #1890ff;
}

.ant-select-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #1890ff;
  content: "";
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  visibility: hidden;
}

.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox:after,
.ant-select-tree-checkbox:hover:after {
  visibility: visible;
}

.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  transition: all 0.3s;
}

.ant-select-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4.57142857px;
  top: 1.14285714px;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  opacity: 0;
}

.ant-select-tree-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner:after {
  content: " ";
  transform: translate(-50%, -50%) scale(1);
  border: 0;
  left: 50%;
  top: 50%;
  width: 9px;
  height: 9px;
  background-color: #1890ff;
  opacity: 1;
}

.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled
  .ant-select-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  opacity: 1;
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}

.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked
  .ant-select-tree-checkbox-inner:after {
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  border-color: #d9d9d9 !important;
  background-color: #f5f5f5;
}

.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  animation-name: none;
  border-color: #f5f5f5;
}

.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ant-select-tree-checkbox-wrapper {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: unset;
  cursor: pointer;
  display: inline-block;
}

.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {
  margin-left: 8px;
}

.ant-select-tree-checkbox + span,
.ant-select-tree-checkbox-wrapper + span {
  padding-left: 8px;
  padding-right: 8px;
}

.ant-select-tree-checkbox-group {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
}

.ant-select-tree-checkbox-group-item {
  display: inline-block;
  margin-right: 8px;
}

.ant-select-tree-checkbox-group-item:last-child {
  margin-right: 0;
}

.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 0;
}

.ant-select-tree {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  padding: 0;
  list-style: none;
  margin: 0;
  padding: 0 4px;
  margin-top: -4px;
}

.ant-select-tree li {
  padding: 0;
  margin: 8px 0;
  list-style: none;
  white-space: nowrap;
  outline: 0;
}

.ant-select-tree li.filter-node > span {
  font-weight: 500;
}

.ant-select-tree li ul {
  margin: 0;
  padding: 0 0 0 18px;
}

.ant-select-tree li .ant-select-tree-node-content-wrapper {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 2px;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
  width: calc(100% - 24px);
}

.ant-select-tree li .ant-select-tree-node-content-wrapper:hover {
  background-color: #e6f7ff;
}

.ant-select-tree
  li
  .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #bae7ff;
}

.ant-select-tree li span.ant-select-tree-checkbox {
  margin: 0 4px 0 0;
}

.ant-select-tree
  li
  span.ant-select-tree-checkbox
  + .ant-select-tree-node-content-wrapper {
  width: calc(100% - 46px);
}

.ant-select-tree li span.ant-select-tree-iconEle,
.ant-select-tree li span.ant-select-tree-switcher {
  margin: 0;
  width: 24px;
  height: 24px;
  line-height: 22px;
  display: inline-block;
  vertical-align: middle;
  border: 0 none;
  cursor: pointer;
  outline: none;
  text-align: center;
}

.ant-select-tree li span.ant-select-tree-icon_loading:after {
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\E6AE";
  animation: loadingCircle 1s infinite linear;
  color: #1890ff;
}

.ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher-noop {
  cursor: auto;
}

.ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher_open:after {
  font-size: 12px;
  font-size: 7px\9;
  transform: scale(0.58333333) rotate(0deg);
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\E606";
  font-weight: 700;
  transition: transform 0.3s;
}

:root
  .ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher_open:after {
  font-size: 12px;
}

.ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  font-size: 12px;
  font-size: 7px\9;
  transform: scale(0.58333333) rotate(0deg);
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\E606";
  font-weight: 700;
  transition: transform 0.3s;
}

:root
  .ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  font-size: 12px;
}

.ant-select-tree
  li
  span.ant-select-tree-switcher.ant-select-tree-switcher_close:after {
  transform: rotate(270deg) scale(0.59);
}

.ant-select-tree-child-tree {
  display: none;
}

.ant-select-tree-child-tree-open {
  display: block;
}

li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper,
li.ant-select-tree-treenode-disabled
  > .ant-select-tree-node-content-wrapper
  span,
li.ant-select-tree-treenode-disabled > span:not(.ant-select-tree-switcher) {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

li.ant-select-tree-treenode-disabled
  > .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}

.ant-select-tree-icon__close,
.ant-select-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}

.ant-select-tree-dropdown {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ant-select-tree-dropdown .ant-select-dropdown-search {
  display: block;
  padding: 4px;
}

.ant-select-tree-dropdown
  .ant-select-dropdown-search
  .ant-select-search__field__wrap {
  width: 100%;
}

.ant-select-tree-dropdown
  .ant-select-dropdown-search
  .ant-select-search__field {
  padding: 4px 7px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
}

.ant-select-tree-dropdown .ant-select-dropdown-search.ant-select-search--hide {
  display: none;
}

.ant-select-tree-dropdown .ant-select-not-found {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
  padding: 7px 16px;
  display: block;
}

.form-item-selector-tree input[type="text"] {
  border: none !important;
  padding: 0 !important;
}

.linkage-setting-tip {
  font-size: 14px;
  color: #000;
  line-height: 20px;
  margin-bottom: 6px;
}

.option-item {
  margin-top: 8px;
}

.option-item input[type="text"] {
  width: 230px !important;
}

.option-item .action-icon {
  cursor: pointer;
  font-size: 16px;
}

.option-item .action-add {
  color: #3296fa;
  opacity: 1 !important;
}

.option-item .action-add.disabled {
  opacity: 0.2 !important;
  pointer-events: none;
}

.option-item .action-del {
  color: #000;
  opacity: 0.45 !important;
}

.option-item .action-del.disabled {
  opacity: 0.2 !important;
  pointer-events: none;
}

.option-item .ant-input-affix-wrapper {
  width: auto;
}

.option-item .option-drag-icon {
  cursor: grab;
}

.option-item .option-drag-icon svg {
  width: 16px;
  height: 16px;
}

.supply-setter {
  margin-bottom: 16px;
}

.supply-setter-card {
  background: #e6f7ff;
  border: 1px solid #15bdf4;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 16px;
}

.supply-setter-card-title,
.supply-setter-label {
  font-weight: 700;
  font-size: 14px;
}

.supply-setter-card-action {
  padding: 10px 0 4px;
}

.supply-setter-link {
  font-weight: 400;
}

.related-opiton-modal .ant-modal-header {
  border-bottom: 0;
}

.related-opiton-modal .ant-checkbox-group {
  display: flex;
  flex-direction: column;
  height: 165px;
  padding-left: 20px;
  overflow-y: scroll;
}

.related-opiton-modal .ant-checkbox-group-item {
  margin-bottom: 8px;
}

.related-opiton-modal .ant-checkbox-group-item > span:last-child {
  opacity: 0.65;
  font-size: 14px;
  color: #000;
  line-height: 22px;
}

.related-option {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.related-option-title {
  margin-bottom: 8px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #191f25;
}

.related-option-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.related-option-item > div {
  display: flex;
  align-items: center;
  width: 260px;
  height: 34px;
  padding: 0 8px;
  background: rgba(25, 31, 37, 0.04);
  border-radius: 4px;
  font-size: 12px;
  color: #000;
}

.related-option-item > i {
  margin-left: 14px;
  font-size: 14px;
  color: #8c8c8c;
  cursor: pointer;
}

.related-option-ft {
  width: 50%;
  margin: 6px 0;
  cursor: pointer;
}

.related-option-ft > i,
.related-option-ft > span {
  color: #3296fa;
  font-size: 14px;
}

.related-option-ft > span {
  margin-left: 5px;
}

.formSelectModal .ant-modal-body {
  padding: 0;
}

.formSelectPanel {
  position: relative;
  height: 400px;
}

.formSelectPanel .contentWrap,
.formSelectPanel .topBar {
  padding: 0 30px;
}

.formSelectPanel .topBar {
  font-size: 14px;
  font-weight: 700;
  padding-top: 10px;
  line-height: 50px;
  height: 60px;
}

.formSelectPanel .contentWrap,
.formSelectPanel .leftPanel,
.formSelectPanel .rightPanel {
  position: absolute;
}

.formSelectPanel .leftPanel,
.formSelectPanel .rightPanel {
  top: 0;
  bottom: 0;
  width: 50%;
}

.formSelectPanel .leftPanel {
  left: 0;
}

.formSelectPanel .rightPanel {
  right: 0;
  border-left: 1px solid #e9e9e9;
}

.formSelectPanel .contentWrap {
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.formTreeSelect {
  color: #323232;
  margin-left: -10px;
}

.dirItem {
  margin: 2px 0;
}

.dirTitle {
  padding: 4px 5px 4px 10px;
  display: flex;
  align-items: center;
}

.dirTitle > span {
  flex: 1;
}

.dirTitle .dirArrow,
.dirTitle .dirCheck {
  flex: none;
  width: 20px;
}

.dirTitle .dirArrow {
  cursor: pointer;
  display: inline-block;
  width: 24px;
  height: 20px;
  background: url(//gw.alicdn.com/tfs/TB1VhwSe7yWBuNjy0FpXXassXXa-30-18.png) 0
    no-repeat;
  background-size: 12px;
}

.dirTitle .dirArrow.down {
  transform-origin: 6px center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.dirTitle .dirName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dirChildren {
  display: block;
  padding-left: 30px;
}

.dirChildren.collapsed {
  display: none;
}

.formItem {
  display: flex;
  align-items: center;
  margin: 2px 0;
  padding: 3px 0 3px 10px;
}

.formItem > span {
  flex: 1;
}

.formItem .formName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.72;
}

.formItem.result {
  cursor: default;
}

.formItem.result .formName {
  opacity: 1;
}

.formItem .formCheck,
.formItem .formRemove {
  flex: none;
  width: 20px;
}

.formItem .formRemove {
  cursor: pointer;
  display: inline-block;
  width: 40px;
  height: 20px;
  background: url(//gw.alicdn.com/tfs/TB19sr_e1uSBuNjy1XcXXcYjFXa-46-46.png) 50%
    no-repeat;
  background-size: 12px;
}

.formSearch {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.formSearch .formSearchIcon {
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  margin-top: -1px;
  display: inline-block;
  width: 30px;
  height: 20px;
  background: url(//gw.alicdn.com/tfs/TB1Nag0e7yWBuNjy0FpXXassXXa-32-32.png) 50%
    no-repeat;
  background-size: 14px;
}

.formSearch input[type="text"].formSearchInput {
  width: 100%;
  font-size: 13px;
  border: none;
  outline: none;
  line-height: 24px;
  padding-left: 30px;
  padding-top: 4px;
  padding-bottom: 4px;
  background: #f5f6f7;
  border-radius: 4px;
}

.formItem .dirTitle {
  cursor: pointer;
}

.formItem .dirTitle:hover {
  background: #f6f6f6;
}

.ant-collapse {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
}

.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse > .ant-collapse-item:last-child,
.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 4px 4px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  line-height: 22px;
  padding: 12px 0 12px 40px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: rotate(0);
  font-size: 12px;
  position: absolute;
  display: inline-block;
  line-height: 46px;
  vertical-align: top;
  transition: transform 0.24s;
  top: 0;
  left: 16px;
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow:before {
  display: block;
  font-family: anticon !important;
  content: "\E61F";
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {
  outline: none;
}

.ant-collapse
  > .ant-collapse-item.ant-collapse-no-arrow
  > .ant-collapse-header {
  padding-left: 12px;
}

.ant-collapse-anim-active {
  transition: height 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.ant-collapse-content {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border-top: 1px solid #d9d9d9;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 16px;
}

.ant-collapse-content-inactive {
  display: none;
}

.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 0 4px 4px;
}

.ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header[aria-expanded="true"]
  .arrow {
  transform: rotate(90deg);
}

.ant-collapse-borderless {
  background-color: #fff;
  border: 0;
}

.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}

.ant-collapse-borderless > .ant-collapse-item:last-child,
.ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0;
}

.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.ant-collapse-borderless
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding-top: 4px;
}

.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,
.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}

@font-face {
  font-family: iconfontold;
  src: url("//at.alicdn.com/t/font_1449632746_779643.eot");
  src: url("//at.alicdn.com/t/font_1449632746_779643.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_1449632746_779643.woff") format("woff"),
    url("//at.alicdn.com/t/font_1449632746_779643.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_1449632746_779643.svg#iconfontold")
      format("svg");
}

.icon {
  font-family: iconfontold !important;
  font-size: 16px;
  font-style: normal;
  vertical-align: middle;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.icon-selected:before {
  content: "\E600";
}

.icon-checked:before {
  content: "\E60B";
}

.icon-add:before {
  content: "\E604";
}

.icon-del:before {
  content: "\E602";
}

.icon-remove:before {
  content: "\E605";
}

.icon-close:before {
  content: "\E603";
}

.icon-error:before {
  content: "\E601";
}

.icon-success:before {
  content: "\E600";
}

.icon-plus:before {
  content: "\E608";
}

.icon-minus:before {
  content: "\E609";
}

.icon-camera:before {
  content: "\E606";
}

.icon-arrow:before {
  content: "\E607";
}

.icon-chakanfujian:before {
  content: "\E60D";
}

.wf-button {
  margin: 0 5px;
  border: none;
  border-radius: 2px;
  padding: 4px 23px;
  color: #fff;
  font-size: 12px;
  outline: none;
  cursor: pointer;
  line-height: normal;
}

.wf-button.wf-button-blue {
  background: #3f9af9;
}

.wf-button.wf-button-blue:hover {
  background: #2786e8;
}

.wf-button.wf-button-cyan {
  background: #5db4cf;
}

.wf-button.wf-button-cyan:hover {
  background: #429dba;
}

.wf-button.wf-button-green {
  background: #41b543;
}

.wf-button.wf-button-green:hover {
  background: #39a03b;
}

.wf-button.wf-button-white {
  color: #fff;
  background: #aaa;
}

.wf-button.wf-button-white:hover {
  color: #fff;
  background: #f90;
}

.wf-new-button {
  margin: 0 5px;
  border: none;
  border-radius: 4px;
  padding: 6px 15px;
  color: #fff;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  line-height: normal;
}

.wf-new-button.wf-button-blue {
  background: #38adff;
}

.wf-new-button.wf-button-blue:hover {
  background: rgba(56, 173, 255, 0.7);
}

.wf-new-button.wf-button-cyan,
.wf-new-button.wf-button-cyan:hover {
  background: #38adff;
}

.wf-new-button.wf-button-green {
  color: #38adff;
  border: 1px solid #38adff;
  background: hsla(0, 0%, 100%, 0.1);
  padding: 6px 34px;
}

.wf-new-button.wf-button-green:hover {
  background: hsla(0, 0%, 100%, 0.2);
}

.wf-new-button.wf-button-white {
  color: #fff;
  background: #aaa;
}

.wf-new-button.wf-button-white:hover {
  color: #fff;
  background: #f90;
}

.wf-storyboard {
  overflow: visible;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 999;
}

.wf-storyboard.mask {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.2);
}

.wf-spinning {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url("data:image/gif;base64,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");
}

.wf-popup {
  position: absolute;
  pointer-events: auto;
  overflow: hidden;
  background: #fff;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) scale(0.9);
  transform: translate(-50%, -50%) scale(0.9);
  -webkit-transition: -webkit-transform 0.15s ease-out;
  transition: transform 0.15s ease-out;
}

.ant-modal.visible,
.wf-popup.visible {
  -webkit-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}

.ant-modal.wf-preview,
.wf-popup.wf-preview {
  top: 150px;
  -webkit-transform: translate(-50%, -15px);
  transform: translate(-50%, -15px);
}

.ant-modal.wf-preview.visible,
.wf-popup.wf-preview.visible {
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}

.ant-modal.wf-message,
.wf-popup.wf-message {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  color: #fff;
  top: 2px;
  left: 50%;
  -webkit-transform: translate(-50%, -120%);
  transform: translate(-50%, -120%);
}

.ant-modal.wf-message.visible,
.wf-popup.wf-message.visible {
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}

.ant-modal input[type="text"],
.ant-modal textarea,
.wf-popup input[type="text"],
.wf-popup textarea {
  border: 1px solid #ccc;
  color: #666;
  padding: 5px 10px;
  width: 400px;
  border-radius: 2px;
  font-size: 12px;
  outline: none;
}

.ant-modal textarea {
  width: 100%;
}

.ant-modal input[type="text"]:focus,
.ant-modal textarea:focus,
.wf-popup input[type="text"]:focus,
.wf-popup textarea:focus {
  border-color: #3f9af9;
}

.ant-modal .select-main .default-select,
.wf-popup .select-main .default-select {
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #666;
}

.ant-modal .select-main .error-empty,
.wf-popup .select-main .error-empty {
  border: 1px solid #ff4500;
}

.ant-modal .wf-popup-title,
.wf-popup .wf-popup-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  padding: 15px;
  border-bottom: 1px dashed #ced1d2;
}

.ant-modal .wf-popup-content,
.wf-popup .wf-popup-content {
  padding: 20px;
}

.ant-modal .wf-popup-actions,
.wf-popup .wf-popup-actions {
  margin: 5px 0;
  text-align: center;
}

.wf-popup-close {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}

.wf-popup-close:hover {
  color: #666;
}

.wf-message .wf-popup-close:hover {
  color: #fff;
}

.wf-message .wf-popup-content {
  text-align: center;
  font-size: 14px;
  padding: 20px !important;
}

.wf-message .wf-popup-content .icon {
  margin-right: 5px;
}

.wf-message .wf-popup-content .text {
  vertical-align: middle;
}

.wf-message .wf-popup-content.success .icon {
  color: #39a03b;
}

.wf-message .wf-popup-content.error .icon {
  color: red;
}

.wf-message .wf-popup-content.warn .icon {
  color: #fda533;
}

.wf-confirm .wf-popup-content {
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

.wf-confirm .wf-popup-content .icon {
  margin-right: 5px;
  color: #fda533;
}

.wf-confirm .wf-popup-content .icon-color-green {
  margin-right: 5px;
  color: #39a03b;
}

.wf-confirm .wf-popup-content .text {
  vertical-align: middle;
}

.wf-confirm .wf-popup-content .detail {
  color: #ccc;
  font-size: 12px;
  margin: 15px 0 5px;
}

.wf-confirm .wf-popup-content .wf-popup-actions {
  margin: 15px 0 5px;
}

.wf-field-group {
  margin: 5px 0 30px;
}

.wf-field-group .wf-setter-field {
  margin: 10px 0 0;
}

.wf-setter-field {
  margin: 5px 0 16px;
}

.wf-setter-field .fieldname {
  display: block;
  font-weight: 700;
  font-size: 14px;
  color: #191f25;
  margin-bottom: 7px;
}

.wf-setter-field .fieldname span {
  font-size: 12px;
}

.wf-setter-field .fieldinfo {
  color: #ccc;
  font-size: 12px !important;
  margin-left: 8px;
  font-weight: 400;
  opacity: 0.9;
}

.wf-setter-field .fieldinfo.error-duplicate,
.wf-setter-field .fieldinfo.error-empty,
.wf-setter-field .fieldinfo.error-toolong,
.wf-setter-field .fieldinfo.error-wrong {
  color: #ff4500 !important;
}

.wf-setter-field .fieldinfo.error-warn {
  color: #ff8c00 !important;
}

.wf-setter-field input[type="text"].error-duplicate,
.wf-setter-field input[type="text"].error-empty,
.wf-setter-field input[type="text"].error-toolong,
.wf-setter-field input[type="text"].error-wrong,
.wf-setter-field textarea.error-duplicate,
.wf-setter-field textarea.error-empty,
.wf-setter-field textarea.error-toolong,
.wf-setter-field textarea.error-wrong {
  border-color: #ff4500 !important;
}

.wf-setter-field input[type="text"].error-warn,
.wf-setter-field textarea.error-warn {
  border-color: #ff8c00 !important;
}

.wf-setter-field .fieldblock {
  display: block;
  margin: 5px 0;
  overflow: hidden;
}

.wf-setter-field .verticalmiddle {
  vertical-align: middle;
}

.wf-dialog .wf-dialog-foot,
.wf-dialog .wf-dialog-head {
  padding: 15px;
}

.wf-dialog .wf-dialog-head {
  border-bottom: 1px solid #ededed;
}

.wf-dialog .wf-dialog-body {
  display: block;
}

.wf-dialog .wf-dialog-foot {
  border-top: 1px solid #ededed;
  text-align: right;
}

.wf-dialog .wf-dialog-foot .wf-button {
  display: inline-block;
  text-align: center;
}

@-moz-keyframes spining {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}

@-webkit-keyframes spining {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}

@-o-keyframes spining {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}

@keyframes spining {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}

.wf-setting-line {
  margin-top: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 12px;
  padding-right: 12px;
}

.border-left-line {
  padding-left: 12px;
  border-left: 1px solid #e3e3e4;
}

.error-warn {
  color: #ff8c00 !important;
}

.error-warn input {
  border-color: #ff8c00 !important;
}

.wf-setting-desc,
.wf-setting-title {
  font-size: 12px;
}

.wf-setting-title {
  font-weight: 700;
  margin-bottom: 12px;
}

.wf-setting-desc {
  margin-top: 6px;
}

.wf-setting-textarea {
  width: 100%;
  max-width: 100%;
  outline: none;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #eaeaea;
}

.selectedFormItem {
  white-space: nowrap;
  display: inline-block;
  margin: 3px 2px;
  padding: 2px 4px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.65);
  text-align: left;
  background: #f5f5f5;
}

.textarea-relatefield {
  cursor: pointer;
}

.unsupport-label-name {
  color: rgba(24, 144, 255, 0.6);
  cursor: pointer;
}

.not-support-linkage {
  width: 280px;
}

.not-support-linkage.ant-popover-placement-top {
  padding-bottom: 4px;
}

.not-support-linkage.ant-popover-placement-top .ant-popover-arrow {
  bottom: -0.5px;
}

.not-support-linkage .container {
  padding-left: 22px;
}

.not-support-linkage .warn-icon {
  color: #faad14;
  position: absolute;
  left: 15px;
  top: 15px;
}

.not-support-linkage .title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
}

.not-support-linkage .content {
  font-family: PingFangSC-Regular;
  font-size: 12px;
}

.not-support-linkage .content p {
  margin: 4px 0;
}

.wf-dragging-proxy {
  position: fixed;
  pointer-events: none;
  z-index: 10;
}

.wf-dragging-proxy .wf-widgetsitem {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
}

.wf-dragging-mark {
  background: #ff4500;
  height: 2px;
  overflow: visible;
  position: relative;
  margin: 3px 0;
}

.wf-dragging-mark:after,
.wf-dragging-mark:before {
  position: absolute;
  content: "";
  display: block;
  height: 0;
  width: 0;
  border-style: solid;
  border-color: transparent;
  border-width: 4px 8px;
  top: -3px;
}

.wf-dragging-mark:before {
  left: 0;
  border-left-color: #ff4500;
}

.wf-dragging-mark:after {
  right: 0;
  border-right-color: #ff4500;
}

.wf-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
  width: 330px;
  background: #fff;
  overflow-y: auto;
  overflow-y: overlay;
}

.wf-panel-tab {
  height: 32px;
}

.wf-panel-tab .fillitem {
  width: 310px !important;
  text-align: left !important;
}

.wf-panel-tab .tabitem {
  display: inline-block;
  width: 175px;
  height: 35px;
  line-height: 35px;
  font-size: 17px;
  text-align: left;
  border-radius: 2px;
  border-bottom: 2px solid #ccc;
  color: #ccc;
}

.wf-panel-tab .tabitem.current {
  color: #2db7f5;
  border-bottom: 2px solid #2db7f5;
}

.controls-tab .tabitem {
  width: 155px;
}

.wf-panel-body {
  overflow: hidden;
}

.wf-panel .ant-tabs .ant-tabs-bar {
  width: 325px;
  margin-bottom: 20px;
}

.wf-panel .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  position: relative;
  flex: 1;
  font-size: 17px;
  margin-right: 0;
  width: 104px;
  height: auto;
  text-align: center;
  overflow: hidden;
  padding: 12px 5px;
}

@font-face {
  font-family: iconfont;
  src: url("//at.alicdn.com/t/font_rmypakjwnxywrk9.eot");
  src: url("//at.alicdn.com/t/font_rmypakjwnxywrk9.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_rmypakjwnxywrk9.woff") format("woff"),
    url("//at.alicdn.com/t/font_rmypakjwnxywrk9.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_rmypakjwnxywrk9.svg#iconfont") format("svg");
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.innercontactfield:before {
  content: "\E602";
}

i.innercontactfield {
  background: none !important;
  top: 0 !important;
}

html.wf-cursor-move,
html.wf-cursor-move * {
  cursor: move !important;
}

.browsers-guide {
  position: absolute;
  left: 50%;
  width: 800px;
  margin-left: -400px;
  top: 100px;
  height: auto;
}

.browsers-guide .headline {
  font-family: PingHei, Lucida Grande, Lucida Sans Unicode, STHeitiSC, Helvetica,
    Arial, Verdana, "sans-serif";
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  cursor: default;
  color: #fff;
  text-align: center;
}

.browsers-guide .dock {
  margin-top: 60px;
  overflow: hidden;
}

.browsers-guide .browser {
  display: block;
  float: left;
  width: 200px;
  text-align: center;
}

.browsers-guide .browser img {
  border: none;
  width: 90px;
  height: 90px;
}

.browsers-guide .browser span {
  display: block;
  font-size: 14px;
  margin-top: 30px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.browsers-guide .browser:hover span {
  color: #ff4500;
}

#body.blur {
  -webkit-filter: blur(3px);
  filter: blur(3px);
}

#body .updateTip,
.wf-wrapper .updateTip {
  background: #fffada;
  color: #333;
  font-size: 13px;
  padding: 7px 20px;
  line-height: 1.2;
  z-index: 5;
  position: relative;
  margin-left: 325px;
  margin-right: 325px;
}

#body .updateTip a,
.wf-wrapper .updateTip a {
  color: #38adff;
}

#body .updateTip .right,
.wf-wrapper .updateTip .right {
  position: absolute;
  right: 20px;
  top: 8px;
}

.wf-wrapper .isv-warn-tip {
  background: #fffada;
  z-index: 5;
  position: relative;
  margin: 12px 325px 0;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.wf-wrapper .isv-warn-tip .isv-tip-icon {
  color: #faad14;
  margin-right: 8px;
}

.wf-header {
  height: 80px;
  width: 1200px;
  margin: 0 auto 20px;
  position: relative;
  z-index: 10;
}

.wf-header .head-title {
  position: absolute;
  top: 10px;
  left: 0;
  font-size: 18px;
  line-height: 37px;
}

.wf-header .head-title,
.wf-header .head-title a {
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wf-header .head-title a span {
  font-size: 24px;
  display: inline-block;
  margin: 0 10px;
}

.wf-header .head-title-font {
  font-size: 25px;
  color: #fff;
  padding: 0 10px;
}

.wf-header .navbar-single-logo {
  position: relative;
  top: 5px;
}

.wf-header .head-actions {
  position: absolute;
  right: 56px;
  line-height: 45px;
  height: 45px;
  top: 15px;
  padding: 0 5px;
  text-align: center;
  z-index: 100;
}

.wf-header .head-actions .select-main {
  width: 150px;
  height: 30px;
  line-height: 15px;
}

.wf-header .head-actions .select-main .select-options {
  width: 150px;
}

.wf-header .head-actions.disabled > .wf-button {
  background: #aaa !important;
  pointer-events: none;
}

.navbar-logo {
  height: 45px;
  vertical-align: -20px;
}

.navbar-head {
  left: 100%;
  top: 50%;
  margin-top: -12px;
  padding-left: 10px;
  line-height: 26px;
  height: 26px;
  position: absolute;
  border-left: 1px solid #ccc;
  color: #fff;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-right {
  margin-right: 5px;
}

.icon-left {
  margin-left: 5px;
}

.dir,
.select-main {
  position: relative;
}

.select-main {
  width: 100%;
  border-radius: 4px;
  display: inline-block;
  z-index: 1;
  cursor: pointer;
}

.select-main .anticon-caret-down {
  float: right;
}

.form-select .anticon {
  vertical-align: middle;
  color: #38adff;
  font-size: 20px;
  margin-left: 3px;
}

.form-select .anticon:hover {
  color: #3e8acc;
}

.select-main .icon-new-cancel {
  vertical-align: middle;
  font-size: 18px;
  color: #38adff;
  margin-left: 5px;
  margin-right: 5px;
}

.select-main .icon-new-cancel:hover {
  color: #f60;
}

.select-main .select-options {
  position: absolute;
  width: 230px;
  z-index: 1;
  box-shadow: 0 12px 12px 0 rgba(48, 113, 149, 0.2);
}

.select-main .select-option {
  background: #fff;
  color: #000;
  padding: 10px;
  cursor: pointer;
}

.select-main .select-option:hover {
  background: #f2f8fd;
}

.select-main .default-select {
  height: 32px;
  padding: 4px 11px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  outline: none;
  line-height: 1.5;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.select-main .default-select.empty {
  color: #bfbfbf;
}

.select-main .default-select.ant-select-focused,
.select-main .default-select:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.select-main .default-select.ant-select-focused {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.select-main .default-select.ant-select-disabled {
  pointer-events: none;
}

.has-error .select-main .default-select {
  border-color: #f5222d;
}

.has-error .select-main .default-select.ant-select-focused {
  border-color: #f5222d;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}

.select-main .select-main-icon {
  user-select: none;
}

.select-main .dir-select {
  background: #ebf7ff;
}

.select-main .add-select,
.select-main .form-select {
  text-align: center;
  color: #323334;
  background: #fff;
  padding: 10px 5px;
  border-top: 1px solid #d9d9d9;
  cursor: pointer;
}

.select-main .add-select:hover,
.select-main .form-select:hover {
  background: #f2f8fd;
}

.select-main .form-select:hover {
  background: #fff;
}

.select-main .form-select input {
  border: 1px solid #d9d9d9 !important;
  width: 170px !important;
  color: #323334 !important;
  padding: 3px 4px;
  outline: none;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut,
.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}

.fadeInDown {
  animation-name: fadeInDown;
}

.ant-modal-wrap .ant-modal-body {
  font-size: 12px;
}

@-moz-keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@-o-keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@-moz-keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@-webkit-keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@-o-keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.anticon.anticon-info-circle-o {
  cursor: pointer;
  font-size: 12px;
  color: rgba(25, 31, 37, 0.4);
}

.wf-formcanvas-bottom {
  position: absolute;
  bottom: 10px;
  left: 50%;
  width: 280px;
  margin-left: -140px;
  z-index: 1000;
}

.developer-set,
.switch-lang {
  text-align: center;
}

.switch-lang-select {
  position: relative;
}

.switch-lang-select-icon,
.switch-lang-select-value {
  cursor: pointer;
  margin-left: 5px;
  color: #1890ff;
}

.switch-lang-select-icon {
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.switch-lang-select-icon.active {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.switch-lang-popup {
  cursor: pointer;
  position: absolute;
  left: 0;
  margin-bottom: 8px;
  bottom: 100%;
  width: 152px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  text-align: left;
  z-index: 9999;
}

.switch-lang-item {
  position: relative;
  padding: 7px 10px 7px 36px;
}

.switch-lang-item:hover {
  background: #edf5fa;
}

.switch-lang-item .switch-lang-item-checked {
  position: absolute;
  font-size: 18px;
  line-height: 18px;
  margin-top: -9px;
  top: 50%;
  left: 10px;
  display: none;
  color: #1890ff;
}

.switch-lang-item.selected {
  color: #1890ff;
}

.switch-lang-item.selected .switch-lang-item-checked {
  display: block;
}

.disableForm {
  pointer-events: none;
  opacity: 0.43;
}

.process-type-switch {
  display: inline-block;
  position: fixed;
  right: 120px;
  bottom: 40px;
}

@keyframes slideInRight {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.quick-design-entry {
  cursor: pointer;
  position: fixed;
  display: flex;
  align-items: center;
  padding: 7px 10px;
  top: 68px;
  left: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 18px 18px 0;
}

.quick-design-entry .quick-design-arrow {
  margin-left: 7px;
  font-size: 18px;
  color: rgba(25, 31, 37, 0.56);
}

.quick-design-side-modal {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  width: 286px;
  z-index: 100;
  background: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  -webkit-animation: slideInRight 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  animation: slideInRight 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.quick-design-head {
  display: flex;
  align-items: center;
  position: relative;
  padding: 15px 12px;
}

.quick-design-head .quick-design-close {
  position: absolute;
  right: 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(25, 31, 37, 0.4);
  cursor: pointer;
}

.quick-design-body {
  padding: 10px 12px;
}

.quick-design-title-icon {
  display: inline-block;
  background: url(https://img.alicdn.com/tfs/TB1.iQoxOLaK1RjSZFxXXamPFXa-64-64.png)
    no-repeat 50%;
  background-size: 100%;
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

.quick-design-title {
  margin-left: 8px;
  font-size: 14px;
  color: #191f25;
}

.quick-design-item {
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 2px;
  border: 1px solid #e3e4e4;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.quick-design-item:hover {
  border: 1px solid #3296fa;
}

.quick-design-item-name {
  font-size: 14px;
  color: #191f25;
  line-height: 20px;
}

.quick-design-item-tip {
  font-size: 12px;
  color: rgba(25, 31, 37, 0.56);
}

.quick-design-item-tip.guide {
  color: #ff943e;
}

.quick-design-item-icon {
  flex: none;
  margin-right: 4px;
  width: 40px;
  height: 40px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
}

.quick-design-item-icon.line {
  background-image: url(https://img.alicdn.com/tfs/TB1jUTzw7voK1RjSZPfXXXPKFXa-140-140.png);
}

.quick-design-item-icon.branch,
.quick-design-item-icon.leave {
  background-image: url(https://img.alicdn.com/tfs/TB1ponzw7voK1RjSZFNXXcxMVXa-140-140.png);
}

.quick-design-item-icon.multiple {
  background-image: url(https://img.alicdn.com/tfs/TB16Y2xwVzqK1RjSZFvXXcB7VXa-140-140.png);
}

.zoom {
  display: flex;
  position: fixed;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 40px;
  width: 125px;
  right: 40px;
  margin-top: 30px;
  z-index: 10;
}

.zoom .zoom-in,
.zoom .zoom-out {
  width: 30px;
  height: 30px;
  background: #fff;
  color: #c1c1cd;
  cursor: pointer;
  background-size: 100%;
  background-repeat: no-repeat;
}

.zoom .zoom-out {
  background-image: url(https://gw.alicdn.com/tfs/TB1s0qhBHGYBuNjy0FoXXciBFXa-90-90.png);
}

.zoom .zoom-out.disabled {
  opacity: 0.5;
}

.zoom .zoom-in {
  background-image: url(https://gw.alicdn.com/tfs/TB1UIgJBTtYBeNjy1XdXXXXyVXa-90-90.png);
}

.zoom .zoom-in.disabled {
  opacity: 0.5;
}

.auto-judge:hover .editable-title,
.node-wrap-box:hover .editable-title {
  border-bottom: 1px dashed #fff;
}

.auto-judge:hover .editable-title.editing,
.node-wrap-box:hover .editable-title.editing {
  text-decoration: none;
  border: 1px solid #d9d9d9;
}

.auto-judge:hover .editable-title {
  border-color: #15bc83;
}

.editable-title {
  line-height: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px dashed transparent;
}

.editable-title:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 40px;
}

.editable-title:hover {
  border-bottom: 1px dashed #fff;
}

.editable-title-input {
  flex: none;
  height: 18px;
  padding-left: 4px;
  text-indent: 0;
  font-size: 12px;
  line-height: 18px;
  z-index: 1;
}

.editable-title-input:hover {
  text-decoration: none;
}

@keyframes slideInLeft {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.side-modal-mask {
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.28);
}

.side-modal,
.side-modal-mask {
  position: fixed;
  top: 0;
  z-index: 999;
}

.side-modal {
  right: 0;
  bottom: 0;
  width: 550px;
  background: #fff;
  -webkit-animation: slideInLeft 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  animation: slideInLeft 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.side-modal-header {
  font-size: 16px;
  height: 60px;
  line-height: 60px;
  padding: 0 24px;
  box-shadow: 0 1px 0 0 hsla(0, 0%, 85%, 0.5);
}

.side-modal-body {
  bottom: 60px;
  position: absolute;
  top: 57px;
  width: 100%;
  overflow: scroll;
}

.side-modal-body-content.form-setting {
  position: relative;
  top: -15px;
}

.side-modal-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 10;
  text-align: right;
  padding: 14px 24px;
  box-shadow: 0 -1px 0 0 hsla(0, 0%, 85%, 0.5);
}

.side-modal-footer .ant-btn {
  margin-left: 8px;
}

.common-group {
  padding: 15px 24px;
  border-bottom: 1px solid #ebebeb;
}

.common-group .group-title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #191f25;
  margin-bottom: 16px;
}

.common-group .group-title.no-title {
  margin-bottom: 0;
}

.common-group .group-line {
  margin-top: 20px;
  height: 1px;
  background: #ececec;
}

.area-auto-up {
  margin-top: 14px;
}

.area-auto-up-popover-img {
  width: 385px;
  height: 226px;
}

.labelMatchListPopover {
  width: 440px;
}

.labelMatchListPopover .ant-popover-title {
  padding-left: 0;
  padding-right: 0;
}

.labelMatchListPopover .ant-popover-inner-content {
  padding: 0;
}

.labelMatchListHeader {
  position: relative;
  padding: 6px 22px;
  padding-right: 32px;
  font-size: 16px;
}

.labelMatchListHeader .anticon {
  position: absolute;
  padding: 8px;
  top: 50%;
  right: 8px;
  margin-top: -15px;
  color: #999;
  cursor: pointer;
}

.labelMatchListContainer {
  height: 350px;
}

.labelListHead {
  background: #f6f6f6 !important;
  padding: 6px 22px !important;
}

.labelListHead .label-item-desc,
.labelListHead .label-item-name {
  color: #999 !important;
}

.labelListContainer {
  position: relative;
  padding-left: 8px;
  padding-right: 8px;
  height: 270px;
  overflow-y: auto;
}

.labelMatchListFooter {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 5px 22px;
  height: 50px;
  border-top: 1px solid #ededed;
  background: #fff;
  display: flex;
  align-items: center;
}

.labelMatchListFooter div {
  flex: 1;
  color: #9b9da0;
  font-size: 12px;
}

.labelMatchListFooter a {
  flex: none;
  min-width: 120px;
  text-align: right;
}

.label-list-item {
  position: relative;
  padding: 15px 14px;
  display: flex;
  align-items: center;
}

.label-list-item .hover {
  display: none;
  color: rgba(25, 31, 37, 0.56);
}

.label-list-item:hover {
  background: #f6f6f6;
}

.label-list-item:hover .hover {
  display: block;
}

.label-list-item + .label-list-item:after {
  content: "";
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  height: 0;
  border-top: 1px solid #ededed;
}

.label-list-item .label-item-avatar {
  flex: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 20px;
}

.label-list-item .label-item-name {
  flex: none;
  width: 100px;
  color: #191f25;
}

.label-list-item .label-item-desc {
  flex: 1;
  width: 100%;
  text-align: right;
  font-size: 12px;
  color: rgba(25, 31, 37, 0.56);
  cursor: default;
}

.label-list-none {
  padding-top: 45px;
  text-align: center;
}

.label-list-none img {
  width: 150px;
  height: 150px;
  margin-bottom: 5px;
}

.label-list-none p {
  font-size: 12px;
  padding: 2px 0;
  margin: 0;
}

.ant-tooltip {
  font-size: 12px !important;
}

.approver-type-wrapper .approver-actions {
  position: relative;
  padding: 5px 0 7px;
  display: inline-block;
}

.approver-type-wrapper .ant-radio-wrapper {
  font-size: 14px;
  line-height: 22px;
  width: 30%;
  color: #191f25;
  margin-bottom: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.approver-type-wrapper .date-tip {
  margin-left: 5px;
}

.approver-type-label-tip-content {
  padding: 15px 0;
}

.approver-type-label-tip-content img {
  width: 528px;
  height: 345px;
}

.approver-type-label-tip-content .approver-type-label-tip {
  text-align: center;
  margin-bottom: 0;
}

.panel-approver .right-action {
  margin-left: 10px;
}

.panel-approver .bottom-content {
  margin-top: 12px;
}

.panel-approver .text-desc {
  color: #999;
  margin-left: 15px;
  margin-top: 10px;
}

.panel-approver .originator-desc {
  font-size: 14px;
  color: rgba(25, 31, 37, 0.72);
}

.panel-approver .area-act-type-wrapper .ant-radio-wrapper,
.panel-approver .none-actioner-wrapper .ant-radio-wrapper {
  font-size: 14px;
  line-height: 22px;
  width: 100%;
  color: #191f25;
  margin-bottom: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.panel-approver .area-act-type-wrapper .radio-item,
.panel-approver .none-actioner-wrapper .radio-item {
  display: block;
}

.panel-approver .area-act-type-wrapper .text-tip-wrapper,
.panel-approver .none-actioner-wrapper .text-tip-wrapper {
  padding-left: 0;
}

.panel-approver .area-act-type-wrapper .area-act-type-popover-img,
.panel-approver .none-actioner-wrapper .area-act-type-popover-img {
  width: 400px;
  height: 374px;
}

.approver-list .approver-item {
  display: inline-block;
  white-space: nowrap;
  background: rgba(50, 150, 250, 0.1);
  border-radius: 4px;
  padding: 2px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
}

.approver-list .approver-item .name {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
}

.approver-list .approver-item .close {
  cursor: pointer;
  padding: 2px;
}

.ding-dot {
  display: block;
  background: #f25643;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.label-match-dot {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
}

.label-button-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  z-index: 1;
}

.ant-btn {
  position: relative;
}

.action-right-btn {
  margin-left: 10px;
}

.panel-field-settings .filed-setting-title .required {
  color: #f2725e;
  position: absolute;
  transform: translateY(10%);
  left: 15px;
}

.field-setting-label {
  padding-left: 24px !important;
}

.side-modal-form-setting-popover-content {
  padding: 10px;
}

.side-modal-form-setting-popover-content img {
  width: 427px;
  height: 311px;
}

.side-modal-form-setting-popover-content .date-tip {
  margin-left: 5px;
}

.priority-select {
  display: inline-block;
}

.editable-text-field {
  height: 60px;
}

.editable-text-field .editable-text-col {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.editable-text-field .editable-text-col .text-value-wrapper {
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.editable-text-field .editable-text-col .text-value-wrapper.disabled {
  cursor: text;
}

.editable-text-field .editable-text-col .text-value-wrapper .anticon {
  margin-left: 5px;
}

.editable-text-field .priority-text-wrapper {
  float: right;
}

.panel-task .common-group {
  padding-bottom: 0;
  border-bottom: none;
}

.panel-task-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.panel-task-item > div:nth-child(2) {
  margin-left: 10px;
}

.panel-notifier .common-group {
  padding-bottom: 0;
  border-bottom: none;
}

.node-wrap-box {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  width: 220px;
  min-height: 72px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.node-wrap-box:after {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.node-wrap-box.active:after,
.node-wrap-box:active:after,
.node-wrap-box:hover:after {
  border: 1px solid #3296fa;
  box-shadow: 0 0 6px 0 rgba(50, 150, 250, 0.3);
}

.node-wrap-box.active .close,
.node-wrap-box:active .close,
.node-wrap-box:hover .close {
  display: block;
}

.node-wrap-box.error:after {
  border: 1px solid #f25643;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.node-wrap-box .title {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 30px;
  width: 100%;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  text-align: left;
  background: #576a95;
  border-radius: 4px 4px 0 0;
}

.node-wrap-box .title .iconfont {
  font-size: 12px;
  margin-right: 5px;
}

.node-wrap-box .placeholder {
  color: #bfbfbf;
}

.node-wrap-box .close {
  display: none;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  font-size: 14px;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}

.node-wrap-box .content {
  position: relative;
  font-size: 14px;
  padding: 16px;
  padding-right: 30px;
}

.node-wrap-box .content .text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.node-wrap-box .content .arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 14px;
  font-size: 14px;
  color: #979797;
}

.start-node.node-wrap-box .content .text {
  display: block;
  white-space: nowrap;
}

.node-wrapper-box-new {
  padding: 12px 10px;
}

.node-wrapper-box-new .actions {
  margin-top: 11px;
  text-align: right;
}

.node-wrapper-box-new .ant-btn {
  margin-left: 8px;
}

.node-wrap-box:before {
  content: "";
  position: absolute;
  top: -12px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 0;
  height: 4px;
  border-style: solid;
  border-width: 8px 6px 4px;
  border-color: #cacaca transparent transparent;
  background: #f5f5f7;
}

.node-wrap-box.start-node:before {
  content: none;
}

.add-node-popover {
  min-height: 160px;
}

.add-node-popover-header {
  position: relative;
  margin-bottom: 15px;
}

.add-node-popover-close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
  color: rgba(0, 0, 0, 0.25);
}

.add-node-popover-body {
  display: flex;
}

.add-node-popover-item {
  margin-right: 10px;
  cursor: pointer;
  text-align: center;
  flex: 1;
  color: #191f25 !important;
}

.add-node-popover-item .item-wrapper {
  user-select: none;
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-bottom: 5px;
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.add-node-popover-item .iconfont {
  font-size: 35px;
  line-height: 80px;
}

.add-node-popover-item.approver .item-wrapper {
  color: #ff943e;
}

.add-node-popover-item.notifier .item-wrapper {
  color: #3296fa;
}

.add-node-popover-item.condition .item-wrapper {
  color: #15bc83;
}

.add-node-popover-item.auto .item-wrapper {
  color: #1059fb;
}

.add-node-popover-item:hover .item-wrapper {
  background: #3296fa;
  box-shadow: 0 10px 20px 0 rgba(50, 150, 250, 0.4);
}

.add-node-popover-item:hover .iconfont {
  color: #fff;
}

.add-node-popover-item:active .item-wrapper {
  box-shadow: none;
  background: #eaeaea;
}

.add-node-popover-item:active .iconfont {
  color: inherit;
}

.add-guide-mask {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.7;
  background: #fff;
  z-index: 999;
}

.copyed-add-btn {
  outline: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  width: 30px;
  height: 30px;
  background: #3296fa;
  border-radius: 50%;
  position: relative;
  border: none;
  line-height: 30px;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.copyed-add-btn .iconfont {
  color: #fff;
  font-size: 16px;
}

.copyed-add-btn:hover {
  transform: scale(1.3);
  box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
}

.copyed-add-btn:active {
  transform: none;
  background: #1e83e9;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.autofix-condition .action-button {
  color: #388ded;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  cursor: pointer;
  text-align: right;
}

.condition-group {
  padding: 0 16px;
  margin: 16px 0;
}

.condition-group .group-title {
  font-family: PingFangTC-Medium;
  text-align: left;
  font-size: 14px;
  color: #191f25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.condition-group .group-delete {
  text-align: center;
  cursor: pointer;
}

.condition-group .ant-checkbox-group {
  width: 100%;
}

.set-condition-between {
  margin: 0 5px;
}

.condition-origin-icon {
  display: flex;
  align-items: center;
}

.condition-origin-icon,
.condition-origin-icon > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.condition-checkbox {
  display: inline-block;
  margin: 4px 8px 0 0 !important;
}

.date-tip {
  color: #aaa;
  font-size: 13px;
  margin-left: 5px;
  cursor: pointer;
}

.set-condition-repeat {
  font-size: 12px;
  color: red;
  cursor: pointer;
  display: inline-block;
  margin-left: 5px;
}

.new-set-condition-value {
  display: flex;
  align-items: flex-start;
}

.new-set-condition-value .ant-checkbox-group-item {
  width: 30%;
  vertical-align: top;
}

.new-set-condition-value .ant-checkbox-group-item:nth-child(n + 4) {
  margin-top: 12px;
}

.set-repeat {
  padding: 0;
}

.set-repeat-title {
  font-size: 14px;
  padding-bottom: 5px;
}

.set-repeat-item {
  padding: 0;
}

.approval-setting-select {
  display: flex;
  align-items: flex-start;
}

.set-condition-content .common-row-title {
  padding-left: 30px;
}

.panel-condition p {
  margin-bottom: 5px;
}

.panel-condition .delete-action {
  display: none;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #3296fa;
  position: absolute;
  top: 15px;
  right: 25px;
}

.panel-condition .common-group {
  position: relative;
  cursor: pointer;
  border-bottom: none;
}

.panel-condition .common-group:last-of-type {
  border-bottom: 1px solid #ebebeb;
}

.panel-condition .common-group:hover {
  background: #f3f9ff;
}

.panel-condition .common-group:hover .delete-action {
  display: block;
}

.panel-condition .add-more-action {
  color: #3296fa;
  cursor: pointer;
  margin-top: 16px;
  font-size: 14px;
}

.panel-condition .condition-remain-tip {
  font-family: PingFangTC-Regular;
  font-size: 13px;
  color: rgba(25, 31, 37, 0.56);
}

.panel-condition .border-line {
  height: 1px;
  background: #ebebeb;
  -webkit-transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  overflow: hidden;
  margin-top: 24px;
}

.ant-input-number {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-variant: tabular-nums;
  box-sizing: border-box;
  list-style: none;
  position: relative;
  padding: 4px 11px;
  width: 100%;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  margin: 0;
  padding: 0;
  display: inline-block;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 90px;
}

.ant-input-number::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}

.ant-input-number:-ms-input-placeholder {
  color: #bfbfbf;
}

.ant-input-number::-webkit-input-placeholder {
  color: #bfbfbf;
}

.ant-input-number:focus {
  border-color: #40a9ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  border-right-width: 1px !important;
}

textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  min-height: 32px;
}

.ant-input-number-lg {
  padding: 6px 11px;
  height: 40px;
}

.ant-input-number-sm {
  padding: 1px 7px;
  height: 24px;
}

.ant-input-number-handler {
  text-align: center;
  line-height: 0;
  height: 50%;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.45);
  position: relative;
  transition: all 0.1s linear;
  display: block;
  width: 100%;
  font-weight: 700;
}

.ant-input-number-handler:active {
  background: #f4f4f4;
}

.ant-input-number-handler:hover .ant-input-number-handler-down-inner,
.ant-input-number-handler:hover .ant-input-number-handler-up-inner {
  color: #40a9ff;
}

.ant-input-number-handler-down-inner,
.ant-input-number-handler-up-inner {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 12px;
  user-select: none;
  position: absolute;
  width: 12px;
  height: 12px;
  transition: all 0.1s linear;
  display: inline-block;
  font-size: 12px;
  font-size: 7px\9;
  transform: scale(0.58333333) rotate(0deg);
  right: 4px;
  color: rgba(0, 0, 0, 0.45);
}

.ant-input-number-handler-down-inner:before,
.ant-input-number-handler-up-inner:before {
  display: block;
  font-family: anticon !important;
}

:root .ant-input-number-handler-down-inner,
:root .ant-input-number-handler-up-inner {
  font-size: 12px;
}

.ant-input-number-focused,
.ant-input-number:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

.ant-input-number-focused {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-input-number-disabled {
  background-color: #f5f5f5;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}

.ant-input-number-disabled:hover {
  border-color: #e6d8d8;
  border-right-width: 1px !important;
}

.ant-input-number-disabled .ant-input-number-input {
  cursor: not-allowed;
}

.ant-input-number-disabled .ant-input-number-handler-wrap {
  display: none;
}

.ant-input-number-input {
  width: 100%;
  text-align: left;
  outline: 0;
  -moz-appearance: textfield;
  height: 30px;
  transition: all 0.3s linear;
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  padding: 0 11px;
}

.ant-input-number-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}

.ant-input-number-input:-ms-input-placeholder {
  color: #bfbfbf;
}

.ant-input-number-input::-webkit-input-placeholder {
  color: #bfbfbf;
}

.ant-input-number-lg {
  padding: 0;
  font-size: 16px;
}

.ant-input-number-lg input {
  height: 38px;
}

.ant-input-number-sm {
  padding: 0;
}

.ant-input-number-sm input {
  height: 22px;
  padding: 0 7px;
}

.ant-input-number-handler-wrap {
  border-left: 1px solid #d9d9d9;
  width: 22px;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  border-radius: 0 4px 4px 0;
  transition: opacity 0.24s linear 0.1s;
}

.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}

.ant-input-number:hover .ant-input-number-handler-wrap {
  opacity: 1;
}

.ant-input-number-handler-up {
  cursor: pointer;
}

.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -6px;
}

.ant-input-number-handler-up-inner:before {
  text-align: center;
  content: "\E61E";
}

.ant-input-number-handler-up:hover {
  height: 60% !important;
}

.ant-input-number-handler-down {
  border-top: 1px solid #d9d9d9;
  top: -1px;
  cursor: pointer;
}

.ant-input-number-handler-down-inner {
  top: 50%;
  margin-top: -6px;
}

.ant-input-number-handler-down-inner:before {
  text-align: center;
  content: "\E61D";
}

.ant-input-number-handler-down:hover {
  height: 60% !important;
}

.ant-input-number-handler-down-disabled,
.ant-input-number-handler-up-disabled {
  cursor: not-allowed;
}

.ant-input-number-handler-down-disabled:hover
  .ant-input-number-handler-down-inner,
.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner {
  color: rgba(0, 0, 0, 0.25);
}

.condition-panel-range-set .range-between {
  margin: 8px 0 10px;
}

.condition-panel-range-set .range-between .range-group,
.condition-panel-range-set .range-between .range-group-label {
  display: inline-block;
  width: 40%;
}

.condition-panel-range-set .range-between .range-group-label {
  width: 20%;
  vertical-align: middle;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.condition-panel-range-set .range-between .range-between-number {
  width: 50%;
}

.condition-panel-range-set .range-between .range-between-select {
  width: 50%;
  padding: 0 6px;
}

.condition-panel-range-set .range-select-type {
  width: 50%;
  padding-right: 12px;
}

.condition-panel-range-set .range-select-type.between {
  width: 100%;
  padding-right: 0;
}

.select-condition-panel .condition-checkbox-invalid {
  margin-top: 20px;
}

.condition-tip {
  padding: 9px 16px;
  margin: 22px 25px 8px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
}

.condition-tip .tip {
  color: rgba(0, 0, 0, 0.65);
}

.condition-tip .i-know,
.condition-tip .tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
}

.condition-tip .i-know {
  color: #388ded;
  cursor: pointer;
  text-align: right;
}

.error-tip {
  padding: 9px 16px;
  margin: 22px 25px 8px;
  background: rgba(25, 31, 37, 0.02);
  border: 1px dashed rgba(25, 31, 37, 0.28);
  border-radius: 4px;
}

.error-tip .close-icon {
  font-size: 12px;
  position: absolute;
  left: -19px;
  top: 5px;
  color: #f25643;
}

.error-tip .content-wrapper {
  font-family: PingFangSC-Regular;
  font-size: 14px;
}

.error-tip .content-wrapper .content {
  color: rgba(25, 31, 37, 0.72);
}

.error-tip .content-wrapper .content strong {
  color: #191f25;
}

.top-left-cover-line {
  left: -1px;
}

.top-left-cover-line,
.top-right-cover-line {
  position: absolute;
  height: 3px;
  width: 50%;
  background-color: #f5f5f7;
  top: -2px;
}

.top-right-cover-line {
  right: -1px;
}

.bottom-left-cover-line {
  left: -1px;
}

.bottom-left-cover-line,
.bottom-right-cover-line {
  position: absolute;
  height: 3px;
  width: 50%;
  background-color: #f5f5f7;
  bottom: -2px;
}

.bottom-right-cover-line {
  right: -1px;
}

.panel-row {
  position: relative;
  margin-bottom: 10px;
}

.dingflow-design {
  width: 100%;
  background-color: #f5f5f7;
  overflow: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.dingflow-design .box-scale {
  transform: scale(1);
  display: inline-block;
  position: relative;
  width: 100%;
  padding: 54.5px 0;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-width: -webkit-min-content;
  min-width: -moz-min-content;
  min-width: min-content;
  background-color: #f5f5f7;
  -webkit-transform-origin: 0 0 0;
  transform-origin: 0 0 0;
}

.dingflow-design .ie-polyfill-container {
  display: -ms-grid;
  -ms-grid-columns: min-content;
}

.dingflow-design .add-node-btn-box {
  width: 240px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  position: relative;
}

.dingflow-design .add-node-btn-box:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  margin: auto;
  width: 2px;
  height: 100%;
  background-color: #cacaca;
}

.dingflow-design .node-wrap {
  flex-direction: column;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  padding: 0 50px;
  position: relative;
}

.dingflow-design .branch-wrap,
.dingflow-design .node-wrap {
  display: inline-flex;
  width: 100%;
}

.dingflow-design .branch-box-wrap {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 270px;
  width: 100%;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.dingflow-design .branch-box {
  display: flex;
  overflow: visible;
  min-height: 180px;
  height: auto;
  border-bottom: 2px solid #ccc;
  border-top: 2px solid #ccc;
  position: relative;
  margin-top: 15px;
}

.dingflow-design .branch-box .col-box {
  background: #f5f5f7;
}

.dingflow-design .branch-box .col-box:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  margin: auto;
  width: 2px;
  height: 100%;
  background-color: #cacaca;
}

.dingflow-design .add-branch {
  border: none;
  outline: none;
  user-select: none;
  justify-content: center;
  font-size: 12px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  color: #3296fa;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  transform-origin: center center;
  cursor: pointer;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.dingflow-design .add-branch:hover {
  transform: translateX(-50%) scale(1.1);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
}

.dingflow-design .add-branch:active {
  transform: translateX(-50%);
  box-shadow: none;
}

.dingflow-design .col-box {
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
}

.dingflow-design .condition-node {
  min-height: 220px;
}

.dingflow-design .condition-node,
.dingflow-design .condition-node-box {
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-flex: 1;
}

.dingflow-design .condition-node-box {
  padding-top: 30px;
  padding-right: 50px;
  padding-left: 50px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

.dingflow-design .condition-node-box:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 2px;
  height: 100%;
  background-color: #cacaca;
}

.dingflow-design .auto-judge {
  position: relative;
  width: 220px;
  min-height: 72px;
  background: #fff;
  border-radius: 4px;
  padding: 14px 19px;
  cursor: pointer;
}

.dingflow-design .auto-judge:after {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.dingflow-design .auto-judge.active:after,
.dingflow-design .auto-judge:active:after,
.dingflow-design .auto-judge:hover:after {
  border: 1px solid #3296fa;
  box-shadow: 0 0 6px 0 rgba(50, 150, 250, 0.3);
}

.dingflow-design .auto-judge.active .close,
.dingflow-design .auto-judge:active .close,
.dingflow-design .auto-judge:hover .close {
  display: block;
}

.dingflow-design .auto-judge.error:after {
  border: 1px solid #f25643;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.dingflow-design .auto-judge .title-wrapper {
  position: relative;
  font-size: 12px;
  color: #15bc83;
  text-align: left;
  line-height: 16px;
}

.dingflow-design .auto-judge .title-wrapper .editable-title {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dingflow-design .auto-judge .title-wrapper .priority-title {
  display: inline-block;
  float: right;
  margin-right: 10px;
  color: rgba(25, 31, 37, 0.56);
}

.dingflow-design .auto-judge .title-wrapper .priority-button {
  display: inline-block;
  height: 28px;
  float: right;
  margin-right: 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
}

.dingflow-design .auto-judge .title-wrapper .priority-button div {
  display: inline-block;
}

.dingflow-design .auto-judge .title-wrapper .priority-button .priority-content {
  padding: 0 8px;
  font-size: 12px;
  line-height: 28px;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}

.dingflow-design .auto-judge .placeholder {
  color: #bfbfbf;
}

.dingflow-design .auto-judge .close {
  display: none;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  z-index: 2;
}

.dingflow-design .auto-judge .content {
  font-size: 14px;
  color: #191f25;
  text-align: left;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.dingflow-design .auto-judge .sort-left,
.dingflow-design .auto-judge .sort-right {
  position: absolute;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 1;
}

.dingflow-design .auto-judge .sort-left {
  left: 0;
  border-right: 1px solid #f6f6f6;
}

.dingflow-design .auto-judge .sort-right {
  right: 0;
  border-left: 1px solid #f6f6f6;
}

.dingflow-design .auto-judge:hover .sort-left,
.dingflow-design .auto-judge:hover .sort-right {
  display: flex;
  align-items: center;
}

.dingflow-design .auto-judge .sort-left:hover,
.dingflow-design .auto-judge .sort-right:hover {
  background: #efefef;
}

.dingflow-design .add-node-btn {
  user-select: none;
  width: 240px;
  padding: 20px 0 32px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  flex-shrink: 0;
  -webkit-box-flex: 1;
  flex-grow: 1;
}

.dingflow-design .add-node-btn .btn {
  outline: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  width: 30px;
  height: 30px;
  background: #3296fa;
  border-radius: 50%;
  position: relative;
  border: none;
  line-height: 30px;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.dingflow-design .add-node-btn .btn .iconfont {
  color: #fff;
  font-size: 16px;
}

.dingflow-design .add-node-btn .btn:hover {
  transform: scale(1.3);
  box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
}

.dingflow-design .add-node-btn .btn:active {
  transform: none;
  background: #1e83e9;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.dingflow-design .end-node {
  border-radius: 50%;
  font-size: 14px;
  color: rgba(25, 31, 37, 0.4);
  text-align: left;
}

.dingflow-design .end-node .end-node-circle {
  width: 10px;
  height: 10px;
  margin: auto;
  border-radius: 50%;
  background: #dbdcdc;
}

.dingflow-design .end-node .end-node-text {
  margin-top: 5px;
  text-align: center;
}

.add-node-modal .ant-modal-body {
  padding: 0;
}

.add-node-modal .ant-tabs-content .ant-row {
  padding: 0 20px;
  margin-bottom: 20px;
}

.add-node-modal .ant-tabs-nav {
  width: 100%;
}

.add-node-modal .ant-tabs-nav .ant-tabs-tab {
  width: 50%;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding: 0;
  text-align: center;
  margin: 0;
  color: #a8a8a8;
}

.add-node-modal .ant-tabs-top .ant-tabs-ink-bar-animated {
  width: 50% !important;
}

.add-node-modal .ant-alert.ant-alert-no-icon {
  line-height: 48px;
  margin: 5px 0 20px;
  padding: 0;
  text-align: left;
  padding-left: 20px;
  font-size: 14px;
  color: #333;
  background: #fffada;
  border-color: #ede7c1;
}

.add-node-modal .ant-modal-close {
  top: -10px;
  right: -10px;
}

.add-node-modal .ant-modal-close-x {
  background: #fff;
  width: 25px;
  height: 25px;
  line-height: 26px;
  border-radius: 50%;
  color: #a8a8a8;
}

.add-node-modal {
  height: 100%;
  width: 607px;
  position: fixed;
  right: -617px;
  top: 0;
  bottom: 0;
  z-index: 9;
  overflow: auto;
  background: #fff;
  border: 1px solid #dedede;
  -webkit-box-shadow: -4px 0 11px 0 rgba(0, 0, 0, 0.14);
  box-shadow: -4px 0 11px 0 rgba(0, 0, 0, 0.14);
  -webkit-transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -o-transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.add-node-modal.show {
  right: 0;
}

.add-node-modal .title {
  font-size: 20px;
  color: #333;
  height: 30px;
  line-height: 30px;
  margin-top: 15px;
  padding: 0 33px;
}

.add-node-modal .anticon-close {
  float: right;
  line-height: 30px;
  color: #ced1d9;
  cursor: pointer;
}

.add-node-modal .ant-tabs-tab {
  color: #333;
}

.add-node-modal .handleAdd {
  padding: 0 33px;
}

.add-node-modal .handleAdd .ant-alert .ant-alert-warning .ant-alert-no-icon {
  width: 507px;
}

.add-node-modal .add-btn {
  width: 180px;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
}

.add-node-modal .add-btn-wrap {
  bottom: 0;
  background: #fff;
  padding: 10px 0;
  border-top: 1px solid #eee;
  text-align: center;
  margin-top: 50px;
}

.add-node-modal .add-btn-wrap .ant-btn {
  height: 34px;
  line-height: 34px;
}

.cancel-btn {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.add-node-button-menu {
  width: 120px !important;
  background: none !important;
  border-right: none !important;
}

.add-node-button-menu .ant-menu-item {
  padding-left: 6px !important;
  margin: 0 !important;
  color: #fff !important;
  height: 30px;
  line-height: 30px;
}

.add-node-button-menu .ant-menu-item .iconfont {
  padding-right: 6px;
}

.add-node-button-menu .ant-menu-item:hover {
  background: hsla(0, 0%, 100%, 0.1) !important;
}

.add-node-button-menu .ant-menu-item-selected {
  background: none !important;
}

.add-node-button-menu :after,
.add-node-button-menu :before {
  display: none !important;
}

.text-tip-wrapper {
  padding-left: 24px;
  color: #576a95;
  cursor: pointer;
}

.text-tip-wrapper .guide-text {
  font-size: 13px;
  margin-left: 5px;
}

.ant-layout {
  display: flex;
  flex-direction: column;
  flex: auto;
  background: #f0f2f5;
}

.ant-layout,
.ant-layout * {
  box-sizing: border-box;
}

.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}

.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: hidden;
}

.ant-layout-footer,
.ant-layout-header {
  flex: 0 0 auto;
}

.ant-layout-header {
  background: #001529;
  padding: 0 50px;
  height: 64px;
  line-height: 64px;
}

.ant-layout-footer {
  background: #f0f2f5;
  padding: 24px 50px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.ant-layout-content {
  flex: auto;
}

.ant-layout-sider {
  transition: all 0.2s;
  position: relative;
  background: #001529;
  min-width: 0;
}

.ant-layout-sider-children {
  height: 100%;
  padding-top: 0.1px;
  margin-top: -0.1px;
}

.ant-layout-sider-has-trigger {
  padding-bottom: 48px;
}

.ant-layout-sider-right {
  order: 1;
}

.ant-layout-sider-trigger {
  position: fixed;
  text-align: center;
  bottom: 0;
  cursor: pointer;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #002140;
  z-index: 1;
  transition: all 0.2s;
}

.ant-layout-sider-zero-width > * {
  overflow: hidden;
}

.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 64px;
  right: -36px;
  text-align: center;
  width: 36px;
  height: 42px;
  line-height: 42px;
  background: #001529;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ant-layout-sider-zero-width-trigger:hover {
  background: #192c3e;
}

.ant-layout-sider-light {
  background: #fff;
}

.ant-layout-sider-light .ant-layout-sider-trigger,
.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
}

.main-layout-content {
  position: relative;
  width: 1080px;
  min-height: 800px;
  margin: 20px auto;
  background: #fff;
  border-radius: 4px;
}

.stream-user-content-approval .approval-stream-card {
  min-width: 140px;
  padding-left: 16px;
  background: #f8f8f8;
  border-radius: 4px;
}

.stream-card-index {
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;
}

.approval-stream-card .avatar-name-horizontal {
  color: #333;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.approval-stream-card .avatar-container {
  overflow: hidden;
}

.approval-stream-card .stream-card-desc {
  color: #999;
  font-size: 12px;
  padding: 5px 0 5px 30px;
  text-align: left;
  display: block;
  clear: both;
  border-top: 1px solid #eaeaea;
}

.node-managers_labels .stream-card-desc {
  padding: 5px 0 5px 45px;
}

.approval-stream-card {
  position: relative;
}

.approval-stream-card .anticon-close {
  position: absolute;
  cursor: pointer;
  z-index: 100;
  right: 4px;
  display: none;
}

.approval-stream-card:hover .anticon-close {
  display: block;
}

.approval-stream-card .ant-avatar {
  width: 24px;
  height: 24px;
}

.approval-stream-card .avatar-container span {
  line-height: 40px;
}

.approval-stream-card .avatar-container .ant-avatar {
  margin-top: 8px;
}

.approval-stream-card .common-img {
  height: 24px;
  width: 24px;
  border-radius: 50%;
}

.approval-stream-card .gradually-img {
  width: 34px;
  height: 25px;
}

.approval-stream-card .node-avatar {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 12px;
  color: #333;
  padding-right: 16px;
}

.approval-stream-card .node-avatar span {
  vertical-align: top;
  line-height: 24px;
  margin-left: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}

.approval-stream-card .node-avatar .choosen-person {
  color: #333;
  margin-left: 4px;
}

.gray-words {
  color: #9f9f9f;
}

.stream-line-type {
  line-height: 120px;
}

.stream-user-content {
  margin: 8px 0;
}

.lastCartClass {
  height: 87px;
}

.stream-user-content-notifier {
  margin-top: 30px;
}

.stream-user-content-approval {
  float: left;
  height: 80px;
}

.approval-sorted .approval-stream-card {
  transition: all 0.2s;
  cursor: move;
}

.approval-sorted .approval-stream-card:hover {
  background: #edf5fa;
}

.stream-user {
  display: inline-block;
  position: relative;
}

.stream-user .stream-user-close {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  display: none;
  cursor: pointer;
}

.stream-user:hover .stream-user-close {
  display: inline-block;
}

.sortable-chosen .anticon-arrow-right {
  visibility: hidden;
}

.stream-user-content-approval .anticon-arrow-right {
  color: #eaeaea;
  font-size: 20px;
  line-height: 40px;
  width: 27px;
  vertical-align: top;
}

.plus i {
  cursor: pointer;
  font-size: 24px;
  color: #999;
}

.plus i:hover {
  color: #38adff;
}

.ghost {
  opacity: 0;
}

.steamLine-arrow-right {
  vertical-align: top;
}

.approval-stream-main {
  display: flex;
  align-items: stretch;
}

.approval-stream-title {
  color: #999;
  font-size: 12px;
  text-align: right;
  padding: 10px;
}

.approval-stream-container {
  background: #fff;
}

.stream-user-content {
  height: 120px;
}

.common-row {
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;
}

.common-row-title {
  font-size: 12px;
  color: #999;
}

.newTips {
  position: relative;
}

.newTips:after {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 2px;
  border-radius: 50%;
  background: red;
}

.step-box {
  background: #f8f8f8;
  border-radius: 2px 2px 2px 0 2px;
  text-align: center;
  color: #666;
  width: 50px;
  height: 50px;
  padding-top: 6px;
  font-size: 12px;
  position: absolute;
  left: -60px;
  top: 0;
}

.step-box .num {
  font-size: 16px;
}

.step-box:before {
  border-right: 25px solid transparent;
  left: 0;
}

.step-box:after,
.step-box:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 5px solid #fff;
  bottom: 0;
}

.step-box:after {
  border-left: 25px solid transparent;
  right: 0;
}

.approval-setting {
  border-radius: 2px;
  margin: 20px 0;
  position: relative;
  background: #fff;
}

.approval-setting .approval-setting-header {
  padding-left: 24px;
  background: #f8f8f8;
  position: relative;
}

.approval-setting-header .conditionOperate {
  float: right;
  font-size: 12px;
}

.approval-setting-header .conditionlabel {
  color: #333;
  max-width: 568px;
  display: inline-block;
  line-height: 18px;
  vertical-align: middle;
  position: relative;
}

.approval-setting-header .condition-label-block {
  display: inline;
  line-height: 25px;
  vertical-align: middle;
}

.approval-setting-header .conditionOperateAbate {
  position: absolute;
  right: 10px;
  top: 0;
  height: 50px;
  z-index: 2;
  line-height: 18px;
}

.approval-setting-header .condiiton-operate-hide {
  display: none;
}

.approval-setting:hover .approval-setting-header .condiiton-operate-hide {
  display: inline-block;
}

.approval-setting-header .conditionOperate {
  position: absolute;
  right: 10px;
  top: 0;
  height: 50px;
  z-index: 2;
  line-height: 18px;
}

.approval-setting-header a {
  margin-right: 10px;
}

.approval-setting .common-row {
  margin: 10px 0 10px 24px;
}

.approval-setting .approval-setting-cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: hsla(0, 0%, 98%, 0.7);
  z-index: 1;
  border: 1px solid #ebebeb;
}

.approval-setting .approval-setting-edit {
  border: 1px solid #ebebeb;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s;
}

.approval-setting .approval-setting-edit:hover {
  border: 1px solid rgba(56, 173, 255, 0.4);
}

.approval-tip {
  background: #666;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  padding: 0 5px;
  margin-right: 10px;
  float: left;
  height: 20px;
  line-height: 20px;
  margin-top: 15px;
}

.conditionOperate img {
  vertical-align: middle;
  width: 16px;
  margin-top: -4px;
}

.normal-btn {
  color: #49a9ee;
  border-color: #49a9ee;
}

.normal-btn:hover {
  color: #108ee9;
  border-color: #108ee9;
}

.ant-switch {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 22px;
  min-width: 44px;
  line-height: 20px;
  vertical-align: middle;
  border-radius: 100px;
  border: 1px solid transparent;
  background-color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.36s;
  user-select: none;
}

.ant-switch-inner {
  color: #fff;
  font-size: 12px;
  margin-left: 24px;
  margin-right: 6px;
  display: block;
}

.ant-switch:after,
.ant-switch:before {
  position: absolute;
  width: 18px;
  height: 18px;
  left: 1px;
  top: 1px;
  border-radius: 18px;
  background-color: #fff;
  content: " ";
  cursor: pointer;
  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.ant-switch:after {
  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
}

.ant-switch:active:after,
.ant-switch:active:before {
  width: 24px;
}

.ant-switch:before {
  content: "\E64D";
  font-family: anticon;
  animation: loadingCircle 1s infinite linear;
  text-align: center;
  background: transparent;
  z-index: 1;
  display: none;
  font-size: 12px;
}

.ant-switch-loading:before {
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
}

.ant-switch-checked.ant-switch-loading:before {
  color: #1890ff;
}

.ant-switch:focus {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: 0;
}

.ant-switch:focus:hover {
  box-shadow: none;
}

.ant-switch-small {
  height: 16px;
  min-width: 28px;
  line-height: 14px;
}

.ant-switch-small .ant-switch-inner {
  margin-left: 18px;
  margin-right: 3px;
  font-size: 12px;
}

.ant-switch-small:after,
.ant-switch-small:before {
  width: 12px;
  height: 12px;
}

.ant-switch-small:active:after,
.ant-switch-small:active:before {
  width: 16px;
}

.ant-switch-small.ant-switch-checked:before {
  left: 100%;
  margin-left: -13px;
}

.ant-switch-small.ant-switch-checked .ant-switch-inner {
  margin-left: 3px;
  margin-right: 18px;
}

.ant-switch-small.ant-switch-loading:before {
  animation: AntSwitchSmallLoadingCircle 1s infinite linear;
  font-weight: 700;
}

.ant-switch-checked {
  background-color: #1890ff;
}

.ant-switch-checked .ant-switch-inner {
  margin-left: 6px;
  margin-right: 24px;
}

.ant-switch-checked:before {
  left: 100%;
  margin-left: -19px;
}

.ant-switch-checked:after {
  left: 100%;
  transform: translateX(-100%);
  margin-left: -1px;
}

.ant-switch-disabled,
.ant-switch-loading {
  pointer-events: none;
  opacity: 0.4;
}

@keyframes AntSwitchSmallLoadingCircle {
  0% {
    transform-origin: 50% 50%;
    transform: rotate(0deg) scale(0.66667);
  }
  to {
    transform-origin: 50% 50%;
    transform: rotate(1turn) scale(0.66667);
  }
}

.slideFormBtn button {
  margin-right: 15px;
}

.labelMatchListPopover {
  width: 440px;
}

.labelMatchListPopover .ant-popover-title {
  padding-left: 0;
  padding-right: 0;
}

.labelMatchListPopover .ant-popover-inner-content {
  padding: 0;
}

.labelMatchListHeader {
  position: relative;
  padding: 6px 22px;
  padding-right: 32px;
  font-size: 16px;
}

.labelMatchListHeader .anticon {
  position: absolute;
  padding: 8px;
  top: 50%;
  right: 8px;
  margin-top: -15px;
  color: #999;
  cursor: pointer;
}

.labelMatchListContainer {
  height: 350px;
}

.labelListHead {
  background: #f6f6f6 !important;
  padding: 6px 22px !important;
}

.labelListHead .label-item-desc,
.labelListHead .label-item-name {
  color: #999 !important;
}

.labelListContainer {
  position: relative;
  padding-left: 8px;
  padding-right: 8px;
  height: 270px;
  overflow-y: auto;
}

.labelMatchListFooter {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 5px 22px;
  height: 50px;
  border-top: 1px solid #ededed;
  background: #fff;
  display: flex;
  align-items: center;
}

.labelMatchListFooter div {
  flex: 1;
  color: #9b9da0;
  font-size: 12px;
}

.labelMatchListFooter a {
  flex: none;
  min-width: 120px;
  text-align: right;
}

.label-list-item {
  position: relative;
  padding: 15px 14px;
  display: flex;
  align-items: center;
}

.label-list-item .hover {
  display: none;
  color: rgba(25, 31, 37, 0.56);
}

.label-list-item:hover {
  background: #f6f6f6;
}

.label-list-item:hover .hover {
  display: block;
}

.label-list-item + .label-list-item:after {
  content: "";
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  height: 0;
  border-top: 1px solid #ededed;
}

.label-list-item .label-item-avatar {
  flex: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 20px;
}

.label-list-item .label-item-name {
  flex: none;
  width: 100px;
  color: #191f25;
}

.label-list-item .label-item-desc {
  flex: 1;
  width: 100%;
  text-align: right;
  font-size: 12px;
  color: rgba(25, 31, 37, 0.56);
  cursor: default;
}

.label-list-none {
  padding-top: 45px;
  text-align: center;
}

.label-list-none img {
  width: 150px;
  height: 150px;
  margin-bottom: 5px;
}

.label-list-none p {
  font-size: 12px;
  padding: 2px 0;
  margin: 0;
}

.ant-tooltip {
  font-size: 12px !important;
}

.ding-dot {
  display: block;
  background: #f25643;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.label-match-dot {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
}

.label-button-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  z-index: 1;
}

.ant-btn {
  position: relative;
}

.sbys-detail-form {
  margin-left: 25px;
}

.sbys-detail-form div,
.sbys-detail-form input {
  color: #333;
}

.sbys-detail-form .ant-form-extra {
  color: #ccc;
}

.sbys-detail-form .ant-form-item-label {
  text-align: left;
}

.sbys-detail-form .ant-form-item-label label {
  font-size: 12px;
  color: #999;
}

.approval-end-line {
  line-height: 50px;
}

.choosen-span {
  max-width: 190px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.chargeBox {
  margin-left: 124px;
}

.approval-charge-content .choose-end {
  color: #38adff;
  cursor: pointer;
  display: inline-block;
}

.approval-charge-content .approval-radio {
  display: block;
}

.approval-node-setting {
  position: fixed;
  right: -800px;
  top: 0;
  bottom: 0;
  width: 800px;
  background: #fff;
  box-shadow: -3px 0 3px #dedede;
  transition: all 0.3s ease-in-out;
  z-index: 100;
}

.approval-node-setting .common-row {
  margin-left: 30px;
}

.approval-node-setting .common-row-title {
  position: relative;
  text-align: right;
  padding-right: 40px;
}

.approval-node-setting .common-row-title .anticon-info-circle {
  position: absolute;
  right: 20px;
  top: 2px;
}

.approval-node-setting.show {
  transform: translateX(-800px);
  -webkit-transform: translateX(-800px);
  -ms-transform: translateX(-800px);
}

.node-setting-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 35px;
  height: 62px;
  padding: 12px 30px;
  border-bottom: 1px solid #dedede;
}

.node-setting-form {
  padding-top: 16px;
}

button.node-delBtn {
  color: #f21;
  border: 1px solid #f21;
}

button.node-delBtn:hover {
  color: #f44;
  border: 1px solid #f44;
}

.approval-node-setting .slideFormBtn {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-top: 1px solid #ebebeb;
  text-align: center;
}

.approval-node-setting .approval-radio {
  height: 30px;
}

.node-setting-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  opacity: 0.4;
  background: #fff;
}

.approval-charge-content .approval-radio,
.charge-end-label {
  line-height: 40px;
  height: 40px;
}

.charge-end-label {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  color: #333;
  margin-right: 10px;
  background: #f8f8f8;
  border-radius: 4px;
  padding: 0 20px 0 10px;
  cursor: pointer;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 0 16px;
  padding-right: 24px;
  width: 140px;
}

.charge-end-label img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}

.choosen-span {
  max-width: 190px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
}

.charge-end-label .close {
  position: absolute;
  right: 3px;
  top: 3px;
  font-size: 14px;
  color: #a7a3a3;
  display: none;
}

.charge-end-label:hover .close {
  display: block;
}

.overlimit-tip {
  margin-left: 20px;
}

.notifier-chunk {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
  margin-right: 10px;
  height: 40px;
  line-height: 40px;
  background: #f8f8f8;
  border-radius: 4px;
  padding: 0 20px 0 10px;
  cursor: pointer;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 0 16px;
  padding-right: 24px;
  float: left;
  width: 140px;
  transition: all 0.2s;
}

.notifier-chunk:hover {
  background: #edf5fa;
}

.notifier-chunk span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 75%;
}

.notifier-chunk:hover .close {
  display: inline-block;
}

.notifier-chunk .close {
  position: absolute;
  right: 3px;
  top: 3px;
  font-size: 14px;
  color: #a7a3a3;
  display: none;
}

.notifier-chunk img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}

.notifier-chunk.empty-label {
  border: 1px solid #f25643;
}

.choosen-notifier-num {
  display: inline-block;
  color: #999;
  font-size: 12px;
  float: left;
  line-height: 40px;
  margin-left: 6px;
}

.edit-condition-depts {
  color: #323334;
  font-size: 12px;
  margin-top: 5px;
}

.depth-tips {
  width: 500px;
}

.canedit-content .common-row-title {
  padding-left: 30px;
}

.guideOpen {
  overflow: hidden;
}

.guide-mask,
.guide-panel {
  width: 1080px;
  position: fixed;
  top: 82px;
  bottom: 0;
  left: auto;
  right: auto;
}

.guide-mask {
  opacity: 0.95;
  background: #fff;
  z-index: 2000;
}

.guide-subtitle {
  font-size: 12px;
  font-weight: 700;
  color: #191f25;
}

.guide-panel {
  color: #191f25;
  z-index: 2010;
}

.guide-panel .guide-panel-body,
.guide-panel .guide-panel-footer,
.guide-panel .guide-panel-header {
  position: absolute;
  left: 0;
  right: 0;
}

.guide-panel .guide-panel-header {
  top: 0;
  text-align: center;
  height: 57px;
  line-height: 57px;
  font-size: 14px;
  font-weight: 700;
  border-bottom: 1px solid #e3e3e4;
}

.guide-panel .guide-panel-body {
  top: 57px;
  bottom: 57px;
  overflow: auto;
}

.guide-panel .guide-panel-footer {
  height: 57px;
  bottom: 0;
  border-top: 1px solid #e3e3e4;
  text-align: center;
}

.guide-panel .guide-panel-footer .ant-btn {
  min-width: 76px;
  margin: 15px 10px;
}

.guide-panel-left,
.guide-panel-right {
  position: relative;
  width: 50%;
  min-height: 100%;
  float: left;
  padding: 20px 50px;
}

.guide-panel-right .guide-panel-right-arrow {
  position: absolute;
  left: -4px;
  width: 10px;
  height: 10px;
  background: #fff;
  border-right: 1px solid #e3e3e4;
  border-top: 1px solid #e3e3e4;
  transform: rotate(45deg);
}

.guide-panel-right:before {
  content: "";
  position: absolute;
  width: 0;
  left: 0;
  top: 20px;
  bottom: 20px;
  border-left: 1px solid #e3e3e4;
  box-shadow: 4px 0 10px 0 rgba(0, 0, 0, 0.34);
}

.guide-avatar-container {
  position: relative;
}

.guide-avatar {
  display: inline-block;
  width: 53px;
  height: 53px;
  background: url(https://img.alicdn.com/tfs/TB1RPjen1uSBuNjy1XcXXcYjFXa-106-106.png)
    no-repeat 50%;
  background-size: 100%;
}

.guide-checkgroup {
  margin-left: 23px;
  padding: 20px 10px 20px 20px;
  background: #f6f6f6;
}

.guide-checkgroup .ant-checkbox-group {
  margin-top: 10px;
}

.guide-type-img {
  width: 436px;
}

.guide-panel-invalid {
  padding: 20px 0;
}

.guide-panel-invalid-row {
  width: 605px;
  margin: 0 auto;
}

.guide-panel-invalid-head {
  margin-bottom: 20px;
  position: relative;
}

.guide-panel-invalid-head .guide-avatar {
  position: absolute;
  right: 100%;
  margin-right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.guide-panel-invalid-body {
  margin-bottom: 40px;
}

.guide-panel-invalid-body img {
  display: block;
  width: 605px;
  height: 415px;
}

.guide-tip {
  position: relative;
  white-space: nowrap;
  display: inline-block;
  padding: 6px 10px;
  color: #fff;
  font-size: 14px;
  background: #3296fa;
  border-radius: 3px;
}

.guide-tip:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 4px solid transparent;
}

.guide-tip.left:before {
  top: 50%;
  margin-top: -4px;
  left: -8px;
  border-color: transparent #3296fa transparent transparent;
}

.guide-tip.right:before {
  top: 50%;
  margin-top: -4px;
  right: -8px;
  border-color: transparent transparent transparent #3296fa;
}

.focus-area,
.focus-mask {
  position: absolute;
  z-index: 2000;
}

.focus-mask {
  opacity: 0.85;
  background: #fff;
}

.focus-mask.top {
  top: 0;
  left: 0;
}

.focus-mask.right {
  top: 0;
  right: 0;
}

.focus-mask.bottom {
  bottom: 0;
  right: 0;
}

.focus-mask.left {
  left: 0;
  bottom: 0;
}

.focus-area {
  background: transparent;
  pointer-events: none;
  border: 2px solid #3296fa;
  box-shadow: 0 1px 16px 0 rgba(50, 150, 250, 0.55),
    inset 0 0 10px 0 rgba(50, 150, 250, 0.55);
  border-radius: 6px;
}

.focus-area-mark {
  position: absolute;
  left: 100%;
  top: -50%;
}

.focus-mask-footer {
  position: fixed;
  width: 1080px;
  left: auto;
  right: auto;
  bottom: 0;
  height: 57px;
  border-top: 1px solid #e3e3e4;
  text-align: center;
  z-index: 2010;
  background: hsla(0, 0%, 100%, 0.7);
}

.focus-mask-footer .ant-btn {
  min-width: 76px;
  margin: 15px 10px;
}

.quick-guide-container {
  position: fixed;
  top: 30%;
  right: 20px;
  z-index: 99;
}

.quick-guide-container .quick-guide-img {
  cursor: pointer;
  width: 198px;
  height: 135px;
  background: url(https://img.alicdn.com/tfs/TB1HbOEseuSBuNjy1XcXXcYjFXa-396-270.png)
    no-repeat 50%;
  background-size: 100%;
}

.quick-guide-container .quick-guide-close {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 18px;
  height: 18px;
  background: url(https://img.alicdn.com/tfs/TB1sI.dnKuSBuNjSsplXXbe8pXa-14-14.png)
    no-repeat 50%;
  background-size: 7px;
}

.approval-page-container {
  padding: 20px 60px;
  position: relative;
}

.plus-icon {
  cursor: pointer;
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-top: 7px;
  border: 1px solid #999;
  border-radius: 50%;
  position: relative;
}

.plus-icon:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 1px;
  height: 11px;
  top: 5px;
  left: 11px;
  background-color: #999;
}

.plus-icon:hover {
  border: 1px solid #38adff;
}

.plus-icon:hover:after,
.plus-icon:hover:before {
  background-color: #38adff;
}

.plus-icon:before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 11px;
  height: 1px;
  top: 10px;
  left: 6px;
  background-color: #999;
}

.cut-line {
  margin: 10px 0 10px 12.5%;
}

.cut-line,
.cut-line-small {
  border-bottom: 1px solid #ebebeb;
}

.cut-line-small {
  margin: 10px 25px 10px 20%;
}

.cut-line-large {
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 20px;
  clear: both;
}

.main-save {
  border-radius: 4px;
  font-size: 14px;
  height: 32px;
  width: 90px;
}

.approval-page-footer {
  margin-left: 150px;
  padding-bottom: 20px;
}

.approval-page-footer .main-save {
  margin-left: 50px;
}

.global-error {
  width: 400px;
  margin: 0 auto;
  position: fixed;
  top: 138px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.approval-spin {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background: hsla(0, 0%, 100%, 0.5);
  padding-top: 200px;
}

.input-margin {
  margin: 0 5px;
}

.common-tips {
  font-size: 12px;
  color: #333;
  margin-left: 5px;
}

.approval-setting-preview {
  padding: 10px;
  padding-top: 0;
}

.approval-setting-preview .preview-tips {
  text-align: center;
  font-size: 14px;
  color: #333;
}

.approval-setting-preview canvas {
  margin-top: 10px;
}

.more-setting-content .common-row-title {
  padding-left: 30px;
}

.process-check-btn {
  width: auto;
  height: 34px;
}

.approval-page-baseTip {
  font-size: 12px;
  color: #aaa;
}

.set-condition-between {
  margin: 0 5px;
}

.condition-origin-icon {
  display: flex;
  align-items: center;
}

.condition-origin-icon,
.condition-origin-icon > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.condition-delete {
  display: none;
  position: absolute;
  right: 0;
}

.choosen-rules-hoverDel:hover .condition-delete {
  display: block;
}

.condition-checkbox-content {
  padding: 16px 4px 16px 16px;
}

.condition-checkbox-content p {
  margin-bottom: 5px;
}

.condition-checkbox-content .condition-checkbox-invalid {
  margin-top: 20px;
}

.condition-checkbox {
  display: inline-block;
  margin: 4px 8px 0 0 !important;
}

.date-tip {
  color: #aaa;
  font-size: 13px;
  margin-left: 5px;
  cursor: pointer;
}

.date-tip-red,
.set-condition-repeat {
  color: red;
  font-size: 12px;
  margin-left: 5px;
}

.set-condition-repeat {
  cursor: pointer;
  display: inline-block;
}

.set-condition-value {
  display: flex;
  align-items: flex-start;
}

.set-repeat {
  padding: 0;
}

.set-repeat-title {
  font-size: 14px;
  padding-bottom: 5px;
}

.set-repeat-item {
  padding: 0;
}

.approval-setting-select {
  display: flex;
  align-items: flex-start;
}

.set-condition-content .common-row-title {
  padding-left: 30px;
}
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Flowable/nodeWrap.vue"
}
</vue-filename-injector>
